/**
 * A function to create a log object for the 'appSetOpened' event (evid: 100)
 *
 * Event description: Opened app settings
 *
 * @param {appSetOpenedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - classic/strip/compact
 * @property {boolean} isFirst - first time open the app settings
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - editorMode
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {number} loading_time - loading time
 * @return {LogObject<appSetOpenedParams>} LogObject<appSetOpenedParams>
 */
export function appSetOpened(params) {
    return { evid: 100, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetPayPalState' event (evid: 101)
 *
 * Event description: PayPal state display  in app settings
 *
 * @param {appSetPayPalStateParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetPayPalStateParams>} LogObject<appSetPayPalStateParams>
 */
export function appSetPayPalState(params) {
    return { evid: 101, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boGeneralPayPalState' event (evid: 102)
 *
 * Event description: PayPal state display  in bo
 *
 * @param {boGeneralPayPalStateParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - ADI / editor / МА
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boGeneralPayPalStateParams>} LogObject<boGeneralPayPalStateParams>
 */
export function boGeneralPayPalState(params) {
    return { evid: 102, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boClosePopupCancelUploadClicked' event (evid: 103)
 *
 * Event description: Clicking in the back office close  while uploading popup  on button
 * 'Go back'  or 'Cancel Uploads'
 *
 * @param {boClosePopupCancelUploadClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {string} button - Go back/Cancel Uploads
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boClosePopupCancelUploadClickedParams>} LogObject<boClosePopupCancelUploadClickedParams>
 */
export function boClosePopupCancelUploadClicked(params) {
    return { evid: 103, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boClosePopupUpgradedChannelClicked' event (evid: 104)
 *
 * Event description: Clicking in the back office close
 * while editing channel without saving changes popup
 * on button 'No, Thanks'  or 'Yes Cancel Changes'
 *
 * @param {boClosePopupUpgradedChannelClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {string} button - No, Thanks/Yes Cancel Changes
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boClosePopupUpgradedChannelClickedParams>} LogObject<boClosePopupUpgradedChannelClickedParams>
 */
export function boClosePopupUpgradedChannelClicked(params) {
    return { evid: 104, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boUploadTotalComplete' event (evid: 105)
 *
 * Event description: Sent when upload (single file of multiple files) is totally finished, meaning all files were proceeded (successfully uploaded or failed). It includes only Drag&drop and upload by clicking on a button for videos library and wellcome screens
 *
 * @param {boUploadTotalCompleteParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} source - upload/drive/dropbox
 * @property {number} batchSize - amount of files
 * @property {number} numberOfSuccessfulUploads - How many filed were successfully uploaded
 * @property {number} manual_resumed - count how many times (in current correlation_id) upload was resumed automatically
 * @property {boolean} isFirst - first time uploading
 * @property {GUID} _appId - app_id
 * @property {boolean} isSuccess - whether ALL videos were successfully uploaded
 * @property {string} user_agent - user_agent
 * @property {string} fileType - image / video / audio / doc / folder
 * @property {string} button - drag&drop /upload
 * @property {boolean} batch - true/false (several files in one import)
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {number} loadingTime - loading_time
 * @property {number} fileSize - file size in KB
 * @property {number} numberOfFailedUploads - How many files failed to upload
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {string} correlationId - id to find one upload process (same as 71:52)
 * @property {boolean} is_resumable - is download resume available for this file
 * @property {GUID} _visitorId - visitor_id
 * @property {number} auto_resumed - count how many times (in current correlation_id) upload was resumed manually
 * @property {string} fileFormat - file extension
 * @return {LogObject<boUploadTotalCompleteParams>} LogObject<boUploadTotalCompleteParams>
 */
export function boUploadTotalComplete(params) {
    return { evid: 105, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boUploadAttempted' event (evid: 106)
 *
 * Event description: User attempted to upload one or few files. For few files, will be sent once. It includes only Drag&drop and upload by clicking on a button for videos library and wellcome screens
 *
 * @param {boUploadAttemptedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} source - upload/drive/dropbox
 * @property {boolean} isFirst - first time uploading
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {string} button - drag-n-drop/upload
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} tracksUploaded - how meay files are send to upload
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boUploadAttemptedParams>} LogObject<boUploadAttemptedParams>
 */
export function boUploadAttempted(params) {
    return { evid: 106, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boUploadAddVideosClicked' event (evid: 107)
 *
 * Event description: Sent when user clicks add videos button
 *
 * @param {boUploadAddVideosClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - ADI / editor / МА
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boUploadAddVideosClickedParams>} LogObject<boUploadAddVideosClickedParams>
 */
export function boUploadAddVideosClicked(params) {
    return { evid: 107, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boUploadAddVideosHovered' event (evid: 108)
 *
 * Event description: Sent when user hovers add videos button
 *
 * @param {boUploadAddVideosHoveredParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - ADI / editor / МА
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boUploadAddVideosHoveredParams>} LogObject<boUploadAddVideosHoveredParams>
 */
export function boUploadAddVideosHovered(params) {
    return { evid: 108, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boUploadAddVideosVideoSourceClicked' event (evid: 109)
 *
 * Event description: Sent when user chooses the video source (computer,youtube,vimeo etc.)
 *
 * @param {boUploadAddVideosVideoSourceClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} source - computer/youtube/vimeo/drive/dropbox/facebook/live
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - first_video/add_videos_menu
 * @property {string} compId - player_id
 * @property {string} type - upload/embed
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boUploadAddVideosVideoSourceClickedParams>} LogObject<boUploadAddVideosVideoSourceClickedParams>
 */
export function boUploadAddVideosVideoSourceClicked(params) {
    return { evid: 109, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetSettingsChannelOptionsShowCategoriesChanged' event (evid: 11)
 *
 * Event description: Choosing to show categories or not
 *
 * @param {appSetSettingsChannelOptionsShowCategoriesChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - classic / grid / slider / strip
 * @property {boolean} isCategories - Choosing to show categories or not
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetSettingsChannelOptionsShowCategoriesChangedParams>} LogObject<appSetSettingsChannelOptionsShowCategoriesChangedParams>
 */
export function appSetSettingsChannelOptionsShowCategoriesChanged(params) {
    return { evid: 11, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boUploadAddVideosEmbedVideoEnterUrl' event (evid: 110)
 *
 * Event description: Sent when user enters video URL
 *
 * @param {boUploadAddVideosEmbedVideoEnterUrlParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} source - youtube/vimeo/facebook
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - first_video/add_videos_menu
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boUploadAddVideosEmbedVideoEnterUrlParams>} LogObject<boUploadAddVideosEmbedVideoEnterUrlParams>
 */
export function boUploadAddVideosEmbedVideoEnterUrl(params) {
    return { evid: 110, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boUploadAddVideosEmbedVideoButtonClicked' event (evid: 111)
 *
 * Event description: Sent when user clicks on button in embed video window
 *
 * @param {boUploadAddVideosEmbedVideoButtonClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} source - youtube/vimeo/facebook
 * @property {string} button_name - add_to_library/cancel/close
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - first_video/add_videos_menu
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boUploadAddVideosEmbedVideoButtonClickedParams>} LogObject<boUploadAddVideosEmbedVideoButtonClickedParams>
 */
export function boUploadAddVideosEmbedVideoButtonClicked(params) {
    return { evid: 111, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boUploadAddVideosEmbedVideoCompleted' event (evid: 112)
 *
 * Event description: Sent when embedded video added to video library
 *
 * @param {boUploadAddVideosEmbedVideoCompletedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} source - youtube/vimeo/facebook
 * @property {number} num_videos_embedded - number of videos embedded together
 * @property {string} url - the URL address the user entered if add failed
 * @property {string} errorMsg - Error message
 * @property {boolean} isFirst - first time uploading
 * @property {GUID} _appId - app_id
 * @property {boolean} isSuccess - if the upload finished successfully
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {number} errorCode - Error code
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - first_video/add_videos_menu
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boUploadAddVideosEmbedVideoCompletedParams>} LogObject<boUploadAddVideosEmbedVideoCompletedParams>
 */
export function boUploadAddVideosEmbedVideoCompleted(params) {
    return { evid: 112, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boUploadAddVideosEmbedVideoEnterUrlParsingCompleted' event (evid: 113)
 *
 * Event description: Sent when url is parsed  successfully
 *
 * @param {boUploadAddVideosEmbedVideoEnterUrlParsingCompletedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} source - youtube/vimeo/facebook
 * @property {string} url - The URL  user insert if parsing failed
 * @property {string} errorMsg - Error message
 * @property {GUID} _appId - app_id
 * @property {boolean} isSuccess - If the parsing complete successfully
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} errorType - client-parse-error/client-unknown-source-error/server-error/unknown-error
 * @property {number} errorCode - Error code
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - first_video/add_videos_menu
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boUploadAddVideosEmbedVideoEnterUrlParsingCompletedParams>} LogObject<boUploadAddVideosEmbedVideoEnterUrlParsingCompletedParams>
 */
export function boUploadAddVideosEmbedVideoEnterUrlParsingCompleted(params) {
    return { evid: 113, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLibSignUpToWatchClicked' event (evid: 114)
 *
 * Event description: click on sign up to watch full video toggle.
 * only for free videos.
 *
 * @param {boLibSignUpToWatchClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {number} numberVideos - number of videos chosen
 * @property {boolean} toggle - on/off
 * @property {GUID} _appId - app_id
 * @property {string} videoID - json of video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} buttonOrigin - from where the user click on it (settings/on video/set pricing/video info)
 * @return {LogObject<boLibSignUpToWatchClickedParams>} LogObject<boLibSignUpToWatchClickedParams>
 */
export function boLibSignUpToWatchClicked(params) {
    return { evid: 114, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boChEditChannelSubscriptionOnlyCheckBoxClick' event (evid: 115)
 *
 * Event description: Sent when user clicks on Make videos on this channel subscription only
 * check box
 *
 * @param {boChEditChannelSubscriptionOnlyCheckBoxClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {boolean} check_box - on/off
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channel_id
 * @return {LogObject<boChEditChannelSubscriptionOnlyCheckBoxClickParams>} LogObject<boChEditChannelSubscriptionOnlyCheckBoxClickParams>
 */
export function boChEditChannelSubscriptionOnlyCheckBoxClick(params) {
    return { evid: 115, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boChEditConnectFeedEnterUrl' event (evid: 116)
 *
 * Event description: Sent when user enters video URL for feed
 *
 * @param {boChEditConnectFeedEnterUrlParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} source - youtube
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - new_feed/change_feed
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boChEditConnectFeedEnterUrlParams>} LogObject<boChEditConnectFeedEnterUrlParams>
 */
export function boChEditConnectFeedEnterUrl(params) {
    return { evid: 116, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boChEditConnectFeedEnterUrlParsingCompleted' event (evid: 117)
 *
 * Event description: Sent when url is parsed  successfully when adding feed
 *
 * @param {boChEditConnectFeedEnterUrlParsingCompletedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} source - youtube
 * @property {string} url - The URL  user insert if parsing failed
 * @property {string} errorMsg - Error message
 * @property {GUID} _appId - app_id
 * @property {boolean} isSuccess - If the parsing complete successfully
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} errorType - client-parse-error/client-unknown-source-error/server-error/unknown-error
 * @property {number} errorCode - Error code
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - new_feed/change_feed
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boChEditConnectFeedEnterUrlParsingCompletedParams>} LogObject<boChEditConnectFeedEnterUrlParsingCompletedParams>
 */
export function boChEditConnectFeedEnterUrlParsingCompleted(params) {
    return { evid: 117, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boChEditConnectFeedEnterUrlButtonClicked' event (evid: 118)
 *
 * Event description: Sent when user clicks on button in feed video window
 *
 * @param {boChEditConnectFeedEnterUrlButtonClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} source - youtube
 * @property {string} button_name - connect/cancel/close/change_feed
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - new_feed/change_feed
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boChEditConnectFeedEnterUrlButtonClickedParams>} LogObject<boChEditConnectFeedEnterUrlButtonClickedParams>
 */
export function boChEditConnectFeedEnterUrlButtonClicked(params) {
    return { evid: 118, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLoaded' event (evid: 119)
 *
 * Event description: The existing  bo.opened (evid=120) event sends when the app starts (aka js inits), this one would send right from the html load
 *
 * @param {boLoadedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} source - back_office / business_manager
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - ADI / editor / МА
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLoadedParams>} LogObject<boLoadedParams>
 */
export function boLoaded(params) {
    return { evid: 119, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetSettingsChannelOptionsTagsChanged' event (evid: 12)
 *
 * Event description: Choosing to offer tags in search or not
 *
 * @param {appSetSettingsChannelOptionsTagsChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - compact / strip / etc
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {boolean} isTags - Choosing to offer tags in search or not
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetSettingsChannelOptionsTagsChangedParams>} LogObject<appSetSettingsChannelOptionsTagsChangedParams>
 */
export function appSetSettingsChannelOptionsTagsChanged(params) {
    return { evid: 12, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boOpened' event (evid: 120)
 *
 * Event description: Opened back office
 *
 * @param {boOpenedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} source - back_office / business_manager
 * @property {boolean} isFirst - first time open the back office
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {number} loading_time - loading time
 * @return {LogObject<boOpenedParams>} LogObject<boOpenedParams>
 */
export function boOpened(params) {
    return { evid: 120, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boTabClicked' event (evid: 121)
 *
 * Event description: Tab clicked in the back office
 *
 * @param {boTabClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} newTabName - video-library/channels/stats/settings
 * @return {LogObject<boTabClickedParams>} LogObject<boTabClickedParams>
 */
export function boTabClicked(params) {
    return { evid: 121, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boWelcomeScreenClicked' event (evid: 122)
 *
 * Event description: Clicked on the let's go button in the bo welcome screen
 *
 * @param {boWelcomeScreenClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - editor/ADI/my account
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boWelcomeScreenClickedParams>} LogObject<boWelcomeScreenClickedParams>
 */
export function boWelcomeScreenClicked(params) {
    return { evid: 122, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boCloseClicked' event (evid: 123)
 *
 * Event description: Clicking on  back office close button
 *
 * @param {boCloseClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - ADI / editor / МА
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boCloseClickedParams>} LogObject<boCloseClickedParams>
 */
export function boCloseClicked(params) {
    return { evid: 123, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boChConnectFeedCompleted' event (evid: 124)
 *
 * Event description: Sent when feed added to user channels
 *
 * @param {boChConnectFeedCompletedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} source - youtube
 * @property {string} url - the URL address the user entered if add failed
 * @property {string} errorMsg - Error message
 * @property {boolean} isFirst - first time uploading
 * @property {GUID} _appId - app_id
 * @property {boolean} isSuccess - if the connect feed finished successfully
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {number} errorCode - Error code
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - new_feed/change_feed
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channel_id
 * @return {LogObject<boChConnectFeedCompletedParams>} LogObject<boChConnectFeedCompletedParams>
 */
export function boChConnectFeedCompleted(params) {
    return { evid: 124, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boChYtlistNextButtonClicked' event (evid: 126)
 *
 * Event description: Sent when user clicks on next button when adding YouTube list or channel in first on boarding experience
 *
 * @param {boChYtlistNextButtonClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} source - youtube/vimeo/facebook
 * @property {boolean} isFirst - true/false
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - ADI / editor / МА
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boChYtlistNextButtonClickedParams>} LogObject<boChYtlistNextButtonClickedParams>
 */
export function boChYtlistNextButtonClicked(params) {
    return { evid: 126, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boOnboardingOpend' event (evid: 127)
 *
 * Event description: Sent when new onboarding open for user in the first time the app opened
 *
 * @param {boOnboardingOpendParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {boolean} isFirst - first time open the back office
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {number} loading_time - loading time
 * @return {LogObject<boOnboardingOpendParams>} LogObject<boOnboardingOpendParams>
 */
export function boOnboardingOpend(params) {
    return { evid: 127, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetVidClicked' event (evid: 128)
 *
 * Event description: play video clicked
 *
 * @param {widgetVidClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - instance_id
 * @property {GUID} _msid - msid
 * @property {number} duration - duration of full video in ms
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - instance_id
 * @property {string} _viewMode - view_mode
 * @property {boolean} overQuoted - is video id under OverQuota, true / false
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {string} buttonName - play_video / next_video
 * @property {string} correlationId - ID for one unique view connection
 * @property {string} videoType - facebook/youtube/computer/vimeo/live
 * @property {GUID} _visitorId - visitorID
 * @property {string} channelID - channelID
 * @return {LogObject<widgetVidClickedParams>} LogObject<widgetVidClickedParams>
 */
export function widgetVidClicked(params) {
    return { evid: 128, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetVidStartPlay' event (evid: 129)
 *
 * Event description: when video start play after user click (128)
 *
 * @param {widgetVidStartPlayParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - instance_id
 * @property {GUID} _msid - msid
 * @property {number} duration - duration of full video in ms
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {string} button - thumbnail/main
 * @property {GUID} _instanceId - instance_id
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {boolean} isAutoplay - If video start autoplay or user click on play
 * @property {string} compId - player_id
 * @property {string} correlationId - ID for one unique view connection
 * @property {string} videoType - computer/vimeo/facebook/youtube/live
 * @property {GUID} _visitorId - visitorID
 * @property {string} channelID - channelID
 * @return {LogObject<widgetVidStartPlayParams>} LogObject<widgetVidStartPlayParams>
 */
export function widgetVidStartPlay(params) {
    return { evid: 129, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetSettingsShareVidsChanged' event (evid: 13)
 *
 * Event description: Choosing to let viewers share my videos
 *
 * @param {appSetSettingsShareVidsChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} playVideo - in_the_frame/expanded_view
 * @property {string} layoutType - classic/strip/compact
 * @property {boolean} isShareVids - Choosing to let viewers share my videos
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetSettingsShareVidsChangedParams>} LogObject<appSetSettingsShareVidsChangedParams>
 */
export function appSetSettingsShareVidsChanged(params) {
    return { evid: 13, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boChEditChCoverFailed' event (evid: 130)
 *
 * Event description: Upload cover error event (picture/video)
 *
 * @param {boChEditChCoverFailedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} mediaType - picture/video
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {string} button - drag-n-drop/upload
 * @property {GUID} _instanceId - InstanceID
 * @property {string} errorType - error type
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channelID
 * @return {LogObject<boChEditChCoverFailedParams>} LogObject<boChEditChCoverFailedParams>
 */
export function boChEditChCoverFailed(params) {
    return { evid: 130, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLibLiveAddClick' event (evid: 131)
 *
 * Event description: Click on "+ Live Stram" button in video library, on onboarding screen or on Live stream tab
 *
 * @param {boLibLiveAddClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {string} type - live_stream_tab / onboarding etc
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLibLiveAddClickParams>} LogObject<boLibLiveAddClickParams>
 */
export function boLibLiveAddClick(params) {
    return { evid: 131, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boChEditDefaultChannelTooltipCloseClick' event (evid: 132)
 *
 * Event description: Tooltip about default channel closed
 *
 * @param {boChEditDefaultChannelTooltipCloseClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channelID
 * @return {LogObject<boChEditDefaultChannelTooltipCloseClickParams>} LogObject<boChEditDefaultChannelTooltipCloseClickParams>
 */
export function boChEditDefaultChannelTooltipCloseClick(params) {
    return { evid: 132, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boFeedbackClicked' event (evid: 133)
 *
 * Event description: feedback button clicked
 *
 * @param {boFeedbackClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} fromTab - video-library/channels/stats/settings
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boFeedbackClickedParams>} LogObject<boFeedbackClickedParams>
 */
export function boFeedbackClicked(params) {
    return { evid: 133, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boChEditDefaultChannelTooltipSettingsClick' event (evid: 134)
 *
 * Event description: click on settings in default channel tooltip
 *
 * @param {boChEditDefaultChannelTooltipSettingsClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channelID
 * @return {LogObject<boChEditDefaultChannelTooltipSettingsClickParams>} LogObject<boChEditDefaultChannelTooltipSettingsClickParams>
 */
export function boChEditDefaultChannelTooltipSettingsClick(params) {
    return { evid: 134, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetEmbedVidGoToSiteClick' event (evid: 135)
 *
 * Event description: click on user logo/title/more to watch on site
 *
 * @param {widgetEmbedVidGoToSiteClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {string} buttonName - logo/title/more
 * @property {GUID} _visitorId - visitorID
 * @property {string} siteUrl - site url (only when embed video)
 * @property {string} channelID - channelID
 * @return {LogObject<widgetEmbedVidGoToSiteClickParams>} LogObject<widgetEmbedVidGoToSiteClickParams>
 */
export function widgetEmbedVidGoToSiteClick(params) {
    return { evid: 135, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageCancelButtonClick' event (evid: 136)
 *
 * Event description: Clicking cancel in video page
 *
 * @param {boVidPageCancelButtonClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} videoId - video_id
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageCancelButtonClickParams>} LogObject<boVidPageCancelButtonClickParams>
 */
export function boVidPageCancelButtonClick(params) {
    return { evid: 136, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageQuickActionActionClick' event (evid: 137)
 *
 * Event description: click on action from quick actions in video page
 *
 * @param {boVidPageQuickActionActionClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} source - computer/vimeo/facebook/youtube
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {string} actionName - promote/stats
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageQuickActionActionClickParams>} LogObject<boVidPageQuickActionActionClickParams>
 */
export function boVidPageQuickActionActionClick(params) {
    return { evid: 137, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boBreadcrumbClick' event (evid: 138)
 *
 * Event description: click on breadcrumb for navigation
 *
 * @param {boBreadcrumbClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} name - breadcrumb name
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boBreadcrumbClickParams>} LogObject<boBreadcrumbClickParams>
 */
export function boBreadcrumbClick(params) {
    return { evid: 138, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageTrailerAddTrailerClick' event (evid: 139)
 *
 * Event description: click on add trailer or change trailer
 *
 * @param {boVidPageTrailerAddTrailerClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {string} actionName - add/change
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageTrailerAddTrailerClickParams>} LogObject<boVidPageTrailerAddTrailerClickParams>
 */
export function boVidPageTrailerAddTrailerClick(params) {
    return { evid: 139, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetSettingsShowInfoChanged' event (evid: 14)
 *
 * Event description: Choosing to show video info on the player or not
 *
 * @param {appSetSettingsShowInfoChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} playVideo - in_the_frame/expanded_view
 * @property {string} layoutType - classic/strip/compact
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - editor / ADI (null is editor)
 * @property {string} compId - player_id
 * @property {boolean} isShowInfo - Choosing to show video info on the player or not
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetSettingsShowInfoChangedParams>} LogObject<appSetSettingsShowInfoChangedParams>
 */
export function appSetSettingsShowInfoChanged(params) {
    return { evid: 14, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLibGoToChannelsClicked' event (evid: 140)
 *
 * Event description: Click on head to channels in video library tab
 *
 * @param {boLibGoToChannelsClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - instance_id
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - instance_id
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - ADI / editor / МА
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLibGoToChannelsClickedParams>} LogObject<boLibGoToChannelsClickedParams>
 */
export function boLibGoToChannelsClicked(params) {
    return { evid: 140, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageUploadImageClick' event (evid: 141)
 *
 * Event description: click on upload/change image in video page
 *
 * @param {boVidPageUploadImageClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {string} buttonName - upload/change
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageUploadImageClickParams>} LogObject<boVidPageUploadImageClickParams>
 */
export function boVidPageUploadImageClick(params) {
    return { evid: 141, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageUploadImageSuccess' event (evid: 142)
 *
 * Event description: upload/change image in video page finish success or not
 *
 * @param {boVidPageUploadImageSuccessParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {boolean} isSuccess - change/upload image success or not
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} errorType - error message the user get when uploading image
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {string} buttonName - upload/change
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageUploadImageSuccessParams>} LogObject<boVidPageUploadImageSuccessParams>
 */
export function boVidPageUploadImageSuccess(params) {
    return { evid: 142, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLibBatchEditSaveClick' event (evid: 143)
 *
 * Event description: Save clicked at the video library (batch edit)
 *
 * @param {boLibBatchEditSaveClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {boolean} genreChanged - did the genre changed
 * @property {string} source - computer/vimeo/facebook/youtube
 * @property {number} numVideoEdit - number of videos user edit
 * @property {string} genre - genre
 * @property {boolean} publisherExists - did publisher added
 * @property {boolean} categoryExists - did categories added
 * @property {string} audience - (all/mature)
 * @property {boolean} videoTypeChanged - did the video type changed
 * @property {number} numOfCrewMembers - number of crew members
 * @property {GUID} _appId - app_id
 * @property {string} videoID - new_videoID
 * @property {string} user_agent - user_agent
 * @property {number} numOfCastMembers - number of cast members
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {number} overQuotaVideosCount - how many of the videos are OverQ
 * @property {number} numOfTags - number of tags
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {string} videoType - video type
 * @property {GUID} _visitorId - visitor_id
 * @property {boolean} audienceChanged - did the audience changed
 * @return {LogObject<boLibBatchEditSaveClickParams>} LogObject<boLibBatchEditSaveClickParams>
 */
export function boLibBatchEditSaveClick(params) {
    return { evid: 143, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLibBatchEditSaveCompleted' event (evid: 144)
 *
 * Event description: Save completed at the video library (batch edit)
 *
 * @param {boLibBatchEditSaveCompletedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {boolean} genreChanged - did the genre changed
 * @property {string} source - computer/vimeo/facebook/youtube
 * @property {number} numVideoEdit - number of videos user edit
 * @property {string} genre - genre
 * @property {boolean} publisherExists - did publisher added
 * @property {boolean} categoryExists - did categories added
 * @property {string} errorMsg - error message the user see
 * @property {string} audience - (all/mature)
 * @property {boolean} videoTypeChanged - did the video type changed
 * @property {number} numOfCrewMembers - number of crew members
 * @property {GUID} _appId - app_id
 * @property {boolean} isSuccess - save completed successfully or not
 * @property {string} videoID - new_videoID
 * @property {string} user_agent - user_agent
 * @property {number} numOfCastMembers - number of cast members
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {number} numOfTags - number of tags
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {string} videoType - video type
 * @property {GUID} _visitorId - visitor_id
 * @property {boolean} audienceChanged - did the audience changed
 * @return {LogObject<boLibBatchEditSaveCompletedParams>} LogObject<boLibBatchEditSaveCompletedParams>
 */
export function boLibBatchEditSaveCompleted(params) {
    return { evid: 144, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boChEditToggleFeaturedVideoClick' event (evid: 145)
 *
 * Event description: Click on "star"button in channel page
 *
 * @param {boChEditToggleFeaturedVideoClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} source - computer/dropbox/drive/youtube/vimeo/facebook
 * @property {boolean} isFeatured - featured video on/off
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {boolean} overQuoted - is video id under OverQuota, true / false
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channelID
 * @return {LogObject<boChEditToggleFeaturedVideoClickParams>} LogObject<boChEditToggleFeaturedVideoClickParams>
 */
export function boChEditToggleFeaturedVideoClick(params) {
    return { evid: 145, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boChEditQuickActionActionClick' event (evid: 146)
 *
 * Event description: Click on quick actions button in channel page (promote/stats).
 * For delete we have 81
 *
 * @param {boChEditQuickActionActionClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - player_id
 * @property {string} actionName - promote/stats
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channelID
 * @return {LogObject<boChEditQuickActionActionClickParams>} LogObject<boChEditQuickActionActionClickParams>
 */
export function boChEditQuickActionActionClick(params) {
    return { evid: 146, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boChEditGoToInfoClick' event (evid: 147)
 *
 * Event description: Click on edit channel info button or channel cover
 *
 * @param {boChEditGoToInfoClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} source - edit_button/cover_image
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channel_id
 * @return {LogObject<boChEditGoToInfoClickParams>} LogObject<boChEditGoToInfoClickParams>
 */
export function boChEditGoToInfoClick(params) {
    return { evid: 147, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boChEditChannelInfoCancelClick' event (evid: 148)
 *
 * Event description: Click on cancel in channel page
 *
 * @param {boChEditChannelInfoCancelClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channel_id
 * @return {LogObject<boChEditChannelInfoCancelClickParams>} LogObject<boChEditChannelInfoCancelClickParams>
 */
export function boChEditChannelInfoCancelClick(params) {
    return { evid: 148, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetSettingsLanguageChanged' event (evid: 149)
 *
 * Event description: User change the widget language
 *
 * @param {appSetSettingsLanguageChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - classic / stripe / grid etc
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {string} prevLanguage - previous language
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {string} language - language
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetSettingsLanguageChangedParams>} LogObject<appSetSettingsLanguageChangedParams>
 */
export function appSetSettingsLanguageChanged(params) {
    return { evid: 149, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetUpgradeClicked' event (evid: 15)
 *
 * Event description: Upgrade clicked
 *
 * @param {appSetUpgradeClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {boolean} isFirst - is first time clicking on upgrade
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetUpgradeClickedParams>} LogObject<appSetUpgradeClickedParams>
 */
export function appSetUpgradeClicked(params) {
    return { evid: 15, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boEmailMarketingUseThisTemplateClicked' event (evid: 150)
 *
 * Event description: Click on use this template button in email marketing tab
 *
 * @param {boEmailMarketingUseThisTemplateClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - instance_id
 * @property {GUID} _msid - msid
 * @property {string} templateType - Share Video/Promote Channel/Send Newsletter
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - instance_id
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - ADI / editor / МА
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boEmailMarketingUseThisTemplateClickedParams>} LogObject<boEmailMarketingUseThisTemplateClickedParams>
 */
export function boEmailMarketingUseThisTemplateClicked(params) {
    return { evid: 150, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boEmailMarketingPreviewClicked' event (evid: 151)
 *
 * Event description: Click on preview button in email marketing tab
 *
 * @param {boEmailMarketingPreviewClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - instance_id
 * @property {GUID} _msid - msid
 * @property {string} templateType - Share Video/Promote Channel/Send Newsletter
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - instance_id
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - ADI / editor / МА
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boEmailMarketingPreviewClickedParams>} LogObject<boEmailMarketingPreviewClickedParams>
 */
export function boEmailMarketingPreviewClicked(params) {
    return { evid: 151, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boEmailMarketingStartFromScratchClicked' event (evid: 152)
 *
 * Event description: Click on start from scratch button in email marketing tab
 *
 * @param {boEmailMarketingStartFromScratchClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - instance_id
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - instance_id
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - ADI / editor / МА
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boEmailMarketingStartFromScratchClickedParams>} LogObject<boEmailMarketingStartFromScratchClickedParams>
 */
export function boEmailMarketingStartFromScratchClicked(params) {
    return { evid: 152, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boEmailMarketingShoutOutDashboardClicked' event (evid: 153)
 *
 * Event description: Click on "head to Wix ShoutOut dashboard" button in email marketing tab
 *
 * @param {boEmailMarketingShoutOutDashboardClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - instance_id
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - instance_id
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - ADI / editor / МА
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boEmailMarketingShoutOutDashboardClickedParams>} LogObject<boEmailMarketingShoutOutDashboardClickedParams>
 */
export function boEmailMarketingShoutOutDashboardClicked(params) {
    return { evid: 153, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boEmailMarketingUseThisTemplateChooseContinueClick' event (evid: 154)
 *
 * Event description: Click on continue in choose a channel/video box from use this template button in email marketing tab
 *
 * @param {boEmailMarketingUseThisTemplateChooseContinueClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - instance_id
 * @property {GUID} _msid - msid
 * @property {string} entityId - entity_id
 * @property {string} templateType - Share Video/Promote Channel/Send Newsletter
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - instance_id
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - ADI / editor / МА
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boEmailMarketingUseThisTemplateChooseContinueClickParams>} LogObject<boEmailMarketingUseThisTemplateChooseContinueClickParams>
 */
export function boEmailMarketingUseThisTemplateChooseContinueClick(params) {
    return { evid: 154, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boEmailMarketingUseThisTemplateChooseCancelClick' event (evid: 155)
 *
 * Event description: Click on cancel in choose a channel/video box from use this template button in email marketing tab
 *
 * @param {boEmailMarketingUseThisTemplateChooseCancelClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - instance_id
 * @property {GUID} _msid - msid
 * @property {string} templateType - Share Video/Promote Channel/Send Newsletter
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - instance_id
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - ADI / editor / МА
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boEmailMarketingUseThisTemplateChooseCancelClickParams>} LogObject<boEmailMarketingUseThisTemplateChooseCancelClickParams>
 */
export function boEmailMarketingUseThisTemplateChooseCancelClick(params) {
    return { evid: 155, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boEmailMarketingUseThisTemplateChooseCloseClick' event (evid: 156)
 *
 * Event description: Click on close in choose a channel/video box from use this template button in email marketing tab
 *
 * @param {boEmailMarketingUseThisTemplateChooseCloseClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - instance_id
 * @property {GUID} _msid - msid
 * @property {string} templateType - Share Video/Promote Channel/Send Newsletter
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - instance_id
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - ADI / editor / МА
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boEmailMarketingUseThisTemplateChooseCloseClickParams>} LogObject<boEmailMarketingUseThisTemplateChooseCloseClickParams>
 */
export function boEmailMarketingUseThisTemplateChooseCloseClick(params) {
    return { evid: 156, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boEmailMarketingPreviewPromoteChooseClick' event (evid: 157)
 *
 * Event description: Click on choose in promote box from preview in email marketing tab
 *
 * @param {boEmailMarketingPreviewPromoteChooseClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - instance_id
 * @property {GUID} _msid - msid
 * @property {string} templateType - Share Video/Promote Channel/Send Newsletter
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - instance_id
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - ADI / editor / МА
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boEmailMarketingPreviewPromoteChooseClickParams>} LogObject<boEmailMarketingPreviewPromoteChooseClickParams>
 */
export function boEmailMarketingPreviewPromoteChooseClick(params) {
    return { evid: 157, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boEmailMarketingPreviewPromoteCloseClick' event (evid: 158)
 *
 * Event description: Click on close in promote box from preview in email marketing tab
 *
 * @param {boEmailMarketingPreviewPromoteCloseClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - instance_id
 * @property {GUID} _msid - msid
 * @property {string} templateType - Share Video/Promote Channel/Send Newsletter
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - instance_id
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - ADI / editor / МА
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boEmailMarketingPreviewPromoteCloseClickParams>} LogObject<boEmailMarketingPreviewPromoteCloseClickParams>
 */
export function boEmailMarketingPreviewPromoteCloseClick(params) {
    return { evid: 158, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boChEditChannelInfoSaveClicked' event (evid: 159)
 *
 * Event description: click on "save" in channel info
 *
 * @param {boChEditChannelInfoSaveClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {boolean} descriptionExists - if description exist
 * @property {boolean} titleChanged - title changed
 * @property {GUID} _appId - app_id
 * @property {boolean} pricingPlanEnabled - true/false
 * @property {number} subscriptionPricing - subscription price doubled by 10000
 * @property {string} user_agent - user_agent
 * @property {boolean} subscriptionOnlyChange - if subscription changed
 * @property {string} planIDs - list of plan_id
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - player_id
 * @property {boolean} subscriptionEnabled - is subscription enable
 * @property {boolean} hasCustomCover - has channel custom cover
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channelID
 * @return {LogObject<boChEditChannelInfoSaveClickedParams>} LogObject<boChEditChannelInfoSaveClickedParams>
 */
export function boChEditChannelInfoSaveClicked(params) {
    return { evid: 159, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boChEditChannelInfoSaveCompleted' event (evid: 160)
 *
 * Event description: "save" in channel info completed
 *
 * @param {boChEditChannelInfoSaveCompletedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {boolean} descriptionExists - if description exist
 * @property {boolean} titleChanged - title changed
 * @property {GUID} _appId - app_id
 * @property {boolean} pricingPlanEnabled - is pricing Plan Enabled
 * @property {number} subscriptionPricing - subscription price doubled by 10000
 * @property {string} user_agent - user_agent
 * @property {boolean} subscriptionOnlyChange - if subscription changed
 * @property {string} planIDs - list of plan_id
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - player_id
 * @property {boolean} subscriptionEnabled - is subscription enable
 * @property {boolean} hasCustomCover - has channel custom cover
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channelID
 * @return {LogObject<boChEditChannelInfoSaveCompletedParams>} LogObject<boChEditChannelInfoSaveCompletedParams>
 */
export function boChEditChannelInfoSaveCompleted(params) {
    return { evid: 160, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boUploadAddVideosFacebookProfileError' event (evid: 161)
 *
 * Event description: Sent after user add URL of video from Facebook profile and try to login and get error message
 *
 * @param {boUploadAddVideosFacebookProfileErrorParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} errorMsg - error message
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - first_video/add_videos_menu
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boUploadAddVideosFacebookProfileErrorParams>} LogObject<boUploadAddVideosFacebookProfileErrorParams>
 */
export function boUploadAddVideosFacebookProfileError(params) {
    return { evid: 161, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boUploadAddVideosFacebookVideoCancelButtonClicked' event (evid: 162)
 *
 * Event description: Sent when user clicks on cancelbutton in embed video window
 *
 * @param {boUploadAddVideosFacebookVideoCancelButtonClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - first_video/add_videos_menu
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boUploadAddVideosFacebookVideoCancelButtonClickedParams>} LogObject<boUploadAddVideosFacebookVideoCancelButtonClickedParams>
 */
export function boUploadAddVideosFacebookVideoCancelButtonClicked(params) {
    return { evid: 162, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boUploadAddVideosLoginAndAddVideoButtonClicked' event (evid: 163)
 *
 * Event description: Sent when user clicks on "Login and Add Video" button in embed video window
 *
 * @param {boUploadAddVideosLoginAndAddVideoButtonClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - first_video/add_videos_menu
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boUploadAddVideosLoginAndAddVideoButtonClickedParams>} LogObject<boUploadAddVideosLoginAndAddVideoButtonClickedParams>
 */
export function boUploadAddVideosLoginAndAddVideoButtonClicked(params) {
    return { evid: 163, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageAddCardClick' event (evid: 164)
 *
 * Event description: click on "Add a card" in video page
 *
 * @param {boVidPageAddCardClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageAddCardClickParams>} LogObject<boVidPageAddCardClickParams>
 */
export function boVidPageAddCardClick(params) {
    return { evid: 164, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageVideoCardsClick' event (evid: 165)
 *
 * Event description: click on "Video Cards" section in video page
 *
 * @param {boVidPageVideoCardsClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageVideoCardsClickParams>} LogObject<boVidPageVideoCardsClickParams>
 */
export function boVidPageVideoCardsClick(params) {
    return { evid: 165, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageEditCardsClick' event (evid: 166)
 *
 * Event description: click on "Edit Cards" section in video page
 *
 * @param {boVidPageEditCardsClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageEditCardsClickParams>} LogObject<boVidPageEditCardsClickParams>
 */
export function boVidPageEditCardsClick(params) {
    return { evid: 166, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageLiveLearnMoreClick' event (evid: 167)
 *
 * Event description: Click on learn more in live stream section
 *
 * @param {boVidPageLiveLearnMoreClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageLiveLearnMoreClickParams>} LogObject<boVidPageLiveLearnMoreClickParams>
 */
export function boVidPageLiveLearnMoreClick(params) {
    return { evid: 167, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageStoreClick' event (evid: 168)
 *
 * Event description: Click on Google Play store or Apple store image
 *
 * @param {boVidPageStoreClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {string} storeName - apple/google
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageStoreClickParams>} LogObject<boVidPageStoreClickParams>
 */
export function boVidPageStoreClick(params) {
    return { evid: 168, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetDesignLoadMoreButtonStyleChanged' event (evid: 169)
 *
 * Event description: User change load more button style
 *
 * @param {appSetDesignLoadMoreButtonStyleChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - classic/strip/compact
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {string} selection - text_button / text_and_button
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetDesignLoadMoreButtonStyleChangedParams>} LogObject<appSetDesignLoadMoreButtonStyleChangedParams>
 */
export function appSetDesignLoadMoreButtonStyleChanged(params) {
    return { evid: 169, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetWelcomeScreenClicked' event (evid: 17)
 *
 * Event description: Witch button did you clicked on the welcome screen
 *
 * @param {appSetWelcomeScreenClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - editorMode
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {string} selection - DesignMyChannel/StartNow
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - editor/adi
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetWelcomeScreenClickedParams>} LogObject<appSetWelcomeScreenClickedParams>
 */
export function appSetWelcomeScreenClicked(params) {
    return { evid: 17, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetSettingsMainItemTypeChanged' event (evid: 170)
 *
 * Event description: User change in appSet.settings at main Item section to channel cover or featured video
 *
 * @param {appSetSettingsMainItemTypeChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - classic/strip/compact
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {string} selection - channel_cover/featured_video
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetSettingsMainItemTypeChangedParams>} LogObject<appSetSettingsMainItemTypeChangedParams>
 */
export function appSetSettingsMainItemTypeChanged(params) {
    return { evid: 170, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetSettingsMainItemShowTitleForMainItemChanged' event (evid: 171)
 *
 * Event description: User change in appSet.settings at main Item section to show title or not
 *
 * @param {appSetSettingsMainItemShowTitleForMainItemChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - classic/strip/compact
 * @property {boolean} toggle - true/false
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetSettingsMainItemShowTitleForMainItemChangedParams>} LogObject<appSetSettingsMainItemShowTitleForMainItemChangedParams>
 */
export function appSetSettingsMainItemShowTitleForMainItemChanged(params) {
    return { evid: 171, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetSettingsPlayTypeChanged' event (evid: 172)
 *
 * Event description: User change in appSet.settings the play option
 *
 * @param {appSetSettingsPlayTypeChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - classic/strip/compact
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {string} selection - in_frame/expanded_view
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetSettingsPlayTypeChangedParams>} LogObject<appSetSettingsPlayTypeChangedParams>
 */
export function appSetSettingsPlayTypeChanged(params) {
    return { evid: 172, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetLayoutActionBarShowVideoListTypeChanged' event (evid: 174)
 *
 * Event description: User change  show video list in appSet.layout
 *
 * @param {appSetLayoutActionBarShowVideoListTypeChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - classic/strip/compact
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {string} selection - when_clicked/never/always
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetLayoutActionBarShowVideoListTypeChangedParams>} LogObject<appSetLayoutActionBarShowVideoListTypeChangedParams>
 */
export function appSetLayoutActionBarShowVideoListTypeChanged(params) {
    return { evid: 174, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetLayoutVideoListShowVideoTitlesChanged' event (evid: 175)
 *
 * Event description: User change  show video titels in appSet.layout.videoList ( the old name was showInfoAction)
 *
 * @param {appSetLayoutVideoListShowVideoTitlesChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - classic/strip/compact
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {string} selection - on_hover/always/never
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetLayoutVideoListShowVideoTitlesChangedParams>} LogObject<appSetLayoutVideoListShowVideoTitlesChangedParams>
 */
export function appSetLayoutVideoListShowVideoTitlesChanged(params) {
    return { evid: 175, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetDesignMainItemShowMainActionsAsChanged' event (evid: 176)
 *
 * Event description: User change  show main actions in appSet.design.mainItem (styleParamName: mainActionStyleType)
 *
 * @param {appSetDesignMainItemShowMainActionsAsChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - classic/strip/compact
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {string} selection - text/icon_buttons
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetDesignMainItemShowMainActionsAsChangedParams>} LogObject<appSetDesignMainItemShowMainActionsAsChangedParams>
 */
export function appSetDesignMainItemShowMainActionsAsChanged(params) {
    return { evid: 176, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLibEmbedOptionsLogoClick' event (evid: 177)
 *
 * Event description: click on add/choose/change logo in embed section
 *
 * @param {boLibEmbedOptionsLogoClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} videoId - video_id
 * @property {string} button_name - add/choose/change
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLibEmbedOptionsLogoClickParams>} LogObject<boLibEmbedOptionsLogoClickParams>
 */
export function boLibEmbedOptionsLogoClick(params) {
    return { evid: 177, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLibChooseLogoPopUpOpened' event (evid: 178)
 *
 * Event description: choose logo pop up opened
 *
 * @param {boLibChooseLogoPopUpOpenedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} videoId - video_id
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLibChooseLogoPopUpOpenedParams>} LogObject<boLibChooseLogoPopUpOpenedParams>
 */
export function boLibChooseLogoPopUpOpened(params) {
    return { evid: 178, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLibChooseLogoPopUpChooseLogoClick' event (evid: 179)
 *
 * Event description: click on "choose logo" in logo pop up
 *
 * @param {boLibChooseLogoPopUpChooseLogoClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} videoId - video_id
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLibChooseLogoPopUpChooseLogoClickParams>} LogObject<boLibChooseLogoPopUpChooseLogoClickParams>
 */
export function boLibChooseLogoPopUpChooseLogoClick(params) {
    return { evid: 179, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetTabClicked' event (evid: 18)
 *
 * Event description: Clicking on tab layout or design or settings
 *
 * @param {appSetTabClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - layout type
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} newTabName - main/channel/settings/layout/design
 * @return {LogObject<appSetTabClickedParams>} LogObject<appSetTabClickedParams>
 */
export function appSetTabClicked(params) {
    return { evid: 18, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLibChooseLogoPopUpSettingsClick' event (evid: 180)
 *
 * Event description: click on settings word in choose logo pop up
 *
 * @param {boLibChooseLogoPopUpSettingsClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} videoId - video_id
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLibChooseLogoPopUpSettingsClickParams>} LogObject<boLibChooseLogoPopUpSettingsClickParams>
 */
export function boLibChooseLogoPopUpSettingsClick(params) {
    return { evid: 180, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLibAddLogoPopUpOpened' event (evid: 181)
 *
 * Event description: "add a custom logo" popup opened
 *
 * @param {boLibAddLogoPopUpOpenedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} videoId - video_id
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLibAddLogoPopUpOpenedParams>} LogObject<boLibAddLogoPopUpOpenedParams>
 */
export function boLibAddLogoPopUpOpened(params) {
    return { evid: 181, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLibAddLogoPopUpGoToSettingsClick' event (evid: 182)
 *
 * Event description: click on "go to settings" in "add a custom logo" popup
 *
 * @param {boLibAddLogoPopUpGoToSettingsClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} videoId - video_id
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLibAddLogoPopUpGoToSettingsClickParams>} LogObject<boLibAddLogoPopUpGoToSettingsClickParams>
 */
export function boLibAddLogoPopUpGoToSettingsClick(params) {
    return { evid: 182, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLibAddLogoPopUpCancelClick' event (evid: 183)
 *
 * Event description: click on cancel in "add a custom logo" popup
 *
 * @param {boLibAddLogoPopUpCancelClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} videoId - video_id
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLibAddLogoPopUpCancelClickParams>} LogObject<boLibAddLogoPopUpCancelClickParams>
 */
export function boLibAddLogoPopUpCancelClick(params) {
    return { evid: 183, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boSettingsLogoLearnMoreClick' event (evid: 184)
 *
 * Event description: Click on learn more button from logo section in bo.settings
 *
 * @param {boSettingsLogoLearnMoreClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boSettingsLogoLearnMoreClickParams>} LogObject<boSettingsLogoLearnMoreClickParams>
 */
export function boSettingsLogoLearnMoreClick(params) {
    return { evid: 184, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boSettingsLogoAdditionalActionsClick' event (evid: 185)
 *
 * Event description: click on one of additional actions in settings.logo section (change logo,make default,remove_default and delete)
 *
 * @param {boSettingsLogoAdditionalActionsClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} button_name - change_logo/make_default/delete/remove_default
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boSettingsLogoAdditionalActionsClickParams>} LogObject<boSettingsLogoAdditionalActionsClickParams>
 */
export function boSettingsLogoAdditionalActionsClick(params) {
    return { evid: 185, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boSettingsLogoUploadLogoComplete' event (evid: 186)
 *
 * Event description: sent when logo upload complete (success or not)
 *
 * @param {boSettingsLogoUploadLogoCompleteParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {boolean} isSuccess - true/false
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {number} numberOfLogosAfter - # of logos after upload complete
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my account/editor/ADI
 * @property {string} errorDec - error message if upload failed
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boSettingsLogoUploadLogoCompleteParams>} LogObject<boSettingsLogoUploadLogoCompleteParams>
 */
export function boSettingsLogoUploadLogoComplete(params) {
    return { evid: 186, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boSettingsLogoAddClick' event (evid: 187)
 *
 * Event description: Click on add logo in settings.logo
 *
 * @param {boSettingsLogoAddClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {number} numberOfLogos - # of existing logos before upload
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boSettingsLogoAddClickParams>} LogObject<boSettingsLogoAddClickParams>
 */
export function boSettingsLogoAddClick(params) {
    return { evid: 187, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetSettingsShowChannelInfoChanged' event (evid: 188)
 *
 * Event description: User change in appSet.settings "show channel info"  toggle
 *
 * @param {appSetSettingsShowChannelInfoChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - classic/strip/compact
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {boolean} isEnabled - toggle on/off
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetSettingsShowChannelInfoChangedParams>} LogObject<appSetSettingsShowChannelInfoChangedParams>
 */
export function appSetSettingsShowChannelInfoChanged(params) {
    return { evid: 188, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetSettingsShowSignInChanged' event (evid: 189)
 *
 * Event description: User change in appSet.settings "show sign in"  toggle
 *
 * @param {appSetSettingsShowSignInChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - classic/strip/compact
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {boolean} isEnabled - toggle on/off
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetSettingsShowSignInChangedParams>} LogObject<appSetSettingsShowSignInChangedParams>
 */
export function appSetSettingsShowSignInChanged(params) {
    return { evid: 189, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetPlayerShowVideoListTitleChanged' event (evid: 191)
 *
 * Event description: User change  "show video list titles" in appSet.player
 *
 * @param {appSetPlayerShowVideoListTitleChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - classic/strip/compact
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {string} selection - hover/never/always
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetPlayerShowVideoListTitleChangedParams>} LogObject<appSetPlayerShowVideoListTitleChangedParams>
 */
export function appSetPlayerShowVideoListTitleChanged(params) {
    return { evid: 191, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetPreviewExpandedViewClick' event (evid: 192)
 *
 * Event description: Preview expanded view button clicked in setting -> design tab.
 *
 * @param {appSetPreviewExpandedViewClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - classic/strip/compact
 * @property {string} section - text, buttons, player, whilePlaying
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetPreviewExpandedViewClickParams>} LogObject<appSetPreviewExpandedViewClickParams>
 */
export function appSetPreviewExpandedViewClick(params) {
    return { evid: 192, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetLayoutDisplayInfoTitleChanged' event (evid: 193)
 *
 * Event description: User click on title on/off in appSet.layout.displayInfo
 *
 * @param {appSetLayoutDisplayInfoTitleChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - classic/strip/compact
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {boolean} isEnabled - on/off
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetLayoutDisplayInfoTitleChangedParams>} LogObject<appSetLayoutDisplayInfoTitleChangedParams>
 */
export function appSetLayoutDisplayInfoTitleChanged(params) {
    return { evid: 193, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetLayoutDisplayInfoPublisherChanged' event (evid: 194)
 *
 * Event description: User click on publisher on/off in appSet.layout.displayInfo
 *
 * @param {appSetLayoutDisplayInfoPublisherChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - classic/strip/compact
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {boolean} isEnabled - on/off
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetLayoutDisplayInfoPublisherChangedParams>} LogObject<appSetLayoutDisplayInfoPublisherChangedParams>
 */
export function appSetLayoutDisplayInfoPublisherChanged(params) {
    return { evid: 194, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetPlayerShowPublisherChanged' event (evid: 195)
 *
 * Event description: User change in appSet.player "show video list"  toggle
 *
 * @param {appSetPlayerShowPublisherChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - classic/strip/compact
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {boolean} isEnabled - toggle on/off
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetPlayerShowPublisherChangedParams>} LogObject<appSetPlayerShowPublisherChangedParams>
 */
export function appSetPlayerShowPublisherChanged(params) {
    return { evid: 195, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetSettingsShowSearchChanged' event (evid: 197)
 *
 * Event description: User change in appSet.settings "show search"  toggle
 *
 * @param {appSetSettingsShowSearchChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - classic/strip/compact
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {boolean} isEnabled - toggle on/off
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetSettingsShowSearchChangedParams>} LogObject<appSetSettingsShowSearchChangedParams>
 */
export function appSetSettingsShowSearchChanged(params) {
    return { evid: 197, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetPlayerThemeChanged' event (evid: 198)
 *
 * Event description: User change theme in appSet.player
 *
 * @param {appSetPlayerThemeChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - classic/strip/compact
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {string} theme_type - dark/light
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetPlayerThemeChangedParams>} LogObject<appSetPlayerThemeChangedParams>
 */
export function appSetPlayerThemeChanged(params) {
    return { evid: 198, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetLoaded' event (evid: 199)
 *
 * Event description: The existing widget.opened (evid=200) event sends when the app starts (aka js inits), this one would send right from the html load
 *
 * @param {widgetLoadedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} viewMode - editor/viewer
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - editor/viewer
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitorID
 * @property {string} channelID - channelID
 * @return {LogObject<widgetLoadedParams>} LogObject<widgetLoadedParams>
 */
export function widgetLoaded(params) {
    return { evid: 199, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boStatsTimeframeChanged' event (evid: 20)
 *
 * Event description: Changing the time frame on the different tabs QuickStats/Channels/Videos
 *
 * @param {boStatsTimeframeChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} tabName - QuickStats/Channels/Videos
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - ADI / editor / МА
 * @property {string} compId - player_id
 * @property {string} timeFrame - All time / Last year / Last month / Last week / Today (hours)
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boStatsTimeframeChangedParams>} LogObject<boStatsTimeframeChangedParams>
 */
export function boStatsTimeframeChanged(params) {
    return { evid: 20, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetOpened' event (evid: 200)
 *
 * Event description: Video widget opend
 *
 * @param {widgetOpenedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} viewMode - editor/viewer
 * @property {boolean} isTrailerBtn - is trailer Button shows
 * @property {GUID} visitorID - visitorID
 * @property {string} trailerType - preview/trailer
 * @property {string} mainItem - featuredVid/channelCover
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {boolean} isSubscriptionBtn - is subscription Button shows
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - editor/viewer
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {string} buyTypeDisplayed - rent/buyFrom/buy/none
 * @property {string} layout - compact/strip/classic
 * @property {GUID} _visitorId - visitorID
 * @property {string} channelID - channelID
 * @property {number} loading_time - loading time
 * @return {LogObject<widgetOpenedParams>} LogObject<widgetOpenedParams>
 */
export function widgetOpened(params) {
    return { evid: 200, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetSignInClicked' event (evid: 201)
 *
 * Event description: SignIn button clicked
 *
 * @param {widgetSignInClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitorID
 * @property {string} channelID - channel
 * @return {LogObject<widgetSignInClickedParams>} LogObject<widgetSignInClickedParams>
 */
export function widgetSignInClicked(params) {
    return { evid: 201, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetVidSelectedDisplayed' event (evid: 203)
 *
 * Event description: Video selected displayed
 *
 * @param {widgetVidSelectedDisplayedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {boolean} trailerBtn - is there a trailer button
 * @property {GUID} visitorID - visitorID
 * @property {boolean} playBtn - is there a play button
 * @property {string} trailerType - preview/trailer
 * @property {boolean} buyBtn - is there a buy button
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {boolean} overQuoted - is video id under OverQuota, true / false
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} buyType - rent/from/none
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitorID
 * @property {string} channelID - channelID
 * @return {LogObject<widgetVidSelectedDisplayedParams>} LogObject<widgetVidSelectedDisplayedParams>
 */
export function widgetVidSelectedDisplayed(params) {
    return { evid: 203, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetVidSelectedBtnClicked' event (evid: 204)
 *
 * Event description: Clicked video button (playVid ,buy, rent, buy From, trailer or preview)
 *
 * @param {widgetVidSelectedBtnClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} buttonType - thumbnail/main
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {string} button - playVid/buy/rent/buyFrom/trailer/preview
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {boolean} overQuoted - is video id under OverQuota, true / false
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitorID
 * @property {string} channelID - channelID
 * @return {LogObject<widgetVidSelectedBtnClickedParams>} LogObject<widgetVidSelectedBtnClickedParams>
 */
export function widgetVidSelectedBtnClicked(params) {
    return { evid: 204, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetChCoverBtnClicked' event (evid: 205)
 *
 * Event description: Clicked cover button (start watching, watch preview or subscribe)
 *
 * @param {widgetChCoverBtnClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {string} button - startWatching/watchPreview/subscribe
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitorID
 * @property {string} channelID - channelID
 * @return {LogObject<widgetChCoverBtnClickedParams>} LogObject<widgetChCoverBtnClickedParams>
 */
export function widgetChCoverBtnClicked(params) {
    return { evid: 205, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetSubscriptionDisplayed' event (evid: 206)
 *
 * Event description: The subscription button displayed
 *
 * @param {widgetSubscriptionDisplayedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {string} whereDisplayed - widget/cover
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitorID
 * @property {string} channelID - channelID
 * @return {LogObject<widgetSubscriptionDisplayedParams>} LogObject<widgetSubscriptionDisplayedParams>
 */
export function widgetSubscriptionDisplayed(params) {
    return { evid: 206, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetSubscriptionPopUpCompleted' event (evid: 207)
 *
 * Event description: Subscription  popup completed
 *
 * @param {widgetSubscriptionPopUpCompletedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {string} errorMsg - error message
 * @property {string} result - success/canceled/failed
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitorID
 * @property {string} channelID - channelID
 * @return {LogObject<widgetSubscriptionPopUpCompletedParams>} LogObject<widgetSubscriptionPopUpCompletedParams>
 */
export function widgetSubscriptionPopUpCompleted(params) {
    return { evid: 207, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetSubscriptionClicked' event (evid: 208)
 *
 * Event description: Subscription click from widget
 *
 * @param {widgetSubscriptionClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitorID
 * @property {string} channelID - channelID
 * @return {LogObject<widgetSubscriptionClickedParams>} LogObject<widgetSubscriptionClickedParams>
 */
export function widgetSubscriptionClicked(params) {
    return { evid: 208, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetSearchClicked' event (evid: 209)
 *
 * Event description: Search click from widget
 *
 * @param {widgetSearchClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitorID
 * @property {string} channelID - channelID
 * @return {LogObject<widgetSearchClickedParams>} LogObject<widgetSearchClickedParams>
 */
export function widgetSearchClicked(params) {
    return { evid: 209, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boStatsChannelsChStatsClicked' event (evid: 21)
 *
 * Event description: Clicking on the stats of a channel
 *
 * @param {boStatsChannelsChStatsClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - ADI / editor / МА
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channel_id
 * @return {LogObject<boStatsChannelsChStatsClickedParams>} LogObject<boStatsChannelsChStatsClickedParams>
 */
export function boStatsChannelsChStatsClicked(params) {
    return { evid: 21, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetTagsClicked' event (evid: 210)
 *
 * Event description: Tags button clicked
 *
 * @param {widgetTagsClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitorID
 * @property {string} channelID - channelID
 * @return {LogObject<widgetTagsClickedParams>} LogObject<widgetTagsClickedParams>
 */
export function widgetTagsClicked(params) {
    return { evid: 210, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetTagsSelected' event (evid: 211)
 *
 * Event description: Tag selected from list
 *
 * @param {widgetTagsSelectedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitorID
 * @property {string} channelID - channelID
 * @return {LogObject<widgetTagsSelectedParams>} LogObject<widgetTagsSelectedParams>
 */
export function widgetTagsSelected(params) {
    return { evid: 211, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetCategoriesSelected' event (evid: 212)
 *
 * Event description: Categories selected from list
 *
 * @param {widgetCategoriesSelectedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitorID
 * @property {string} channelID - channelID
 * @return {LogObject<widgetCategoriesSelectedParams>} LogObject<widgetCategoriesSelectedParams>
 */
export function widgetCategoriesSelected(params) {
    return { evid: 212, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetCategoriesClicked' event (evid: 213)
 *
 * Event description: Categories  button clicked
 *
 * @param {widgetCategoriesClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitorID
 * @property {string} channelID - channelID
 * @return {LogObject<widgetCategoriesClickedParams>} LogObject<widgetCategoriesClickedParams>
 */
export function widgetCategoriesClicked(params) {
    return { evid: 213, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetAboutChDisplayed' event (evid: 214)
 *
 * Event description: About channel  button displayed
 *
 * @param {widgetAboutChDisplayedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitorID
 * @property {string} channelID - channelID
 * @return {LogObject<widgetAboutChDisplayedParams>} LogObject<widgetAboutChDisplayedParams>
 */
export function widgetAboutChDisplayed(params) {
    return { evid: 214, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetAboutChClicked' event (evid: 215)
 *
 * Event description: About channel  button clicked
 *
 * @param {widgetAboutChClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitorID
 * @property {string} channelID - channelID
 * @return {LogObject<widgetAboutChClickedParams>} LogObject<widgetAboutChClickedParams>
 */
export function widgetAboutChClicked(params) {
    return { evid: 215, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetSignupClicked' event (evid: 216)
 *
 * Event description: Signup button clicked
 *
 * @param {widgetSignupClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitorID
 * @property {string} channelID - channelID
 * @return {LogObject<widgetSignupClickedParams>} LogObject<widgetSignupClickedParams>
 */
export function widgetSignupClicked(params) {
    return { evid: 216, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetShareClicked' event (evid: 217)
 *
 * Event description: Share button clicked
 *
 * @param {widgetShareClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {string} typeShare - facebook/twitter/pinterest/tumblr
 * @property {GUID} _visitorId - visitorID
 * @property {string} channelID - channelID
 * @return {LogObject<widgetShareClickedParams>} LogObject<widgetShareClickedParams>
 */
export function widgetShareClicked(params) {
    return { evid: 217, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetVidPlayed' event (evid: 218)
 *
 * Event description: Video played
 *
 * @param {widgetVidPlayedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {number} duration - duration of full video in ms
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {string} button - thumbnail/main
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {boolean} isAutoplay - If video start autoplay or user click on play
 * @property {string} compId - player_id
 * @property {string} correlationId - ID for one unique view connection
 * @property {boolean} isLive - If video is live
 * @property {GUID} _visitorId - visitorID
 * @property {string} channelID - channelID
 * @return {LogObject<widgetVidPlayedParams>} LogObject<widgetVidPlayedParams>
 */
export function widgetVidPlayed(params) {
    return { evid: 218, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetVidBuyDisplayed' event (evid: 219)
 *
 * Event description: Buy button displayed on video
 *
 * @param {widgetVidBuyDisplayedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {string} button - thumbnail/main
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - on_site/embed
 * @property {string} buyType - buy/rent/buyFrom
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitorID
 * @property {string} siteUrl - site url (only when embed video)
 * @property {string} channelID - channelID
 * @return {LogObject<widgetVidBuyDisplayedParams>} LogObject<widgetVidBuyDisplayedParams>
 */
export function widgetVidBuyDisplayed(params) {
    return { evid: 219, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boStatsVideosChStatsClicked' event (evid: 22)
 *
 * Event description: Clicking on the stats of a video
 *
 * @param {boStatsVideosChStatsClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - ADI / editor / МА
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boStatsVideosChStatsClickedParams>} LogObject<boStatsVideosChStatsClickedParams>
 */
export function boStatsVideosChStatsClicked(params) {
    return { evid: 22, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetVidBuyClicked' event (evid: 220)
 *
 * Event description: Buy button clicked on video
 *
 * @param {widgetVidBuyClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {number} price - doubled by 10000
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {string} button - thumbnail/main/cover/lightbox
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - on_site/embed
 * @property {string} buyType - buy/rent/buyFrom
 * @property {string} compId - player_id
 * @property {string} currency - currency
 * @property {string} videoType - computer / youtube etc
 * @property {GUID} _visitorId - visitorID
 * @property {string} siteUrl - site url (only when embed video)
 * @property {string} channelID - channelID
 * @return {LogObject<widgetVidBuyClickedParams>} LogObject<widgetVidBuyClickedParams>
 */
export function widgetVidBuyClicked(params) {
    return { evid: 220, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetVidBuySuccess' event (evid: 221)
 *
 * Event description: Buy succeeded
 *
 * @param {widgetVidBuySuccessParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {number} price - doubled by 10000
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} buyType - buy/rent/buyFrom/recurring
 * @property {GUID} orderid - orderId
 * @property {string} compId - player_id
 * @property {string} currency - currency
 * @property {GUID} _visitorId - visitorID
 * @property {string} channelID - channelID
 * @return {LogObject<widgetVidBuySuccessParams>} LogObject<widgetVidBuySuccessParams>
 */
export function widgetVidBuySuccess(params) {
    return { evid: 221, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetVidInfoDisplayed' event (evid: 222)
 *
 * Event description: Info butten displayed
 *
 * @param {widgetVidInfoDisplayedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitorID
 * @property {string} channelID - channelID
 * @return {LogObject<widgetVidInfoDisplayedParams>} LogObject<widgetVidInfoDisplayedParams>
 */
export function widgetVidInfoDisplayed(params) {
    return { evid: 222, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetVidInfoClicked' event (evid: 223)
 *
 * Event description: Info butten clicked
 *
 * @param {widgetVidInfoClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - on_site/embed
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitorID
 * @property {string} siteUrl - site url (only when embed video)
 * @property {string} channelID - channelID
 * @return {LogObject<widgetVidInfoClickedParams>} LogObject<widgetVidInfoClickedParams>
 */
export function widgetVidInfoClicked(params) {
    return { evid: 223, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetVidShareDisplayed' event (evid: 224)
 *
 * Event description: Share buttens displayed
 *
 * @param {widgetVidShareDisplayedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - on_site/embed
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitorID
 * @property {string} siteUrl - site url (only when embed video)
 * @property {string} channelID - channelID
 * @return {LogObject<widgetVidShareDisplayedParams>} LogObject<widgetVidShareDisplayedParams>
 */
export function widgetVidShareDisplayed(params) {
    return { evid: 224, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetVidShareClicked' event (evid: 225)
 *
 * Event description: Share butten clicked
 *
 * @param {widgetVidShareClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {string} button - facebook/twitter/pinterest/tumblr/link
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - on_site/embed
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitorID
 * @property {string} shareType - video/channel
 * @property {string} siteUrl - site url (only when embed video)
 * @property {string} channelID - channelID
 * @return {LogObject<widgetVidShareClickedParams>} LogObject<widgetVidShareClickedParams>
 */
export function widgetVidShareClicked(params) {
    return { evid: 225, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetVidFullScreenClicked' event (evid: 226)
 *
 * Event description: Full screen butten clicked
 *
 * @param {widgetVidFullScreenClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {string} correlationId - ID for one unique view connection
 * @property {string} videoType - live/upload/youtube/vimeo/facebook
 * @property {GUID} _visitorId - visitorID
 * @property {string} channelID - channelID
 * @return {LogObject<widgetVidFullScreenClickedParams>} LogObject<widgetVidFullScreenClickedParams>
 */
export function widgetVidFullScreenClicked(params) {
    return { evid: 226, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetVidCancelBuyCompleted' event (evid: 227)
 *
 * Event description: Cancel buying from Paypal
 *
 * @param {widgetVidCancelBuyCompletedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {number} price - doubled by 10000
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} buyType - buy/rent/buyFrom
 * @property {GUID} orderid - orderId
 * @property {string} compId - player_id
 * @property {string} currency - currency
 * @property {GUID} _visitorId - visitorID
 * @property {string} channelID - channelID
 * @return {LogObject<widgetVidCancelBuyCompletedParams>} LogObject<widgetVidCancelBuyCompletedParams>
 */
export function widgetVidCancelBuyCompleted(params) {
    return { evid: 227, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetExploreThisChannelClicked' event (evid: 228)
 *
 * Event description: Explore this channel click from widget on the mobile site
 *
 * @param {widgetExploreThisChannelClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitorID
 * @property {string} channelID - channelID
 * @return {LogObject<widgetExploreThisChannelClickedParams>} LogObject<widgetExploreThisChannelClickedParams>
 */
export function widgetExploreThisChannelClicked(params) {
    return { evid: 228, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetVidError' event (evid: 229)
 *
 * Event description: Error state display on video
 *
 * @param {widgetVidErrorParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} errorType - Video is not available/Video is processing
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - on_site/embed
 * @property {string} compId - player_id
 * @property {string} correlationId - ID for one unique view connection
 * @property {GUID} _visitorId - visitorID
 * @property {string} siteUrl - site url (only when embed video)
 * @property {string} channelID - channelID
 * @return {LogObject<widgetVidErrorParams>} LogObject<widgetVidErrorParams>
 */
export function widgetVidError(params) {
    return { evid: 229, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetActionBarOpenClick' event (evid: 231)
 *
 * Event description: UoU click on "hamburger" to open action bar
 *
 * @param {widgetActionBarOpenClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitorID
 * @property {string} channelID - channel id
 * @return {LogObject<widgetActionBarOpenClickParams>} LogObject<widgetActionBarOpenClickParams>
 */
export function widgetActionBarOpenClick(params) {
    return { evid: 231, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetAction' event (evid: 232)
 *
 * Event description: Common Event for all UoU actions in widget
 *
 * @param {widgetActionParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - instance_id
 * @property {GUID} _msid - msid
 * @property {string} eventName - [Namespace].[UI type].[Action type]
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - instance_id
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitorID
 * @return {LogObject<widgetActionParams>} LogObject<widgetActionParams>
 */
export function widgetAction(params) {
    return { evid: 232, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'playerDebugInfo' event (evid: 233)
 *
 * Event description: New Video Player debug system
 *
 * @param {playerDebugInfoParams} params - The parameters for this event
 * @property {GUID} biToken - biToken
 * @property {GUID} videoInstanceID - videoInstanceID
 * @property {GUID} _msid - biToken
 * @property {number} duration - duration of full video in ms
 * @property {number} bitrate - Bitrate
 * @property {string} videoUrl - Url of video source
 * @property {GUID} visitorID - visitorID
 * @property {number} viewportWidth - Width of video viewport
 * @property {GUID} _appId - app_id
 * @property {string} videoID - ID of video in terms of Wix VOD
 * @property {string} user_agent - user_agent
 * @property {number} avgBandwidth - avg bandwidth
 * @property {GUID} _instanceId - videoInstanceID
 * @property {string} _viewMode - view_mode
 * @property {number} videoWidth - Actual width of video source
 * @property {string} deliveryType - Delivery type of stream(native, library, etc)
 * @property {GUID} _siteMemberId - site_member_id
 * @property {boolean} isAutoplay - If video start autoplay or user click on play
 * @property {number} viewportHeight - Height of video viewport
 * @property {string} compId - compId
 * @property {string} correlationId - ID for one unique view connection
 * @property {boolean} isLive - Ind if the video is live
 * @property {string} timeFrame - The time in the video we shoot this event (Not the time the user see the movie)
 * @property {number} videoHeight - Actual height of video source
 * @property {string} videoType - Type of video source
 * @property {boolean} isEmbed - Ind if the video embedded
 * @property {GUID} _visitorId - visitorID
 * @property {string} siteUrl - site url (only when embed video)
 * @property {string} channelID - Channel ID
 * @return {LogObject<playerDebugInfoParams>} LogObject<playerDebugInfoParams>
 */
export function playerDebugInfo(params) {
    return { evid: 233, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetVidFullScreenEntered' event (evid: 234)
 *
 * Event description: User entered (see) video in full screen
 *
 * @param {widgetVidFullScreenEnteredParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - on_site/embed
 * @property {string} compId - player_id
 * @property {string} correlationId - ID for one unique view connection
 * @property {GUID} _visitorId - visitorID
 * @property {string} siteUrl - site url (only when embed video)
 * @property {string} channelID - channelID
 * @return {LogObject<widgetVidFullScreenEnteredParams>} LogObject<widgetVidFullScreenEnteredParams>
 */
export function widgetVidFullScreenEntered(params) {
    return { evid: 234, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetLogOutClicked' event (evid: 235)
 *
 * Event description: logOut button clicked
 *
 * @param {widgetLogOutClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitorID
 * @return {LogObject<widgetLogOutClickedParams>} LogObject<widgetLogOutClickedParams>
 */
export function widgetLogOutClicked(params) {
    return { evid: 235, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetPaymentProviderClicked' event (evid: 236)
 *
 * Event description: Click on payment method button in proceed to check out window
 *
 * @param {widgetPaymentProviderClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {number} price - price
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} buyType - buy/rent/subscription
 * @property {string} compId - player_id
 * @property {string} paymentProvider - pay_pal/credit_card/alipay etc.
 * @property {string} currency - currency
 * @property {GUID} _visitorId - visitorID
 * @property {string} channelID - channel id
 * @return {LogObject<widgetPaymentProviderClickedParams>} LogObject<widgetPaymentProviderClickedParams>
 */
export function widgetPaymentProviderClicked(params) {
    return { evid: 236, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetCommentsToggleUploadedVideosClick' event (evid: 237)
 *
 * Event description: Click on "On uploaded videos" toggle on Comments tab in app setting
 *
 * @param {appSetCommentsToggleUploadedVideosClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {boolean} isSingleVideo - true for single / false for channel
 * @property {boolean} isEnabled - Comments on/off on uploaded videos
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetCommentsToggleUploadedVideosClickParams>} LogObject<appSetCommentsToggleUploadedVideosClickParams>
 */
export function appSetCommentsToggleUploadedVideosClick(params) {
    return { evid: 237, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetCommentsToggleLiveStreamCommentsClick' event (evid: 238)
 *
 * Event description: Click on "On live streams" toggle on Comments tab in app setting
 *
 * @param {appSetCommentsToggleLiveStreamCommentsClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {boolean} isSingleVideo - true for single / false for channel
 * @property {boolean} isEnabled - Comments on/off on live streams
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetCommentsToggleLiveStreamCommentsClickParams>} LogObject<appSetCommentsToggleLiveStreamCommentsClickParams>
 */
export function appSetCommentsToggleLiveStreamCommentsClick(params) {
    return { evid: 238, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetCommentsLearnMoreClick' event (evid: 239)
 *
 * Event description: Click on "Learn more" on Comments tab in app setting
 *
 * @param {appSetCommentsLearnMoreClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {boolean} isSingleVideo - true for single / false for channel
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetCommentsLearnMoreClickParams>} LogObject<appSetCommentsLearnMoreClickParams>
 */
export function appSetCommentsLearnMoreClick(params) {
    return { evid: 239, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetEmbedLoaded' event (evid: 240)
 *
 * Event description: widget from embed site loaded
 *
 * @param {widgetEmbedLoadedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {number} videoWidth - Actual width of video source
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {number} videoHeight - Actual height of video source
 * @property {GUID} _visitorId - visitorID
 * @property {string} siteUrl - site url (only when embed video)
 * @property {string} channelID - channelID
 * @return {LogObject<widgetEmbedLoadedParams>} LogObject<widgetEmbedLoadedParams>
 */
export function widgetEmbedLoaded(params) {
    return { evid: 240, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetEmbedOpened' event (evid: 241)
 *
 * Event description: Video embed widget opened
 *
 * @param {widgetEmbedOpenedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {string} trailerType - preview/trailer
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {number} videoWidth - Actual width of video source
 * @property {number} loadingTime - loading time
 * @property {boolean} overQuoted - is video id under OverQuota, true / false
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {string} buyTypeDisplayed - rent/buyFrom/buy/none
 * @property {number} videoHeight - Actual height of video source
 * @property {GUID} _visitorId - visitorID
 * @property {string} siteUrl - site url (only when embed video)
 * @property {string} channelID - channelID
 * @return {LogObject<widgetEmbedOpenedParams>} LogObject<widgetEmbedOpenedParams>
 */
export function widgetEmbedOpened(params) {
    return { evid: 241, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetEmbedVidPlayClicked' event (evid: 242)
 *
 * Event description: play video clicked
 *
 * @param {widgetEmbedVidPlayClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitor_id
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {number} videoWidth - Actual width of video source
 * @property {boolean} overQuoted - is video id under OverQuota, true / false
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {string} correlationId - ID for one unique view connection
 * @property {number} videoHeight - Actual height of video source
 * @property {string} videoType - facebook/youtube/computer/vimeo
 * @property {GUID} _visitorId - visitor_id
 * @property {string} siteUrl - site url (only when embed video)
 * @property {string} channelID - channelID
 * @return {LogObject<widgetEmbedVidPlayClickedParams>} LogObject<widgetEmbedVidPlayClickedParams>
 */
export function widgetEmbedVidPlayClicked(params) {
    return { evid: 242, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetEmbedVidStartPlay' event (evid: 243)
 *
 * Event description: when video start play after user click (242)
 *
 * @param {widgetEmbedVidStartPlayParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - instance_id
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - instance_id
 * @property {string} _viewMode - view_mode
 * @property {number} videoWidth - Actual width of video source
 * @property {GUID} _siteMemberId - site_member_id
 * @property {boolean} isAutoplay - If video start autoplay or user click on play
 * @property {string} compId - player_id
 * @property {string} correlationId - ID for one unique view connection
 * @property {number} videoHeight - Actual height of video source
 * @property {string} videoType - computer/vimeo/facebook/youtube
 * @property {GUID} _visitorId - visitorID
 * @property {string} siteUrl - site url (only when embed video)
 * @property {string} channelID - channelID
 * @return {LogObject<widgetEmbedVidStartPlayParams>} LogObject<widgetEmbedVidStartPlayParams>
 */
export function widgetEmbedVidStartPlay(params) {
    return { evid: 243, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'playerError' event (evid: 244)
 *
 * Event description: New Video Player error system
 *
 * @param {playerErrorParams} params - The parameters for this event
 * @property {GUID} biToken - biToken
 * @property {GUID} videoInstanceID - videoInstanceID
 * @property {GUID} _msid - biToken
 * @property {string} streamType - Type of stream
 * @property {string} videoUrl - Url of video source
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} videoID - ID of video in terms of Wix VOD
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - videoInstanceID
 * @property {string} errorType - Type of error
 * @property {string} _viewMode - view_mode
 * @property {string} streamProvider - Provider of stream
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - compId
 * @property {string} correlationId - ID for one unique view connection
 * @property {boolean} isLive - Ind if the video is live
 * @property {boolean} isEmbed - Ind if the video embedded
 * @property {GUID} _visitorId - visitorID
 * @return {LogObject<playerErrorParams>} LogObject<playerErrorParams>
 */
export function playerError(params) {
    return { evid: 244, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'playerPlayRequested' event (evid: 245)
 *
 * Event description: Video player play requested
 *
 * @param {playerPlayRequestedParams} params - The parameters for this event
 * @property {GUID} biToken - biToken
 * @property {GUID} videoInstanceID - videoInstaceID
 * @property {GUID} _msid - biToken
 * @property {string} videoUrl - Url of video
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} videoID - ID of video in terms of Wix VOD
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - videoInstaceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {boolean} isAutoplay - If video start autoplay or user click on play
 * @property {string} compId - compId
 * @property {string} correlationId - one unique view
 * @property {GUID} _visitorId - visitorID
 * @property {string} siteUrl - site_url when embed
 * @property {string} channelID - channelID
 * @return {LogObject<playerPlayRequestedParams>} LogObject<playerPlayRequestedParams>
 */
export function playerPlayRequested(params) {
    return { evid: 245, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'playerPlayDone' event (evid: 246)
 *
 * Event description: Video player playing
 *
 * @param {playerPlayDoneParams} params - The parameters for this event
 * @property {GUID} biToken - biToken
 * @property {GUID} videoInstanceID - videoInstaceID
 * @property {GUID} _msid - biToken
 * @property {string} videoUrl - Url of video
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} videoID - ID of video in term of Wix VOD
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - videoInstaceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {boolean} isAutoplay - If video start autoplay or user click on play
 * @property {string} compId - compId
 * @property {string} correlationId - one uniq view
 * @property {GUID} _visitorId - visitorID
 * @property {string} siteUrl - site_url when embed
 * @property {string} channelID - channelID
 * @return {LogObject<playerPlayDoneParams>} LogObject<playerPlayDoneParams>
 */
export function playerPlayDone(params) {
    return { evid: 246, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetShareEmbedCopyClicked' event (evid: 247)
 *
 * Event description: click on copy in widget.share.embed
 *
 * @param {widgetShareEmbedCopyClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - on_site/embed
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitorID
 * @property {string} shareType - video/channel
 * @property {string} siteUrl - site url (only when embed video)
 * @property {string} channelID - channelID
 * @return {LogObject<widgetShareEmbedCopyClickedParams>} LogObject<widgetShareEmbedCopyClickedParams>
 */
export function widgetShareEmbedCopyClicked(params) {
    return { evid: 247, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetVideosChannelCreateNewChannelClick' event (evid: 248)
 *
 * Event description: When user click on create a new channel from appSet.videos.channels
 *
 * @param {appSetVideosChannelCreateNewChannelClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - classic, strip or compact
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account, editor, ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetVideosChannelCreateNewChannelClickParams>} LogObject<appSetVideosChannelCreateNewChannelClickParams>
 */
export function appSetVideosChannelCreateNewChannelClick(params) {
    return { evid: 248, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetVideoCardsCardClick' event (evid: 249)
 *
 * Event description: UoU clicking on action in card
 *
 * @param {widgetVideoCardsCardClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - instance_id
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {string} socialNetwork - If it's increase social card Facebook/YouTube/Twitter
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - instance_id
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - video/all_cards
 * @property {string} compId - player_id
 * @property {string} cardName - promote_video/promote_channel/get_social_followers/boost_sales/custom_text
 * @property {GUID} _visitorId - visitorID
 * @property {string} siteUrl - site url when video embeded
 * @return {LogObject<widgetVideoCardsCardClickParams>} LogObject<widgetVideoCardsCardClickParams>
 */
export function widgetVideoCardsCardClick(params) {
    return { evid: 249, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boStatsTabClicked' event (evid: 25)
 *
 * Event description: Clicking on tab QuickStats/Channels/Videos in the stats page
 *
 * @param {boStatsTabClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - ADI / editor / МА
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} newTabName - QuickStats/Channels/Videos
 * @return {LogObject<boStatsTabClickedParams>} LogObject<boStatsTabClickedParams>
 */
export function boStatsTabClicked(params) {
    return { evid: 25, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetVideoCardsCardCloseClick' event (evid: 250)
 *
 * Event description: UoU click close on card
 *
 * @param {widgetVideoCardsCardCloseClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - instance_id
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - instance_id
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {string} cardName - promote_video/promote_channel/get_social_followers/boost_sales/custom_text
 * @property {GUID} _visitorId - visitorID
 * @property {string} siteUrl - site url when video embeded
 * @return {LogObject<widgetVideoCardsCardCloseClickParams>} LogObject<widgetVideoCardsCardCloseClickParams>
 */
export function widgetVideoCardsCardCloseClick(params) {
    return { evid: 250, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetVideoCardsAllCardsOpenClick' event (evid: 251)
 *
 * Event description: UoU click on 4th button on video
 *
 * @param {widgetVideoCardsAllCardsOpenClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - instance_id
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - instance_id
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitorID
 * @property {string} siteUrl - site url when video embeded
 * @return {LogObject<widgetVideoCardsAllCardsOpenClickParams>} LogObject<widgetVideoCardsAllCardsOpenClickParams>
 */
export function widgetVideoCardsAllCardsOpenClick(params) {
    return { evid: 251, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetDefaultChCreated' event (evid: 252)
 *
 * Event description: Default channel in widget created automatically after adding a first video
 *
 * @param {widgetDefaultChCreatedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - editor / ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channel_id
 * @return {LogObject<widgetDefaultChCreatedParams>} LogObject<widgetDefaultChCreatedParams>
 */
export function widgetDefaultChCreated(params) {
    return { evid: 252, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetVideoCardsAllCardsCloseClick' event (evid: 253)
 *
 * Event description: UoU click close on  4th button overlay
 *
 * @param {widgetVideoCardsAllCardsCloseClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - instance_id
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - instance_id
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitorID
 * @property {string} siteUrl - site url when video embeded
 * @return {LogObject<widgetVideoCardsAllCardsCloseClickParams>} LogObject<widgetVideoCardsAllCardsCloseClickParams>
 */
export function widgetVideoCardsAllCardsCloseClick(params) {
    return { evid: 253, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLibAddLivestreamButtonClick' event (evid: 255)
 *
 * Event description: User clicks on +Livestream button in a library (which opens Livestream tab)
 *
 * @param {boLibAddLivestreamButtonClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLibAddLivestreamButtonClickParams>} LogObject<boLibAddLivestreamButtonClickParams>
 */
export function boLibAddLivestreamButtonClick(params) {
    return { evid: 255, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetLoadComplete' event (evid: 257)
 *
 * Event description: widget.loadComplete
 *
 * @param {widgetLoadCompleteParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} viewMode - editor/viewer
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - editor/viewer
 * @property {number} loadingTime - in ms
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitorID
 * @return {LogObject<widgetLoadCompleteParams>} LogObject<widgetLoadCompleteParams>
 */
export function widgetLoadComplete(params) {
    return { evid: 257, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boChEditVideoPricingSelect' event (evid: 259)
 *
 * Event description: user select free, pricing plan or subs option in Cannel Settings
 *
 * @param {boChEditVideoPricingSelectParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - player_id
 * @property {string} target - free/pp/subs
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channelID
 * @return {LogObject<boChEditVideoPricingSelectParams>} LogObject<boChEditVideoPricingSelectParams>
 */
export function boChEditVideoPricingSelect(params) {
    return { evid: 259, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boSettingsPayPalDisconnectClicked' event (evid: 26)
 *
 * Event description: Clicking on the disconnect paypal button
 *
 * @param {boSettingsPayPalDisconnectClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boSettingsPayPalDisconnectClickedParams>} LogObject<boSettingsPayPalDisconnectClickedParams>
 */
export function boSettingsPayPalDisconnectClicked(params) {
    return { evid: 26, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boChEditVideoPricingActionsClick' event (evid: 260)
 *
 * Event description: bo.chEdit.VideoPricing.actions.click
 *
 * @param {boChEditVideoPricingActionsClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {string} selection - on / off
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - player_id
 * @property {string} target - add_plan / disable_single_video_purchase
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channelID
 * @return {LogObject<boChEditVideoPricingActionsClickParams>} LogObject<boChEditVideoPricingActionsClickParams>
 */
export function boChEditVideoPricingActionsClick(params) {
    return { evid: 260, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boChEditPricingPlanConnected' event (evid: 261)
 *
 * Event description: user connected pricing plan  in Channel Settings, but not saved yet
 *
 * @param {boChEditPricingPlanConnectedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {string} planIDs - plan_id
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channelID
 * @return {LogObject<boChEditPricingPlanConnectedParams>} LogObject<boChEditPricingPlanConnectedParams>
 */
export function boChEditPricingPlanConnected(params) {
    return { evid: 261, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetSettingsShowVideoTitleChanged' event (evid: 262)
 *
 * Event description: User toggles to show Video title
 *
 * @param {appSetSettingsShowVideoTitleChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - small_slider/big_slider
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {boolean} isEnabled - on / off
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetSettingsShowVideoTitleChangedParams>} LogObject<appSetSettingsShowVideoTitleChangedParams>
 */
export function appSetSettingsShowVideoTitleChanged(params) {
    return { evid: 262, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'mobileAppSetLoadStarted' event (evid: 263)
 *
 * Event description: The existing appSet.opened (evid=100) event sends when the app starts (aka js inits), this one would send right from the html load
 *
 * @param {mobileAppSetLoadStartedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - editorMode
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<mobileAppSetLoadStartedParams>} LogObject<mobileAppSetLoadStartedParams>
 */
export function mobileAppSetLoadStarted(params) {
    return { evid: 263, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'mobileAppSetLoadFinished' event (evid: 264)
 *
 * Event description: Mobile app settings load start
 *
 * @param {mobileAppSetLoadFinishedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - classic/strip/compact
 * @property {boolean} success - t / f
 * @property {boolean} isFirst - first time open the app settings
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - editorMode
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {number} loading_time - loading time
 * @return {LogObject<mobileAppSetLoadFinishedParams>} LogObject<mobileAppSetLoadFinishedParams>
 */
export function mobileAppSetLoadFinished(params) {
    return { evid: 264, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boPopUpShown' event (evid: 265)
 *
 * Event description: any pop up shoown
 *
 * @param {boPopUpShownParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - player_id
 * @property {string} message - old_subs_to_free etc
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channelID
 * @return {LogObject<boPopUpShownParams>} LogObject<boPopUpShownParams>
 */
export function boPopUpShown(params) {
    return { evid: 265, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetMenuClicked' event (evid: 266)
 *
 * Event description: Click on layout menu (3 dots) from widget
 *
 * @param {widgetMenuClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitorID
 * @property {string} channelID - channel
 * @return {LogObject<widgetMenuClickedParams>} LogObject<widgetMenuClickedParams>
 */
export function widgetMenuClicked(params) {
    return { evid: 266, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boPopUpClick' event (evid: 267)
 *
 * Event description: click in any pop up
 *
 * @param {boPopUpClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - player_id
 * @property {string} choice - yes / no
 * @property {string} message - old_subs_to_free etc
 * @property {string} target - continue / close
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channelID
 * @return {LogObject<boPopUpClickParams>} LogObject<boPopUpClickParams>
 */
export function boPopUpClick(params) {
    return { evid: 267, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boPricingPlanSectionPricingPlanchannelsSettings' event (evid: 268)
 *
 * Event description: "save" in Pricing Plan settings - only when user connected video channel to one of the pricing plans
 *
 * @param {boPricingPlanSectionPricingPlanchannelsSettingsParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {string} planIDs - list of plan_id
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channelID
 * @return {LogObject<boPricingPlanSectionPricingPlanchannelsSettingsParams>} LogObject<boPricingPlanSectionPricingPlanchannelsSettingsParams>
 */
export function boPricingPlanSectionPricingPlanchannelsSettings(params) {
    return { evid: 268, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetPlayerAutoplayChanged' event (evid: 269)
 *
 * Event description: User changes Autoplay toggle in App settings
 *
 * @param {appSetPlayerAutoplayChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - instance_id
 * @property {GUID} _msid - msid
 * @property {string} layoutType - compact / strip etc
 * @property {boolean} toggle - on / off
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - instance_id
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetPlayerAutoplayChangedParams>} LogObject<appSetPlayerAutoplayChangedParams>
 */
export function appSetPlayerAutoplayChanged(params) {
    return { evid: 269, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLibVidArrowClicked' event (evid: 270)
 *
 * Event description: Click on navigation arrows on video edit page
 *
 * @param {boLibVidArrowClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} source - youtube/vimeo/facebook/computer/live
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {string} button - next / previous
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLibVidArrowClickedParams>} LogObject<boLibVidArrowClickedParams>
 */
export function boLibVidArrowClicked(params) {
    return { evid: 270, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boChEditVidEdit' event (evid: 271)
 *
 * Event description: User clicks on edit video from channel edit page
 *
 * @param {boChEditVidEditParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} source - computer / live / youtube / vimeo etc
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {string} button - button / double_click
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {boolean} overQuoted - is video id under OverQuota, true / false
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channelID
 * @return {LogObject<boChEditVidEditParams>} LogObject<boChEditVidEditParams>
 */
export function boChEditVidEdit(params) {
    return { evid: 271, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetEmbedVidPlayed' event (evid: 272)
 *
 * Event description: Embedded Video played
 *
 * @param {widgetEmbedVidPlayedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {number} duration - duration of full video in ms
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {boolean} isAutoplay - If video start autoplay or user click on play
 * @property {string} compId - player_id
 * @property {string} correlationId - ID for one unique view connection
 * @property {boolean} isLive - If video is live
 * @property {string} videoType - computer/vimeo/facebook/youtube
 * @property {GUID} _visitorId - visitorID
 * @property {string} siteUrl - site url (only when embed video)
 * @property {string} channelID - channelID
 * @return {LogObject<widgetEmbedVidPlayedParams>} LogObject<widgetEmbedVidPlayedParams>
 */
export function widgetEmbedVidPlayed(params) {
    return { evid: 272, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boSettingsCurrencyChanged' event (evid: 28)
 *
 * Event description: Changing difolt currency
 *
 * @param {boSettingsCurrencyChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {boolean} isSiteBased - true - if VOD2, false - user-based (VOD1)
 * @property {boolean} isFirst - first time paypal connection made
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {string} currency - new defined currency
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boSettingsCurrencyChangedParams>} LogObject<boSettingsCurrencyChangedParams>
 */
export function boSettingsCurrencyChanged(params) {
    return { evid: 28, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetVideoAutoplayStart' event (evid: 280)
 *
 * Event description: When video autoplay start to play
 *
 * @param {widgetVideoAutoplayStartParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - instance_id
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - instance_id
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - on_site/embed
 * @property {string} compId - player_id
 * @property {string} videoType - live/upload/youtube/vimeo/facebook
 * @property {GUID} _visitorId - visitorID
 * @property {string} siteUrl - site url (only when embed video)
 * @property {string} channelID - channelID
 * @return {LogObject<widgetVideoAutoplayStartParams>} LogObject<widgetVideoAutoplayStartParams>
 */
export function widgetVideoAutoplayStart(params) {
    return { evid: 280, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetLiveVideoEnded' event (evid: 281)
 *
 * Event description: When Live video ends
 *
 * @param {widgetLiveVideoEndedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - instance_id
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - instance_id
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - on_site/embed
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitorID
 * @property {string} siteUrl - site url (only when embed video)
 * @property {string} channelID - channelID
 * @return {LogObject<widgetLiveVideoEndedParams>} LogObject<widgetLiveVideoEndedParams>
 */
export function widgetLiveVideoEnded(params) {
    return { evid: 281, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetPollRequestSent' event (evid: 282)
 *
 * Event description: When we send poll request to see if live video started
 *
 * @param {widgetPollRequestSentParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - instance_id
 * @property {GUID} _msid - msid
 * @property {boolean} isError - If we recive error from request
 * @property {string} errorMessage - error message
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - instance_id
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - on_site/embed
 * @property {string} compId - player_id
 * @property {string} videoType - live/scheduale
 * @property {GUID} _visitorId - visitorID
 * @property {string} siteUrl - site url (only when embed video)
 * @property {string} channelID - channelID
 * @return {LogObject<widgetPollRequestSentParams>} LogObject<widgetPollRequestSentParams>
 */
export function widgetPollRequestSent(params) {
    return { evid: 282, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetVidNewCommentAdded' event (evid: 283)
 *
 * Event description: user of user added new comment to Annoto video widget. triggered by orange pimple appearance
 *
 * @param {widgetVidNewCommentAddedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} source - live/computer/drive/dropbox
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {boolean} isSingleVideo - true for single / false for channel
 * @property {GUID} _visitorId - visitorID
 * @property {string} channelID - channelID
 * @return {LogObject<widgetVidNewCommentAddedParams>} LogObject<widgetVidNewCommentAddedParams>
 */
export function widgetVidNewCommentAdded(params) {
    return { evid: 283, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetDownloadVideoClicked' event (evid: 284)
 *
 * Event description: UoU clicked on download video button
 *
 * @param {widgetDownloadVideoClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {number} duration - video duration in ms
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {boolean} isLive - If video is live
 * @property {string} videoType - free/purchased
 * @property {GUID} _visitorId - visitorID
 * @property {string} channelID - channelID
 * @return {LogObject<widgetDownloadVideoClickedParams>} LogObject<widgetDownloadVideoClickedParams>
 */
export function widgetDownloadVideoClicked(params) {
    return { evid: 284, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetVidShowCommentShown' event (evid: 285)
 *
 * Event description: Show comment site bar (Annoto)
 *
 * @param {widgetVidShowCommentShownParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} source - live/computer/drive/dropbox
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {boolean} isShown - when shown is true / else false
 * @property {boolean} isSingleVideo - true for single / false for channel
 * @property {GUID} _visitorId - visitorID
 * @property {string} channelID - channelID
 * @return {LogObject<widgetVidShowCommentShownParams>} LogObject<widgetVidShowCommentShownParams>
 */
export function widgetVidShowCommentShown(params) {
    return { evid: 285, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetVidCommentsLoginRequested' event (evid: 286)
 *
 * Event description: Clicked on "Get the conversation started" in comments (Annoto) and all other logins
 *
 * @param {widgetVidCommentsLoginRequestedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} source - live/computer/drive/dropbox
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {boolean} isSingleVideo - true for single / false for channel
 * @property {GUID} _visitorId - visitorID
 * @property {string} channelID - channelID
 * @return {LogObject<widgetVidCommentsLoginRequestedParams>} LogObject<widgetVidCommentsLoginRequestedParams>
 */
export function widgetVidCommentsLoginRequested(params) {
    return { evid: 286, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boSettingsDefaultPriceOpen' event (evid: 29)
 *
 * Event description: Clicking difolt price
 *
 * @param {boSettingsDefaultPriceOpenParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boSettingsDefaultPriceOpenParams>} LogObject<boSettingsDefaultPriceOpenParams>
 */
export function boSettingsDefaultPriceOpen(params) {
    return { evid: 29, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetChooseChannelChanged' event (evid: 3)
 *
 * Event description: Choosing a channel from the channel list drop down
 *
 * @param {appSetChooseChannelChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - compact/strip/classic
 * @property {string} channelType - channel/youtube-feed
 * @property {boolean} isFirst - first time choosing a channel
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - editor / ADI (null is editor)
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channel_id
 * @return {LogObject<appSetChooseChannelChangedParams>} LogObject<appSetChooseChannelChangedParams>
 */
export function appSetChooseChannelChanged(params) {
    return { evid: 3, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boSettingsDefaultPriceCancelButtonClicked' event (evid: 30)
 *
 * Event description: Clicking cancel in default price edit
 *
 * @param {boSettingsDefaultPriceCancelButtonClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boSettingsDefaultPriceCancelButtonClickedParams>} LogObject<boSettingsDefaultPriceCancelButtonClickedParams>
 */
export function boSettingsDefaultPriceCancelButtonClicked(params) {
    return { evid: 30, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetPlayerShowVideoListChanged' event (evid: 300)
 *
 * Event description: User change in appSet.player "show video list"  toggle
 *
 * @param {appSetPlayerShowVideoListChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - classic/strip/compact
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {boolean} isEnabled - toggle on/off
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetPlayerShowVideoListChangedParams>} LogObject<appSetPlayerShowVideoListChangedParams>
 */
export function appSetPlayerShowVideoListChanged(params) {
    return { evid: 300, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetPlayerShowChannelTitleChanged' event (evid: 301)
 *
 * Event description: User change in appSet.player "show channel title"  toggle
 *
 * @param {appSetPlayerShowChannelTitleChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - classic/strip/compact
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {boolean} isEnabled - toggle on/off
 * @property {string} type - before_playing / while_playing / around_the_player
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetPlayerShowChannelTitleChangedParams>} LogObject<appSetPlayerShowChannelTitleChangedParams>
 */
export function appSetPlayerShowChannelTitleChanged(params) {
    return { evid: 301, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetPlayerShowSignInChanged' event (evid: 302)
 *
 * Event description: User change in appSet.player "show sign in"  toggle
 *
 * @param {appSetPlayerShowSignInChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - classic/strip/compact
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {boolean} isEnabled - toggle on/off
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetPlayerShowSignInChangedParams>} LogObject<appSetPlayerShowSignInChangedParams>
 */
export function appSetPlayerShowSignInChanged(params) {
    return { evid: 302, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetVideosSelectWhatToPlayChanged' event (evid: 304)
 *
 * Event description: When user choose which type of video to play in player (single/channel)
 *
 * @param {appSetVideosSelectWhatToPlayChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {string} selection - single_video/channel
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetVideosSelectWhatToPlayChangedParams>} LogObject<appSetVideosSelectWhatToPlayChangedParams>
 */
export function appSetVideosSelectWhatToPlayChanged(params) {
    return { evid: 304, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetVideosSingleVideoSelected' event (evid: 305)
 *
 * Event description: When user choose which single video he want to present in player
 *
 * @param {appSetVideosSingleVideoSelectedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetVideosSingleVideoSelectedParams>} LogObject<appSetVideosSingleVideoSelectedParams>
 */
export function appSetVideosSingleVideoSelected(params) {
    return { evid: 305, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetVideosSingleVideoAddNewVideoClick' event (evid: 306)
 *
 * Event description: When user choose click on add new video from appSet.singleVideo
 *
 * @param {appSetVideosSingleVideoAddNewVideoClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetVideosSingleVideoAddNewVideoClickParams>} LogObject<appSetVideosSingleVideoAddNewVideoClickParams>
 */
export function appSetVideosSingleVideoAddNewVideoClick(params) {
    return { evid: 306, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetMainChooseVideoClicked' event (evid: 307)
 *
 * Event description: Clicking on "Choose Video" in app settings
 *
 * @param {appSetMainChooseVideoClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - classic, strip or compact
 * @property {boolean} isFirst - first time clicking on Choose Video
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - 'my_account' | 'editor' | 'ADI'
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetMainChooseVideoClickedParams>} LogObject<appSetMainChooseVideoClickedParams>
 */
export function appSetMainChooseVideoClicked(params) {
    return { evid: 307, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetLayoutShowNavigArrowsChanged' event (evid: 308)
 *
 * Event description: Users changes "Show navigation arrows" (slider layout)
 *
 * @param {appSetLayoutShowNavigArrowsChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - small_slider/big_slider
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {string} selection - on_hover / always
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetLayoutShowNavigArrowsChangedParams>} LogObject<appSetLayoutShowNavigArrowsChangedParams>
 */
export function appSetLayoutShowNavigArrowsChanged(params) {
    return { evid: 308, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetLayoutArrowsPositionChanged' event (evid: 309)
 *
 * Event description: Users changes "Arrows position" (slider layout)
 *
 * @param {appSetLayoutArrowsPositionChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - small_slider/big_slider
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {string} selection - on / outside
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetLayoutArrowsPositionChangedParams>} LogObject<appSetLayoutArrowsPositionChangedParams>
 */
export function appSetLayoutArrowsPositionChanged(params) {
    return { evid: 309, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boSettingsDefaultPriceSaveButtonClicked' event (evid: 31)
 *
 * Event description: Clicking save in default price edit
 *
 * @param {boSettingsDefaultPriceSaveButtonClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {boolean} rentalPeriodChange - did the rental period changed
 * @property {number} purchasePricinig - the price for purchase doubled by 10000
 * @property {string} rentalPeriod - 24/48/72
 * @property {boolean} isDownload - if uou can download the video
 * @property {boolean} purchasableChange - did the purchase option changed
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {number} rentalPricinig - the price of renting  doubled by 10000
 * @property {boolean} downloadChanged - If user changed the download option
 * @property {GUID} _instanceId - InstanceID
 * @property {boolean} purchasePricinigChange - did the rental purchase changed
 * @property {string} _viewMode - view_mode
 * @property {boolean} rentalPricinigChange - did the rental price changed
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {string} pricingSelection - free/paid
 * @property {boolean} isPurchasable - is the videos for purchase
 * @property {boolean} isRental - is the videos for rental
 * @property {boolean} rentalChange - did the rental option changed
 * @property {GUID} _visitorId - visitor_id
 * @property {boolean} pricingSelectionChange - did the pricing selection changed
 * @return {LogObject<boSettingsDefaultPriceSaveButtonClickedParams>} LogObject<boSettingsDefaultPriceSaveButtonClickedParams>
 */
export function boSettingsDefaultPriceSaveButtonClicked(params) {
    return { evid: 31, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetShowTitleAndPublisherChanged' event (evid: 310)
 *
 * Event description: User change in appSet(currently only in ADI) the "Title & Publisher" button
 *
 * @param {appSetShowTitleAndPublisherChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - classic/strip/compact
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {boolean} isEnabled - toggle on/off
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetShowTitleAndPublisherChangedParams>} LogObject<appSetShowTitleAndPublisherChangedParams>
 */
export function appSetShowTitleAndPublisherChanged(params) {
    return { evid: 310, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetLayoutVideosInRowChanged' event (evid: 311)
 *
 * Event description: User change in appSet the number of videos in row
 *
 * @param {appSetLayoutVideosInRowChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - classic/strip/compact
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {string} selection - 2,3,4
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetLayoutVideosInRowChangedParams>} LogObject<appSetLayoutVideosInRowChangedParams>
 */
export function appSetLayoutVideosInRowChanged(params) {
    return { evid: 311, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetLayoutNumberVideoRowsChanged' event (evid: 312)
 *
 * Event description: User change in appSet the number of video rows
 *
 * @param {appSetLayoutNumberVideoRowsChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - classic/strip/compact
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {string} selection - 1,2,3,4,5,6,7,8,9,10
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetLayoutNumberVideoRowsChangedParams>} LogObject<appSetLayoutNumberVideoRowsChangedParams>
 */
export function appSetLayoutNumberVideoRowsChanged(params) {
    return { evid: 312, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetAdiDisplayElementsShareMyVideosChanged' event (evid: 313)
 *
 * Event description: User click on "share my videos" in ADI
 *
 * @param {appSetAdiDisplayElementsShareMyVideosChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - classic/strip/compact
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {boolean} isEnabled - true/false
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetAdiDisplayElementsShareMyVideosChangedParams>} LogObject<appSetAdiDisplayElementsShareMyVideosChangedParams>
 */
export function appSetAdiDisplayElementsShareMyVideosChanged(params) {
    return { evid: 313, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetAdiDisplayElementsChannelDetailsChanged' event (evid: 314)
 *
 * Event description: User click on "channel Details" in ADI
 *
 * @param {appSetAdiDisplayElementsChannelDetailsChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - classic/strip/compact
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {boolean} isEnabled - true/false
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetAdiDisplayElementsChannelDetailsChangedParams>} LogObject<appSetAdiDisplayElementsChannelDetailsChangedParams>
 */
export function appSetAdiDisplayElementsChannelDetailsChanged(params) {
    return { evid: 314, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetLayoutShowButtonChanged' event (evid: 315)
 *
 * Event description: Users changes "Show button" for video thumbnails (layout)
 *
 * @param {appSetLayoutShowButtonChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - small_slider/big_slider
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {string} selection - on_hover / always
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetLayoutShowButtonChangedParams>} LogObject<appSetLayoutShowButtonChangedParams>
 */
export function appSetLayoutShowButtonChanged(params) {
    return { evid: 315, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetLayoutStretchToWidthChanged' event (evid: 317)
 *
 * Event description: Users changes toggle 'Stretch to full width' in AppSet
 *
 * @param {appSetLayoutStretchToWidthChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - small_slider/big_slider
 * @property {boolean} toggle - on / off
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetLayoutStretchToWidthChangedParams>} LogObject<appSetLayoutStretchToWidthChangedParams>
 */
export function appSetLayoutStretchToWidthChanged(params) {
    return { evid: 317, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetPlayerActionsInMenuShareChannelToggleChanged' event (evid: 319)
 *
 * Event description: User changed toggle Use optimal font sizes on Design tab in App Set
 *
 * @param {appSetPlayerActionsInMenuShareChannelToggleChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - small_slider/big_slider
 * @property {boolean} toggle - on / off
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetPlayerActionsInMenuShareChannelToggleChangedParams>} LogObject<appSetPlayerActionsInMenuShareChannelToggleChangedParams>
 */
export function appSetPlayerActionsInMenuShareChannelToggleChanged(params) {
    return { evid: 319, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boSettingsDefaultPriceSaveCompleted' event (evid: 32)
 *
 * Event description: Saving the default price completed
 *
 * @param {boSettingsDefaultPriceSaveCompletedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {boolean} rentalPeriodChange - did the rental period changed
 * @property {number} purchasePricinig - the price for purchase doubled by 10000
 * @property {string} rentalPeriod - 24/48/72
 * @property {boolean} isDownload - if uou can download the video
 * @property {boolean} purchasableChange - did the purchase option changed
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {number} rentalPricinig - the price of renting doubled by 10000
 * @property {boolean} downloadChanged - If user changed the download option
 * @property {GUID} _instanceId - InstanceID
 * @property {boolean} purchasePricinigChange - did the purchase price changed
 * @property {string} _viewMode - view_mode
 * @property {boolean} rentalPricinigChange - did the rental price changed
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {string} pricingSelection - free/paid
 * @property {boolean} isPurchasable - is the videos for purchase
 * @property {boolean} isRental - is the videos for rental
 * @property {boolean} rentalChange - did the rental option changed
 * @property {GUID} _visitorId - visitor_id
 * @property {boolean} pricingSelectionChange - did the pricing selection changed
 * @return {LogObject<boSettingsDefaultPriceSaveCompletedParams>} LogObject<boSettingsDefaultPriceSaveCompletedParams>
 */
export function boSettingsDefaultPriceSaveCompleted(params) {
    return { evid: 32, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageVideoCardsAddVideoCardClick' event (evid: 320)
 *
 * Event description: add video card click in video cards section (promote a video/Promote a channel/Increase social followers/Boost sales/Custom test)
 *
 * @param {boVidPageVideoCardsAddVideoCardClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {string} cardName - promote_video/feature_channel/promote_product/get_social_followers/custom
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageVideoCardsAddVideoCardClickParams>} LogObject<boVidPageVideoCardsAddVideoCardClickParams>
 */
export function boVidPageVideoCardsAddVideoCardClick(params) {
    return { evid: 320, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageVideoCardsCardTimingChanged' event (evid: 321)
 *
 * Event description: Timing (start/end time) for video card changed
 *
 * @param {boVidPageVideoCardsCardTimingChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {string} changeBy - seek/manual
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {string} cardName - promote_video/feature_channel/promote_product/get_social_followers/custom
 * @property {string} timeFrame - start/end
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageVideoCardsCardTimingChangedParams>} LogObject<boVidPageVideoCardsCardTimingChangedParams>
 */
export function boVidPageVideoCardsCardTimingChanged(params) {
    return { evid: 321, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageVideoCardsPromoteProductPopUpOpened' event (evid: 322)
 *
 * Event description: "Promote A Product" pop up opened
 *
 * @param {boVidPageVideoCardsPromoteProductPopUpOpenedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageVideoCardsPromoteProductPopUpOpenedParams>} LogObject<boVidPageVideoCardsPromoteProductPopUpOpenedParams>
 */
export function boVidPageVideoCardsPromoteProductPopUpOpened(params) {
    return { evid: 322, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageVideoCardsPromoteProductPopUpSaveClick' event (evid: 323)
 *
 * Event description: click on save in "Promote A Product" pop up
 *
 * @param {boVidPageVideoCardsPromoteProductPopUpSaveClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {boolean} isSuggestedButtonName - if the button name is from list or user type
 * @property {boolean} descriptionExists - Product have description
 * @property {boolean} coverExists - if cover exists
 * @property {boolean} buttonExists - Product have call to action button
 * @property {string} errorMsg - error message if save fail
 * @property {GUID} _appId - app_id
 * @property {boolean} isSuccess - save success or not
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {string} buttonName - the button name user insert
 * @property {GUID} _visitorId - visitor_id
 * @property {boolean} linkExists - Product have URL link
 * @return {LogObject<boVidPageVideoCardsPromoteProductPopUpSaveClickParams>} LogObject<boVidPageVideoCardsPromoteProductPopUpSaveClickParams>
 */
export function boVidPageVideoCardsPromoteProductPopUpSaveClick(params) {
    return { evid: 323, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageVideoCardsPromoteProductPopUpDismissClick' event (evid: 324)
 *
 * Event description: click on close (X) button in "Choose A channel" pop up or on cancel button
 *
 * @param {boVidPageVideoCardsPromoteProductPopUpDismissClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {string} buttonName - close/cancel
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageVideoCardsPromoteProductPopUpDismissClickParams>} LogObject<boVidPageVideoCardsPromoteProductPopUpDismissClickParams>
 */
export function boVidPageVideoCardsPromoteProductPopUpDismissClick(params) {
    return { evid: 324, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageVideoCardsPromoteProductPopUpUploadImageActionClick' event (evid: 325)
 *
 * Event description: upload image action (upload/change/delete) clicked in   "Promote A Product" pop up
 *
 * @param {boVidPageVideoCardsPromoteProductPopUpUploadImageActionClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {string} buttonName - upload/change/delete
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageVideoCardsPromoteProductPopUpUploadImageActionClickParams>} LogObject<boVidPageVideoCardsPromoteProductPopUpUploadImageActionClickParams>
 */
export function boVidPageVideoCardsPromoteProductPopUpUploadImageActionClick(params) {
    return { evid: 325, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageVideoCardsPromoteProductPopUpUploadImageCompleted' event (evid: 326)
 *
 * Event description: upload image in  "Promote A Product" pop up finished
 *
 * @param {boVidPageVideoCardsPromoteProductPopUpUploadImageCompletedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} errorMsg - error message if upload fail
 * @property {GUID} _appId - app_id
 * @property {boolean} isSuccess - image upload success or not
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageVideoCardsPromoteProductPopUpUploadImageCompletedParams>} LogObject<boVidPageVideoCardsPromoteProductPopUpUploadImageCompletedParams>
 */
export function boVidPageVideoCardsPromoteProductPopUpUploadImageCompleted(params) {
    return { evid: 326, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageVideoCardsCardEditClick' event (evid: 327)
 *
 * Event description: click on edit card (Pencil) image or on the card’s title
 *
 * @param {boVidPageVideoCardsCardEditClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {string} cardName - promote_video/feature_channel/promote_product/get_social_followers/custom
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageVideoCardsCardEditClickParams>} LogObject<boVidPageVideoCardsCardEditClickParams>
 */
export function boVidPageVideoCardsCardEditClick(params) {
    return { evid: 327, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageVideoCardsCardQuickActionClick' event (evid: 328)
 *
 * Event description: click on card quick actions (duplicate/delete)
 *
 * @param {boVidPageVideoCardsCardQuickActionClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} actionType - delete/duplicate
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {string} cardName - promote_video/feature_channel/promote_product/get_social_followers/custom
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageVideoCardsCardQuickActionClickParams>} LogObject<boVidPageVideoCardsCardQuickActionClickParams>
 */
export function boVidPageVideoCardsCardQuickActionClick(params) {
    return { evid: 328, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageVideoCardsSaveClick' event (evid: 329)
 *
 * Event description: Save clicked at the video cards section / unsaved changes popup
 *
 * @param {boVidPageVideoCardsSaveClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} numberOfCardsDeleted - number of cards deleted in this session
 * @property {string} cardsPosition - top_left/top_right/bottom_left/bottom_right
 * @property {string} cardsOrientation - vertical/horizontal
 * @property {string} numberOfCustomText - number of custom texts
 * @property {string} numberOfBoostSales - number of boost sales cards
 * @property {boolean} embed - embed toggle on/off
 * @property {GUID} _appId - app_id
 * @property {string} videoID - new_videoID
 * @property {string} user_agent - user_agent
 * @property {number} numberOfCards - number of cards after this session
 * @property {GUID} _instanceId - InstanceID
 * @property {string} saveOrigin - popup/cards_page
 * @property {string} _viewMode - view_mode
 * @property {boolean} overQuoted - is video id under OverQuota, true / false
 * @property {string} numberOfCardsUpdated - number of cards updated in this session
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} numberOfIncreaseSocial - number of get increase social followers
 * @property {string} numberOfPromoteChannel - number of promote channel cards
 * @property {string} compId - player_id
 * @property {string} pricingSelection - free/paid
 * @property {boolean} isPurchasable - is the videos for purchase
 * @property {boolean} isRental - is the videos for rental
 * @property {string} numberOfPromoteVideo - number of promote video cards
 * @property {GUID} _visitorId - visitor_id
 * @property {string} numberOfCardsCreated - number of cards created in this session
 * @return {LogObject<boVidPageVideoCardsSaveClickParams>} LogObject<boVidPageVideoCardsSaveClickParams>
 */
export function boVidPageVideoCardsSaveClick(params) {
    return { evid: 329, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boSettingsDefaultChChanged' event (evid: 33)
 *
 * Event description: Default channel changed
 *
 * @param {boSettingsDefaultChChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channel_id
 * @return {LogObject<boSettingsDefaultChChangedParams>} LogObject<boSettingsDefaultChChangedParams>
 */
export function boSettingsDefaultChChanged(params) {
    return { evid: 33, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageVideoCardsSaveCompleted' event (evid: 330)
 *
 * Event description: Save  completed at the video cards section / unsaved changes popup
 *
 * @param {boVidPageVideoCardsSaveCompletedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} numberOfCardsDeleted - number of cards deleted in this session
 * @property {string} cardsPosition - top_left/top_right/bottom_left/bottom_right
 * @property {string} cardsOrientation - vertical/horizontal
 * @property {string} errorMsg - error message if save fail
 * @property {string} numberOfCustomText - number of custom texts
 * @property {string} numberOfBoostSales - number of boost sales cards
 * @property {boolean} embed - embed toggle on/off
 * @property {GUID} _appId - app_id
 * @property {boolean} isSuccess - save success or not
 * @property {string} videoID - new_videoID
 * @property {string} user_agent - user_agent
 * @property {number} numberOfCards - number of cards after this session
 * @property {GUID} _instanceId - InstanceID
 * @property {string} saveOrigin - popup/cards_page
 * @property {string} _viewMode - view_mode
 * @property {boolean} overQuoted - is video id under OverQuota, true / false
 * @property {string} numberOfCardsUpdated - number of cards updated in this session
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} numberOfIncreaseSocial - number of get increase social followers
 * @property {string} numberOfPromoteChannel - number of promote channel cards
 * @property {string} compId - player_id
 * @property {string} pricingSelection - free/paid
 * @property {boolean} isPurchasable - is the videos for purchase
 * @property {boolean} isRental - is the videos for rental
 * @property {string} numberOfPromoteVideo - number of promote video cards
 * @property {GUID} _visitorId - visitor_id
 * @property {string} numberOfCardsCreated - number of cards created in this session
 * @return {LogObject<boVidPageVideoCardsSaveCompletedParams>} LogObject<boVidPageVideoCardsSaveCompletedParams>
 */
export function boVidPageVideoCardsSaveCompleted(params) {
    return { evid: 330, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageUnsavedChangesPopUpOpened' event (evid: 331)
 *
 * Event description: unsaved changes  pop up opened
 *
 * @param {boVidPageUnsavedChangesPopUpOpenedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageUnsavedChangesPopUpOpenedParams>} LogObject<boVidPageUnsavedChangesPopUpOpenedParams>
 */
export function boVidPageUnsavedChangesPopUpOpened(params) {
    return { evid: 331, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageUnsavedChangesPopUpLeaveClick' event (evid: 332)
 *
 * Event description: click on leave in ""unsaved changes"" pop up
 *
 * @param {boVidPageUnsavedChangesPopUpLeaveClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageUnsavedChangesPopUpLeaveClickParams>} LogObject<boVidPageUnsavedChangesPopUpLeaveClickParams>
 */
export function boVidPageUnsavedChangesPopUpLeaveClick(params) {
    return { evid: 332, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageUnsavedChangesPopUpCloseClick' event (evid: 333)
 *
 * Event description: click on close in "unsaved changes" pop up
 *
 * @param {boVidPageUnsavedChangesPopUpCloseClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageUnsavedChangesPopUpCloseClickParams>} LogObject<boVidPageUnsavedChangesPopUpCloseClickParams>
 */
export function boVidPageUnsavedChangesPopUpCloseClick(params) {
    return { evid: 333, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageVideoCardsVideoPlayRequested' event (evid: 334)
 *
 * Event description: click on video play button in video cards section
 *
 * @param {boVidPageVideoCardsVideoPlayRequestedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} playSource - keyboard/play_button/screen_click
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageVideoCardsVideoPlayRequestedParams>} LogObject<boVidPageVideoCardsVideoPlayRequestedParams>
 */
export function boVidPageVideoCardsVideoPlayRequested(params) {
    return { evid: 334, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageVideoCardsVideoPlayStart' event (evid: 335)
 *
 * Event description: video start play in video cards section (after 71:337)
 *
 * @param {boVidPageVideoCardsVideoPlayStartParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} playSource - keyboard/play_button/screen_click
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageVideoCardsVideoPlayStartParams>} LogObject<boVidPageVideoCardsVideoPlayStartParams>
 */
export function boVidPageVideoCardsVideoPlayStart(params) {
    return { evid: 335, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageVideoCardsVideoCardsButtonClicked' event (evid: 336)
 *
 * Event description: Click on 4th button (cards button - star) in player (only on video cards BO)
 *
 * @param {boVidPageVideoCardsVideoCardsButtonClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - new_videoID
 * @property {string} user_agent - user_agent
 * @property {number} numberOfCards - number of cards in video (all cards)
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageVideoCardsVideoCardsButtonClickedParams>} LogObject<boVidPageVideoCardsVideoCardsButtonClickedParams>
 */
export function boVidPageVideoCardsVideoCardsButtonClicked(params) {
    return { evid: 336, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageVideoCardsPromoteVideoPopUpOpened' event (evid: 337)
 *
 * Event description: "Promote A Video" modal opened
 *
 * @param {boVidPageVideoCardsPromoteVideoPopUpOpenedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageVideoCardsPromoteVideoPopUpOpenedParams>} LogObject<boVidPageVideoCardsPromoteVideoPopUpOpenedParams>
 */
export function boVidPageVideoCardsPromoteVideoPopUpOpened(params) {
    return { evid: 337, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageVideoCardsPromoteVideoPopUpNextClick' event (evid: 338)
 *
 * Event description: click on next in "Promote A Video" modal after choosing to promote latest video or to choose video to promote
 *
 * @param {boVidPageVideoCardsPromoteVideoPopUpNextClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {string} selection - recent_video/choose_video
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageVideoCardsPromoteVideoPopUpNextClickParams>} LogObject<boVidPageVideoCardsPromoteVideoPopUpNextClickParams>
 */
export function boVidPageVideoCardsPromoteVideoPopUpNextClick(params) {
    return { evid: 338, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageVideoCardsPromoteVideoPopUpCancelClick' event (evid: 339)
 *
 * Event description: click on cancel in "Promote A Video" modal
 *
 * @param {boVidPageVideoCardsPromoteVideoPopUpCancelClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} currentStep - In which step user click cancel
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} previousStep - the previous step of the modal
 * @return {LogObject<boVidPageVideoCardsPromoteVideoPopUpCancelClickParams>} LogObject<boVidPageVideoCardsPromoteVideoPopUpCancelClickParams>
 */
export function boVidPageVideoCardsPromoteVideoPopUpCancelClick(params) {
    return { evid: 339, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boSettingsEmailLangChanged' event (evid: 34)
 *
 * Event description: Default email language changed
 *
 * @param {boSettingsEmailLangChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} selectedLang - the language changed to
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boSettingsEmailLangChangedParams>} LogObject<boSettingsEmailLangChangedParams>
 */
export function boSettingsEmailLangChanged(params) {
    return { evid: 34, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageVideoCardsPromoteVideoPopUpCloseClick' event (evid: 340)
 *
 * Event description: click on close (X button) in "Promote A Video" modal
 *
 * @param {boVidPageVideoCardsPromoteVideoPopUpCloseClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} currentStep - In which step user click close (promote_a_video/choose_a_channel/
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageVideoCardsPromoteVideoPopUpCloseClickParams>} LogObject<boVidPageVideoCardsPromoteVideoPopUpCloseClickParams>
 */
export function boVidPageVideoCardsPromoteVideoPopUpCloseClick(params) {
    return { evid: 340, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageVideoCardsPromoteVideoPopUpChooseVideoChooseClick' event (evid: 341)
 *
 * Event description: click on choose in "choose a video" page in promote video modal
 *
 * @param {boVidPageVideoCardsPromoteVideoPopUpChooseVideoChooseClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageVideoCardsPromoteVideoPopUpChooseVideoChooseClickParams>} LogObject<boVidPageVideoCardsPromoteVideoPopUpChooseVideoChooseClickParams>
 */
export function boVidPageVideoCardsPromoteVideoPopUpChooseVideoChooseClick(params) {
    return { evid: 341, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageVideoCardsPromoteVideoPopUpChannelPickerSaveClick' event (evid: 342)
 *
 * Event description: click on save in "choose a channel" page in promote video modal
 *
 * @param {boVidPageVideoCardsPromoteVideoPopUpChannelPickerSaveClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} previousStep - from which page the user "came" to choose a channel page
 * @return {LogObject<boVidPageVideoCardsPromoteVideoPopUpChannelPickerSaveClickParams>} LogObject<boVidPageVideoCardsPromoteVideoPopUpChannelPickerSaveClickParams>
 */
export function boVidPageVideoCardsPromoteVideoPopUpChannelPickerSaveClick(params) {
    return { evid: 342, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageVideoCardsChannelPickerGotItClick' event (evid: 343)
 *
 * Event description: click on got it in "choose a channel" page in promote video modal (When chosen video is not connected to any channel)
 *
 * @param {boVidPageVideoCardsChannelPickerGotItClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {string} cardType - promote_video/feature_channel
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageVideoCardsChannelPickerGotItClickParams>} LogObject<boVidPageVideoCardsChannelPickerGotItClickParams>
 */
export function boVidPageVideoCardsChannelPickerGotItClick(params) {
    return { evid: 343, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageVideoCardsChannelPickerChannelsClick' event (evid: 344)
 *
 * Event description: click on "channels" in "choose a channel" page in promote video modal (When chosen video is not connected to any channel)
 *
 * @param {boVidPageVideoCardsChannelPickerChannelsClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {string} cardType - promote_video/feature_channel
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageVideoCardsChannelPickerChannelsClickParams>} LogObject<boVidPageVideoCardsChannelPickerChannelsClickParams>
 */
export function boVidPageVideoCardsChannelPickerChannelsClick(params) {
    return { evid: 344, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageVideoCardsPromoteVideoPopUpChannelPickerLoaded' event (evid: 345)
 *
 * Event description: the channel picker loaded
 *
 * @param {boVidPageVideoCardsPromoteVideoPopUpChannelPickerLoadedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageVideoCardsPromoteVideoPopUpChannelPickerLoadedParams>} LogObject<boVidPageVideoCardsPromoteVideoPopUpChannelPickerLoadedParams>
 */
export function boVidPageVideoCardsPromoteVideoPopUpChannelPickerLoaded(params) {
    return { evid: 345, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageVideoCardsFeatureChannelPopUpOpened' event (evid: 346)
 *
 * Event description: "feature a Channel" modal opened
 *
 * @param {boVidPageVideoCardsFeatureChannelPopUpOpenedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageVideoCardsFeatureChannelPopUpOpenedParams>} LogObject<boVidPageVideoCardsFeatureChannelPopUpOpenedParams>
 */
export function boVidPageVideoCardsFeatureChannelPopUpOpened(params) {
    return { evid: 346, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageVideoCardsFeatureChannelPopUpDismissClick' event (evid: 347)
 *
 * Event description: click on cancel or X (close) button in Feature a Channel pop up
 *
 * @param {boVidPageVideoCardsFeatureChannelPopUpDismissClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {string} buttonName - cancel/close
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageVideoCardsFeatureChannelPopUpDismissClickParams>} LogObject<boVidPageVideoCardsFeatureChannelPopUpDismissClickParams>
 */
export function boVidPageVideoCardsFeatureChannelPopUpDismissClick(params) {
    return { evid: 347, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageVideoCardsFeatureChannelPopUpSaveClick' event (evid: 348)
 *
 * Event description: click on save in "Feature a Channel" page
 *
 * @param {boVidPageVideoCardsFeatureChannelPopUpSaveClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageVideoCardsFeatureChannelPopUpSaveClickParams>} LogObject<boVidPageVideoCardsFeatureChannelPopUpSaveClickParams>
 */
export function boVidPageVideoCardsFeatureChannelPopUpSaveClick(params) {
    return { evid: 348, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageVideoCardsActionCardsHowToPopUpOpened' event (evid: 349)
 *
 * Event description: How to action cards pop up opened
 *
 * @param {boVidPageVideoCardsActionCardsHowToPopUpOpenedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageVideoCardsActionCardsHowToPopUpOpenedParams>} LogObject<boVidPageVideoCardsActionCardsHowToPopUpOpenedParams>
 */
export function boVidPageVideoCardsActionCardsHowToPopUpOpened(params) {
    return { evid: 349, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boSettingsEmailPreviewClicked' event (evid: 35)
 *
 * Event description: Clicking on email preview
 *
 * @param {boSettingsEmailPreviewClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boSettingsEmailPreviewClickedParams>} LogObject<boSettingsEmailPreviewClickedParams>
 */
export function boSettingsEmailPreviewClicked(params) {
    return { evid: 35, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageVideoCardsGetSocialFollowersPopUpOpened' event (evid: 350)
 *
 * Event description: "Get Social Followers" pop up opened
 *
 * @param {boVidPageVideoCardsGetSocialFollowersPopUpOpenedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageVideoCardsGetSocialFollowersPopUpOpenedParams>} LogObject<boVidPageVideoCardsGetSocialFollowersPopUpOpenedParams>
 */
export function boVidPageVideoCardsGetSocialFollowersPopUpOpened(params) {
    return { evid: 350, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageVideoCardsGetSocialFollowersPopUpEnterUrlParsingComplete' event (evid: 351)
 *
 * Event description: send after user enter the URL and parsing complete
 *
 * @param {boVidPageVideoCardsGetSocialFollowersPopUpEnterUrlParsingCompleteParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} source - Facebook/Twitter/YouTube/NULL
 * @property {string} errorMsg - error message if parsing failed
 * @property {GUID} _appId - app_id
 * @property {boolean} isSuccess - parsing complete success or not
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageVideoCardsGetSocialFollowersPopUpEnterUrlParsingCompleteParams>} LogObject<boVidPageVideoCardsGetSocialFollowersPopUpEnterUrlParsingCompleteParams>
 */
export function boVidPageVideoCardsGetSocialFollowersPopUpEnterUrlParsingComplete(params) {
    return { evid: 351, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageVideoCardsGetSocialFollowersPopUpConnectClick' event (evid: 352)
 *
 * Event description: click on connect in "Get Social Followers" pop up
 *
 * @param {boVidPageVideoCardsGetSocialFollowersPopUpConnectClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} source - Facebook/Twitter/YouTube/NULL
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageVideoCardsGetSocialFollowersPopUpConnectClickParams>} LogObject<boVidPageVideoCardsGetSocialFollowersPopUpConnectClickParams>
 */
export function boVidPageVideoCardsGetSocialFollowersPopUpConnectClick(params) {
    return { evid: 352, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageVideoCardsGetSocialFollowersPopUpDismissClick' event (evid: 353)
 *
 * Event description: click on close/cancel in "Get Social Followers" pop up
 *
 * @param {boVidPageVideoCardsGetSocialFollowersPopUpDismissClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {string} buttonName - close/cancel
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageVideoCardsGetSocialFollowersPopUpDismissClickParams>} LogObject<boVidPageVideoCardsGetSocialFollowersPopUpDismissClickParams>
 */
export function boVidPageVideoCardsGetSocialFollowersPopUpDismissClick(params) {
    return { evid: 353, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageVideoCardsCustomCardPopUpOpened' event (evid: 354)
 *
 * Event description: "custom card" pop up opened
 *
 * @param {boVidPageVideoCardsCustomCardPopUpOpenedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageVideoCardsCustomCardPopUpOpenedParams>} LogObject<boVidPageVideoCardsCustomCardPopUpOpenedParams>
 */
export function boVidPageVideoCardsCustomCardPopUpOpened(params) {
    return { evid: 354, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageVideoCardsCustomCardPopUpSaveClick' event (evid: 355)
 *
 * Event description: click on save in "Custom Card" pop up
 *
 * @param {boVidPageVideoCardsCustomCardPopUpSaveClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {boolean} isSuggestedButtonName - if the button name is from list or user type
 * @property {boolean} descriptionExists - Product have description
 * @property {boolean} coverExists - if cover exists
 * @property {boolean} buttonExists - Product have call to action button
 * @property {string} errorMsg - error message if save fail
 * @property {GUID} _appId - app_id
 * @property {boolean} isSuccess - save success or not
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {string} buttonName - the button name user insert
 * @property {GUID} _visitorId - visitor_id
 * @property {boolean} linkExists - Product have URL link
 * @return {LogObject<boVidPageVideoCardsCustomCardPopUpSaveClickParams>} LogObject<boVidPageVideoCardsCustomCardPopUpSaveClickParams>
 */
export function boVidPageVideoCardsCustomCardPopUpSaveClick(params) {
    return { evid: 355, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageVideoCardsCustomCardPopUpDismissClick' event (evid: 356)
 *
 * Event description: click on close (X) button in "Custom Card" pop up
 *
 * @param {boVidPageVideoCardsCustomCardPopUpDismissClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {string} buttonName - close/cancel
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageVideoCardsCustomCardPopUpDismissClickParams>} LogObject<boVidPageVideoCardsCustomCardPopUpDismissClickParams>
 */
export function boVidPageVideoCardsCustomCardPopUpDismissClick(params) {
    return { evid: 356, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageVideoCardsCustomCardPopUpUploadImageActionClick' event (evid: 357)
 *
 * Event description: upload image action (upload/change/delete) clicked in   "Custom Card" pop up
 *
 * @param {boVidPageVideoCardsCustomCardPopUpUploadImageActionClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {string} buttonName - upload/change/delete
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageVideoCardsCustomCardPopUpUploadImageActionClickParams>} LogObject<boVidPageVideoCardsCustomCardPopUpUploadImageActionClickParams>
 */
export function boVidPageVideoCardsCustomCardPopUpUploadImageActionClick(params) {
    return { evid: 357, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageVideoCardsCustomCardPopUpUploadImageCompleted' event (evid: 358)
 *
 * Event description: upload image in  "Custom Card" pop up finished
 *
 * @param {boVidPageVideoCardsCustomCardPopUpUploadImageCompletedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} errorMsg - error message if upload fail
 * @property {GUID} _appId - app_id
 * @property {boolean} isSuccess - image upload success or not
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageVideoCardsCustomCardPopUpUploadImageCompletedParams>} LogObject<boVidPageVideoCardsCustomCardPopUpUploadImageCompletedParams>
 */
export function boVidPageVideoCardsCustomCardPopUpUploadImageCompleted(params) {
    return { evid: 358, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageVideoCardsActionCardsHowToPopUpButtonClick' event (evid: 359)
 *
 * Event description: Button click on "how to" action cards pop up
 *
 * @param {boVidPageVideoCardsActionCardsHowToPopUpButtonClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {boolean} dontShow - don't show on/off
 * @property {string} button - add_action_card/close
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageVideoCardsActionCardsHowToPopUpButtonClickParams>} LogObject<boVidPageVideoCardsActionCardsHowToPopUpButtonClickParams>
 */
export function boVidPageVideoCardsActionCardsHowToPopUpButtonClick(params) {
    return { evid: 359, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boSettingsEmailWhenSaleChanged' event (evid: 36)
 *
 * Event description: Changing if a email will be send after a sale or not
 *
 * @param {boSettingsEmailWhenSaleChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {boolean} emailWhenSale - is an email is going to be send when there a sale
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boSettingsEmailWhenSaleChangedParams>} LogObject<boSettingsEmailWhenSaleChangedParams>
 */
export function boSettingsEmailWhenSaleChanged(params) {
    return { evid: 36, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boPageLoaded' event (evid: 360)
 *
 * Event description: Video BO page loaded successfully
 *
 * @param {boPageLoadedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} referralInfo - Side_bar, bread_crumbs...
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} previousPage - last page seen by the user
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - MA/Editor/ADI
 * @property {string} compId - player_id
 * @property {string} pageName - Page name (video_library,channels_page etc.)
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boPageLoadedParams>} LogObject<boPageLoadedParams>
 */
export function boPageLoaded(params) {
    return { evid: 360, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLibVideoItemQuickActionsActionClick' event (evid: 361)
 *
 * Event description: click on an action from quick actions in the video library
 *
 * @param {boLibVideoItemQuickActionsActionClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {string} actionName - add_card/social/promote
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLibVideoItemQuickActionsActionClickParams>} LogObject<boLibVideoItemQuickActionsActionClickParams>
 */
export function boLibVideoItemQuickActionsActionClick(params) {
    return { evid: 361, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLibState' event (evid: 362)
 *
 * Event description: Event with current user video library state, shoot on library open
 *
 * @param {boLibStateParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {number} videosCount - how many videos user has
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {number} uploadedVideosCount - how many uploaded videos user has (live and upload)
 * @property {GUID} _instanceId - InstanceID
 * @property {number} uploadedVideosDuration - sum of all uploaded videos duration, sec
 * @property {string} _viewMode - view_mode
 * @property {number} overQuotaVideosCount - how many uploaded but over-quoted videos user has (live and upload)
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - MA/Editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {number} overQuotaVideosDuration - sum of all uploaded and over-quoted videos duration, sec
 * @return {LogObject<boLibStateParams>} LogObject<boLibStateParams>
 */
export function boLibState(params) {
    return { evid: 362, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLibUploadYourOwnVideoBannerCloseClick' event (evid: 364)
 *
 * Event description: User close  "Upload your own videos banner"
 * example: https://www.screencast.com/t/3EG1pmmqbMb
 *
 * @param {boLibUploadYourOwnVideoBannerCloseClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLibUploadYourOwnVideoBannerCloseClickParams>} LogObject<boLibUploadYourOwnVideoBannerCloseClickParams>
 */
export function boLibUploadYourOwnVideoBannerCloseClick(params) {
    return { evid: 364, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageVideoCardsActionCardsHowToBannerButtonClick' event (evid: 365)
 *
 * Event description: Button click on "how to" action cards banner: close or show me how
 *
 * @param {boVidPageVideoCardsActionCardsHowToBannerButtonClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {string} button - show_me_how/close
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageVideoCardsActionCardsHowToBannerButtonClickParams>} LogObject<boVidPageVideoCardsActionCardsHowToBannerButtonClickParams>
 */
export function boVidPageVideoCardsActionCardsHowToBannerButtonClick(params) {
    return { evid: 365, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boSyndicLoadStarted' event (evid: 366)
 *
 * Event description: Syndication load start (event to track syndication success rate)
 *
 * @param {boSyndicLoadStartedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - new_videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boSyndicLoadStartedParams>} LogObject<boSyndicLoadStartedParams>
 */
export function boSyndicLoadStarted(params) {
    return { evid: 366, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetPlayerAfterPlayingWhenVideoEndsChanged' event (evid: 367)
 *
 * Event description: User change in appSet.player.afterPlaying when video ends dropdown
 *
 * @param {appSetPlayerAfterPlayingWhenVideoEndsChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - instance_id
 * @property {GUID} _msid - msid
 * @property {string} layoutType - small_slider/big_slider
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - instance_id
 * @property {string} _viewMode - view_mode
 * @property {string} selection - show_video_cover/play_next_video/open_action_cards
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} previousSelection - show_video_cover/play_next_video/open_action_cards
 * @return {LogObject<appSetPlayerAfterPlayingWhenVideoEndsChangedParams>} LogObject<appSetPlayerAfterPlayingWhenVideoEndsChangedParams>
 */
export function appSetPlayerAfterPlayingWhenVideoEndsChanged(params) {
    return { evid: 367, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boSettingsReviewContactsClicked' event (evid: 37)
 *
 * Event description: Clicking on review contacts
 *
 * @param {boSettingsReviewContactsClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boSettingsReviewContactsClickedParams>} LogObject<boSettingsReviewContactsClickedParams>
 */
export function boSettingsReviewContactsClicked(params) {
    return { evid: 37, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boSettingsPayPalConnectBtnConnected' event (evid: 38)
 *
 * Event description: Connect paypal Succeed
 *
 * @param {boSettingsPayPalConnectBtnConnectedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} uuid - uuid
 * @property {boolean} isFirst - first time paypal connection made
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boSettingsPayPalConnectBtnConnectedParams>} LogObject<boSettingsPayPalConnectBtnConnectedParams>
 */
export function boSettingsPayPalConnectBtnConnected(params) {
    return { evid: 38, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageLivePopUpDownloadClick' event (evid: 380)
 *
 * Event description: Click on Google Play store or Apple store image from download the app in live stream pop up
 *
 * @param {boVidPageLivePopUpDownloadClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {string} storeName - apple/google
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageLivePopUpDownloadClickParams>} LogObject<boVidPageLivePopUpDownloadClickParams>
 */
export function boVidPageLivePopUpDownloadClick(params) {
    return { evid: 380, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageLivePopUpCloseClick' event (evid: 381)
 *
 * Event description: click on close (X) in the live pop up
 *
 * @param {boVidPageLivePopUpCloseClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageLivePopUpCloseClickParams>} LogObject<boVidPageLivePopUpCloseClickParams>
 */
export function boVidPageLivePopUpCloseClick(params) {
    return { evid: 381, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageLivePopUpGotItClick' event (evid: 382)
 *
 * Event description: click on got it  in the live pop up
 *
 * @param {boVidPageLivePopUpGotItClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {boolean} dontShow - don't show this again checkbox
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageLivePopUpGotItClickParams>} LogObject<boVidPageLivePopUpGotItClickParams>
 */
export function boVidPageLivePopUpGotItClick(params) {
    return { evid: 382, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageLivePopUpOpened' event (evid: 383)
 *
 * Event description: Live pop up opened
 *
 * @param {boVidPageLivePopUpOpenedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageLivePopUpOpenedParams>} LogObject<boVidPageLivePopUpOpenedParams>
 */
export function boVidPageLivePopUpOpened(params) {
    return { evid: 383, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boSettingsPayPalConnectBtnClicked' event (evid: 39)
 *
 * Event description: Clicking on the connect paypal button
 *
 * @param {boSettingsPayPalConnectBtnClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {boolean} isFirst - first time connecting to paypal
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boSettingsPayPalConnectBtnClickedParams>} LogObject<boSettingsPayPalConnectBtnClickedParams>
 */
export function boSettingsPayPalConnectBtnClicked(params) {
    return { evid: 39, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'adiConnectFeedCompleted' event (evid: 396)
 *
 * Event description: Send when user connected youtube feed in ADI
 *
 * @param {adiConnectFeedCompletedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} source - youtube
 * @property {string} url - the URL address the user entered if add failed
 * @property {string} errorMsg - Error message
 * @property {GUID} _appId - app_id
 * @property {boolean} isSuccess - if the connect feed finished successfully
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {number} errorCode - Error code
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channel_id
 * @return {LogObject<adiConnectFeedCompletedParams>} LogObject<adiConnectFeedCompletedParams>
 */
export function adiConnectFeedCompleted(params) {
    return { evid: 396, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'mediaShareVideoRequest' event (evid: 397)
 *
 * Event description: Server events for Facebook & Twitter share params
 *
 * @param {mediaShareVideoRequestParams} params - The parameters for this event
 * @property {GUID} biToken - biToken
 * @property {GUID} videoInstanceID - instance_id
 * @property {GUID} _msid - biToken
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - instance_id
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {string} correlationId - ID for one unique view connection
 * @property {GUID} _visitorId - visitorID
 * @property {string} parameters - parameters
 * @return {LogObject<mediaShareVideoRequestParams>} LogObject<mediaShareVideoRequestParams>
 */
export function mediaShareVideoRequest(params) {
    return { evid: 397, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'mediaShareVideoError' event (evid: 398)
 *
 * Event description: Server events for Facebook & Twitter share params
 *
 * @param {mediaShareVideoErrorParams} params - The parameters for this event
 * @property {GUID} biToken - biToken
 * @property {GUID} videoInstanceID - instance_id
 * @property {GUID} _msid - biToken
 * @property {string} errorMessage - error_message
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - instance_id
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - compId
 * @property {string} correlationId - ID for one unique view connection
 * @property {GUID} _visitorId - visitorID
 * @property {string} parameters - parameters
 * @return {LogObject<mediaShareVideoErrorParams>} LogObject<mediaShareVideoErrorParams>
 */
export function mediaShareVideoError(params) {
    return { evid: 398, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'mediaShareVideoSucceed' event (evid: 399)
 *
 * Event description: Server events for Facebook & Twitter share params
 *
 * @param {mediaShareVideoSucceedParams} params - The parameters for this event
 * @property {GUID} biToken - biToken
 * @property {GUID} videoInstanceID - instance_id
 * @property {GUID} _msid - biToken
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} videoID - ID of video in terms of Wix VOD
 * @property {string} user_agent - user_agent
 * @property {string} pageId - page_id
 * @property {GUID} _instanceId - instance_id
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - compId
 * @property {string} correlationId - ID for one unique view connection
 * @property {GUID} _visitorId - visitorID
 * @property {string} channelID - channel_id
 * @return {LogObject<mediaShareVideoSucceedParams>} LogObject<mediaShareVideoSucceedParams>
 */
export function mediaShareVideoSucceed(params) {
    return { evid: 399, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetMainNewChannelClicked' event (evid: 4)
 *
 * Event description: Clicking on new channel button
 *
 * @param {appSetMainNewChannelClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {boolean} isFirst - first time clicking on new channel button
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetMainNewChannelClickedParams>} LogObject<appSetMainNewChannelClickedParams>
 */
export function appSetMainNewChannelClicked(params) {
    return { evid: 4, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boGeneralHelpBtnClicked' event (evid: 40)
 *
 * Event description: Help button clicked
 *
 * @param {boGeneralHelpBtnClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} fromTab - video-library/channels/stats/settings
 * @property {string} buttonPosition - left_sidebar/top_right
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boGeneralHelpBtnClickedParams>} LogObject<boGeneralHelpBtnClickedParams>
 */
export function boGeneralHelpBtnClicked(params) {
    return { evid: 40, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetLayoutInfoPositionChanged' event (evid: 401)
 *
 * Event description: User changed info position in appSet.layout
 *
 * @param {appSetLayoutInfoPositionChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - classic/strip/compact
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {string} selection - on_video/below_video
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetLayoutInfoPositionChangedParams>} LogObject<appSetLayoutInfoPositionChangedParams>
 */
export function appSetLayoutInfoPositionChanged(params) {
    return { evid: 401, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetLayoutDisplayInfoTimestampChanged' event (evid: 403)
 *
 * Event description: User toggles to show Video timestamp
 *
 * @param {appSetLayoutDisplayInfoTimestampChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - small_slider/big_slider
 * @property {boolean} toggle - on / off
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetLayoutDisplayInfoTimestampChangedParams>} LogObject<appSetLayoutDisplayInfoTimestampChangedParams>
 */
export function appSetLayoutDisplayInfoTimestampChanged(params) {
    return { evid: 403, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetLayoutDisplayInfoDescriptionChanged' event (evid: 404)
 *
 * Event description: User toggles to show Video description
 *
 * @param {appSetLayoutDisplayInfoDescriptionChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - small_slider/big_slider
 * @property {boolean} toggle - on / off
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetLayoutDisplayInfoDescriptionChangedParams>} LogObject<appSetLayoutDisplayInfoDescriptionChangedParams>
 */
export function appSetLayoutDisplayInfoDescriptionChanged(params) {
    return { evid: 404, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetSettingsTextAlignmentChanged' event (evid: 405)
 *
 * Event description: Users changes text alignment, design tab
 *
 * @param {appSetSettingsTextAlignmentChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - small_slider/big_slider
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {string} selection - left / right / center
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetSettingsTextAlignmentChangedParams>} LogObject<appSetSettingsTextAlignmentChangedParams>
 */
export function appSetSettingsTextAlignmentChanged(params) {
    return { evid: 405, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetDesignOptimalFontToggleChanged' event (evid: 406)
 *
 * Event description: User changed toggle 'Use optimal font sizes'
 *
 * @param {appSetDesignOptimalFontToggleChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - small_slider/big_slider
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {boolean} isEnabled - on / off
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetDesignOptimalFontToggleChangedParams>} LogObject<appSetDesignOptimalFontToggleChangedParams>
 */
export function appSetDesignOptimalFontToggleChanged(params) {
    return { evid: 406, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boGeneralCancelUploadPopUpClick' event (evid: 41)
 *
 * Event description: In cancel upload popup which button did he clicked
 *
 * @param {boGeneralCancelUploadPopUpClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {string} button - Delete/Cancel
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boGeneralCancelUploadPopUpClickParams>} LogObject<boGeneralCancelUploadPopUpClickParams>
 */
export function boGeneralCancelUploadPopUpClick(params) {
    return { evid: 41, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boGeneralCancelUploadClick' event (evid: 42)
 *
 * Event description: Click  on cancel upload
 *
 * @param {boGeneralCancelUploadClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {string} fileType - image / video / audio / doc / folder
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {number} fileSize - file size in KB
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {string} target - cancel / cancel_upload / go_back / close_popup
 * @property {string} correlationId - id to find one upload process (same as 71:52)
 * @property {GUID} _visitorId - visitor_id
 * @property {string} fileFormat - file extension
 * @return {LogObject<boGeneralCancelUploadClickParams>} LogObject<boGeneralCancelUploadClickParams>
 */
export function boGeneralCancelUploadClick(params) {
    return { evid: 42, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boSettingsBackToBackofficeClicked' event (evid: 420)
 *
 * Event description: Clicking on "Back To Library" button in bo.settings
 *
 * @param {boSettingsBackToBackofficeClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {string} backToTab - library/channels
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boSettingsBackToBackofficeClickedParams>} LogObject<boSettingsBackToBackofficeClickedParams>
 */
export function boSettingsBackToBackofficeClicked(params) {
    return { evid: 420, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boMeetChannelsPopUpOpened' event (evid: 45)
 *
 * Event description: Channel introduction popup open
 *
 * @param {boMeetChannelsPopUpOpenedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boMeetChannelsPopUpOpenedParams>} LogObject<boMeetChannelsPopUpOpenedParams>
 */
export function boMeetChannelsPopUpOpened(params) {
    return { evid: 45, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLiveLearnMoreClick' event (evid: 450)
 *
 * Event description: Click on learn more on live stream tab
 *
 * @param {boLiveLearnMoreClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {string} type - onboarding / encoder / reconnecting / library
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLiveLearnMoreClickParams>} LogObject<boLiveLearnMoreClickParams>
 */
export function boLiveLearnMoreClick(params) {
    return { evid: 450, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLiveOnboardingButtonClick' event (evid: 451)
 *
 * Event description: Click on schedule event / go live now buttons on live stream tab
 *
 * @param {boLiveOnboardingButtonClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {string} button - schedule / go_live_mobile / go_live_desktop
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLiveOnboardingButtonClickParams>} LogObject<boLiveOnboardingButtonClickParams>
 */
export function boLiveOnboardingButtonClick(params) {
    return { evid: 451, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLiveBeforeStartPopUpOpened' event (evid: 452)
 *
 * Event description: Before you start pop up opened (live stream tab)
 *
 * @param {boLiveBeforeStartPopUpOpenedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLiveBeforeStartPopUpOpenedParams>} LogObject<boLiveBeforeStartPopUpOpenedParams>
 */
export function boLiveBeforeStartPopUpOpened(params) {
    return { evid: 452, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLiveBeforeStartPopUpClick' event (evid: 453)
 *
 * Event description: Click on 'Before you start pop up' (live stream tab)
 *
 * @param {boLiveBeforeStartPopUpClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {boolean} dontShow - true / false
 * @property {string} button - cancel / close / i_have_an_encoder / guide
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLiveBeforeStartPopUpClickParams>} LogObject<boLiveBeforeStartPopUpClickParams>
 */
export function boLiveBeforeStartPopUpClick(params) {
    return { evid: 453, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLiveEditTabClick' event (evid: 454)
 *
 * Event description: Click on Connect Stream tab or Add info tab, live stream edit process
 *
 * @param {boLiveEditTabClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} tabName - connect_stream / add_info
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLiveEditTabClickParams>} LogObject<boLiveEditTabClickParams>
 */
export function boLiveEditTabClick(params) {
    return { evid: 454, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLiveEditNextClick' event (evid: 455)
 *
 * Event description: Click on Next to go to Connect Stream tab, live stream edit process
 *
 * @param {boLiveEditNextClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLiveEditNextClickParams>} LogObject<boLiveEditNextClickParams>
 */
export function boLiveEditNextClick(params) {
    return { evid: 455, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLiveEditConnectStreamCopyClick' event (evid: 456)
 *
 * Event description: Click to copy key / url to connect encoder
 *
 * @param {boLiveEditConnectStreamCopyClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {string} button - server / stream
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLiveEditConnectStreamCopyClickParams>} LogObject<boLiveEditConnectStreamCopyClickParams>
 */
export function boLiveEditConnectStreamCopyClick(params) {
    return { evid: 456, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLiveEditConnectStreamRenewKeyClick' event (evid: 457)
 *
 * Event description: Click on Renew Key on connect stream tab
 *
 * @param {boLiveEditConnectStreamRenewKeyClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLiveEditConnectStreamRenewKeyClickParams>} LogObject<boLiveEditConnectStreamRenewKeyClickParams>
 */
export function boLiveEditConnectStreamRenewKeyClick(params) {
    return { evid: 457, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLiveEditConnectStreamScheduleClick' event (evid: 458)
 *
 * Event description: Click on Schedule on connect stream tab
 *
 * @param {boLiveEditConnectStreamScheduleClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLiveEditConnectStreamScheduleClickParams>} LogObject<boLiveEditConnectStreamScheduleClickParams>
 */
export function boLiveEditConnectStreamScheduleClick(params) {
    return { evid: 458, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLiveEditCancelButtonClick' event (evid: 459)
 *
 * Event description: Clicking cancel in live editing page
 *
 * @param {boLiveEditCancelButtonClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} videoId - video_id
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLiveEditCancelButtonClickParams>} LogObject<boLiveEditCancelButtonClickParams>
 */
export function boLiveEditCancelButtonClick(params) {
    return { evid: 459, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLibVidClicked' event (evid: 46)
 *
 * Event description: Clicking on video opening the edit video
 *
 * @param {boLibVidClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} source - youtube/vimeo/facebook/computer/batch/live
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {boolean} overQuoted - is video id under OverQuota, true / false
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {string} editMode - batch/single
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLibVidClickedParams>} LogObject<boLibVidClickedParams>
 */
export function boLibVidClicked(params) {
    return { evid: 46, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLiveEditConnectStreamKeyAndUrlDisplayed' event (evid: 460)
 *
 * Event description: Which stream key and url user has. Send on Connect tab view or after Renew key click
 *
 * @param {boLiveEditConnectStreamKeyAndUrlDisplayedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} streamId - stream id
 * @property {string} serverUrl - server url
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} streamKey - stream key
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLiveEditConnectStreamKeyAndUrlDisplayedParams>} LogObject<boLiveEditConnectStreamKeyAndUrlDisplayedParams>
 */
export function boLiveEditConnectStreamKeyAndUrlDisplayed(params) {
    return { evid: 460, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLiveEditConnectStreamCloseClick' event (evid: 461)
 *
 * Event description: Click on Close on Connect stream tab
 *
 * @param {boLiveEditConnectStreamCloseClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLiveEditConnectStreamCloseClickParams>} LogObject<boLiveEditConnectStreamCloseClickParams>
 */
export function boLiveEditConnectStreamCloseClick(params) {
    return { evid: 461, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLiveReschedulePopUpOpened' event (evid: 462)
 *
 * Event description: 'Reschedule this live stream for later'  pop up open
 *
 * @param {boLiveReschedulePopUpOpenedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLiveReschedulePopUpOpenedParams>} LogObject<boLiveReschedulePopUpOpenedParams>
 */
export function boLiveReschedulePopUpOpened(params) {
    return { evid: 462, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLiveReschedulePopUpClick' event (evid: 463)
 *
 * Event description: Click on 'Reschedule this live stream for later' pop up
 *
 * @param {boLiveReschedulePopUpClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {string} button - close / cancel / reschedule
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {boolean} scheduleChanged - true / false
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLiveReschedulePopUpClickParams>} LogObject<boLiveReschedulePopUpClickParams>
 */
export function boLiveReschedulePopUpClick(params) {
    return { evid: 463, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLiveConnectStreamClosePopupOpened' event (evid: 464)
 *
 * Event description: 'You're still Live'  pop up open
 *
 * @param {boLiveConnectStreamClosePopupOpenedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLiveConnectStreamClosePopupOpenedParams>} LogObject<boLiveConnectStreamClosePopupOpenedParams>
 */
export function boLiveConnectStreamClosePopupOpened(params) {
    return { evid: 464, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLiveConnectStreamClosePopupClick' event (evid: 465)
 *
 * Event description: Click on 'You're still live' pop up
 *
 * @param {boLiveConnectStreamClosePopupClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {boolean} dontShow - true / false
 * @property {string} button - close / cancel / got_it
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLiveConnectStreamClosePopupClickParams>} LogObject<boLiveConnectStreamClosePopupClickParams>
 */
export function boLiveConnectStreamClosePopupClick(params) {
    return { evid: 465, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLiveEmptyStateScheduleClick' event (evid: 466)
 *
 * Event description: Schedule event click on live stream library (when empty)
 *
 * @param {boLiveEmptyStateScheduleClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLiveEmptyStateScheduleClickParams>} LogObject<boLiveEmptyStateScheduleClickParams>
 */
export function boLiveEmptyStateScheduleClick(params) {
    return { evid: 466, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLiveGoLiveNowClick' event (evid: 468)
 *
 * Event description: Click on 'Go live now' button on 'Live Stream' tab
 *
 * @param {boLiveGoLiveNowClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video
 * @property {string} user_agent - user_agent
 * @property {string} button - main / scheduled_event
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {string} type - desktop / mobile
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLiveGoLiveNowClickParams>} LogObject<boLiveGoLiveNowClickParams>
 */
export function boLiveGoLiveNowClick(params) {
    return { evid: 468, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLiveGoLiveMobilePopUpOpened' event (evid: 469)
 *
 * Event description: 'Go live from your mobile'  pop up open
 *
 * @param {boLiveGoLiveMobilePopUpOpenedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLiveGoLiveMobilePopUpOpenedParams>} LogObject<boLiveGoLiveMobilePopUpOpenedParams>
 */
export function boLiveGoLiveMobilePopUpOpened(params) {
    return { evid: 469, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLibSearchClicked' event (evid: 47)
 *
 * Event description: Clicking on search video
 *
 * @param {boLibSearchClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLibSearchClickedParams>} LogObject<boLibSearchClickedParams>
 */
export function boLibSearchClicked(params) {
    return { evid: 47, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLiveGoLiveMobilePopUpClick' event (evid: 470)
 *
 * Event description: Click on 'Go live from your mobile'  pop
 *
 * @param {boLiveGoLiveMobilePopUpClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {string} button - close / got_it / download
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLiveGoLiveMobilePopUpClickParams>} LogObject<boLiveGoLiveMobilePopUpClickParams>
 */
export function boLiveGoLiveMobilePopUpClick(params) {
    return { evid: 470, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLiveEventEditClicked' event (evid: 473)
 *
 * Event description: click on Edit Event on Live stream tab
 *
 * @param {boLiveEventEditClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLiveEventEditClickedParams>} LogObject<boLiveEventEditClickedParams>
 */
export function boLiveEventEditClicked(params) {
    return { evid: 473, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLiveEditDeletePopUpOpened' event (evid: 474)
 *
 * Event description: 'Delete this live stream'  pop up open
 *
 * @param {boLiveEditDeletePopUpOpenedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLiveEditDeletePopUpOpenedParams>} LogObject<boLiveEditDeletePopUpOpenedParams>
 */
export function boLiveEditDeletePopUpOpened(params) {
    return { evid: 474, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLiveEditDeletePopUpClick' event (evid: 475)
 *
 * Event description: Click on 'Delete this live stream' pop up
 *
 * @param {boLiveEditDeletePopUpClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {string} button - close / delete / keep_editing
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLiveEditDeletePopUpClickParams>} LogObject<boLiveEditDeletePopUpClickParams>
 */
export function boLiveEditDeletePopUpClick(params) {
    return { evid: 475, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLiveStreamScheduledPopUpOpened' event (evid: 476)
 *
 * Event description: 'Your live stream has been scheduled'  pop up open
 *
 * @param {boLiveStreamScheduledPopUpOpenedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLiveStreamScheduledPopUpOpenedParams>} LogObject<boLiveStreamScheduledPopUpOpenedParams>
 */
export function boLiveStreamScheduledPopUpOpened(params) {
    return { evid: 476, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLiveStreamScheduledPopUpClick' event (evid: 477)
 *
 * Event description: Click on 'Your live stream has been scheduled'  pop up
 *
 * @param {boLiveStreamScheduledPopUpClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {boolean} dontShow - true / false
 * @property {string} button - close / got_it / wix_app / encoder
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLiveStreamScheduledPopUpClickParams>} LogObject<boLiveStreamScheduledPopUpClickParams>
 */
export function boLiveStreamScheduledPopUpClick(params) {
    return { evid: 477, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLibPricingClicked' event (evid: 48)
 *
 * Event description: Clicking on set pricing
 *
 * @param {boLibPricingClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {number} numberVideos - number of videos chosen
 * @property {GUID} _appId - app_id
 * @property {string} videoID - json of video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLibPricingClickedParams>} LogObject<boLibPricingClickedParams>
 */
export function boLibPricingClicked(params) {
    return { evid: 48, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLiveStreamKeyExpiredPopUpOpened' event (evid: 480)
 *
 * Event description: 'Your stream key has expired'  pop up open
 *
 * @param {boLiveStreamKeyExpiredPopUpOpenedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLiveStreamKeyExpiredPopUpOpenedParams>} LogObject<boLiveStreamKeyExpiredPopUpOpenedParams>
 */
export function boLiveStreamKeyExpiredPopUpOpened(params) {
    return { evid: 480, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLiveStreamKeyExpiredPopUpClick' event (evid: 481)
 *
 * Event description: Click on 'Your stream key has expired'  pop up
 *
 * @param {boLiveStreamKeyExpiredPopUpClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {string} button - close / got_it
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLiveStreamKeyExpiredPopUpClickParams>} LogObject<boLiveStreamKeyExpiredPopUpClickParams>
 */
export function boLiveStreamKeyExpiredPopUpClick(params) {
    return { evid: 481, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLibPricingSaveClicked' event (evid: 49)
 *
 * Event description: Clicking on save set pricing
 *
 * @param {boLibPricingSaveClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {boolean} rentalPeriodChange - did the rental period changed
 * @property {number} numberVideos - number of videos chosen
 * @property {number} purchasePricinig - the price for purchase doubled by 10000
 * @property {string} rentalPeriod - 24/48/72
 * @property {boolean} isDownload - if uou can download the video
 * @property {boolean} purchasableChange - did the purchase option changed
 * @property {GUID} _appId - app_id
 * @property {string} videoID - json of video_id
 * @property {string} user_agent - user_agent
 * @property {number} rentalPricinig - the price of renting doubled by 10000
 * @property {boolean} downloadChanged - If user changed the download option
 * @property {GUID} _instanceId - InstanceID
 * @property {boolean} purchasePricinigChange - did the purchase price changed
 * @property {string} _viewMode - view_mode
 * @property {boolean} rentalPricinigChange - did the rental price changed
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {string} pricingSelection - free/paid
 * @property {boolean} isPurchasable - is the videos for purchase
 * @property {boolean} isRental - is the videos for rental
 * @property {boolean} rentalChange - did the rental option changed
 * @property {GUID} _visitorId - visitor_id
 * @property {boolean} pricingSelectionChange - did the pricing selection changed
 * @return {LogObject<boLibPricingSaveClickedParams>} LogObject<boLibPricingSaveClickedParams>
 */
export function boLibPricingSaveClicked(params) {
    return { evid: 49, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetMainManageVideosClicked' event (evid: 5)
 *
 * Event description: Clicking on manage videos button
 *
 * @param {appSetMainManageVideosClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - classic, strip or compact
 * @property {boolean} isFirst - first time clicking on manage videos
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - 'my_account' | 'editor' | 'ADI'
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetMainManageVideosClickedParams>} LogObject<appSetMainManageVideosClickedParams>
 */
export function appSetMainManageVideosClicked(params) {
    return { evid: 5, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLibPricingSaveCompleted' event (evid: 50)
 *
 * Event description: Saving the set pricing completed
 *
 * @param {boLibPricingSaveCompletedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {boolean} rentalPeriodChange - did the rental period changed
 * @property {number} numberVideos - number of videos chosen
 * @property {number} purchasePricinig - the price for purchase doubled by 10000
 * @property {string} rentalPeriod - 24/48/72
 * @property {boolean} isDownload - if uou can download the video
 * @property {boolean} purchasableChange - did the purchase option changed
 * @property {GUID} _appId - app_id
 * @property {string} videoID - json of video_id
 * @property {string} user_agent - user_agent
 * @property {number} rentalPricinig - the price of renting doubled by 10000
 * @property {boolean} downloadChanged - If user changed the download option
 * @property {GUID} _instanceId - InstanceID
 * @property {boolean} purchasePricinigChange - did the purchase price changed
 * @property {string} _viewMode - view_mode
 * @property {boolean} rentalPricinigChange - did the rental price changed
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {string} pricingSelection - free/paid
 * @property {boolean} isPurchasable - is the videos for purchase
 * @property {boolean} isRental - is the videos for rental
 * @property {boolean} rentalChange - did the rental option changed
 * @property {GUID} _visitorId - visitor_id
 * @property {boolean} pricingSelectionChange - did the pricing selection changed
 * @return {LogObject<boLibPricingSaveCompletedParams>} LogObject<boLibPricingSaveCompletedParams>
 */
export function boLibPricingSaveCompleted(params) {
    return { evid: 50, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLibDeleteVideoClicked' event (evid: 51)
 *
 * Event description: Clicking  on delete video
 *
 * @param {boLibDeleteVideoClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {number} numberVideos - number of videos chosen
 * @property {GUID} _appId - app_id
 * @property {string} videoID - json of video_id
 * @property {string} user_agent - user_agent
 * @property {string} button - batch/video-page
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {number} overQuotaVideosCount - how many of the videos are OverQ
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLibDeleteVideoClickedParams>} LogObject<boLibDeleteVideoClickedParams>
 */
export function boLibDeleteVideoClicked(params) {
    return { evid: 51, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boUploadStart' event (evid: 52)
 *
 * Event description: Uploading single video started. It includes only Drag&drop and upload by clicking on a button for videos library and wellcome screens
 *
 * @param {boUploadStartParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} source - upload/drive/dropbox
 * @property {number} batchSize - amount of files
 * @property {boolean} isFirst - first time uploading
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {string} fileType - image / video / audio / doc / folder
 * @property {string} button - drag&drop /upload
 * @property {boolean} batch - several files in one import
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {number} fileSize - file size in KB
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} tracksUploaded - number of files, what was selected to upload including current
 * @property {string} compId - player_id
 * @property {string} correlationId - correlation_Id to join with 53 per video
 * @property {GUID} _visitorId - visitor_id
 * @property {string} uploadType - auto_resumed / user_resumed / common (upload)
 * @property {string} fileFormat - file extension
 * @return {LogObject<boUploadStartParams>} LogObject<boUploadStartParams>
 */
export function boUploadStart(params) {
    return { evid: 52, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boUploadCompleted' event (evid: 53)
 *
 * Event description: Uploading single video completed. It includes only Drag&drop and upload by clicking on a button for videos library and wellcome screens
 *
 * @param {boUploadCompletedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} source - upload/drive/dropbox
 * @property {string} path - url path of a http call that caused the error
 * @property {string} errorKey - wmp error key
 * @property {number} manual_resumed - count how many times (in current correlation_id) upload was resumed manually
 * @property {boolean} isFirst - first time uploading
 * @property {number} status_code - status code
 * @property {GUID} _appId - app_id
 * @property {string} errorScope - OK/failedChecking/failedRequirement/failedTransmission/failedByUseAction/failedProcessing
 * @property {boolean} isSuccess - did the upload succesed
 * @property {string} user_agent - user_agent
 * @property {string} fileType - image / video / audio / doc / folder
 * @property {string} button - drag&drop /upload
 * @property {GUID} _instanceId - InstanceID
 * @property {string} errorType - OK/networkError/serverError/unknownError/userClosedDashboard/quotaExceeded/invalidFile/notSupported/exceedsMaxSize
 * @property {string} _viewMode - view_mode
 * @property {number} loadingTime - loadingTime
 * @property {number} fileSize - file_size
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} tracksUploaded - number of files, what was selected to upload including current
 * @property {string} compId - player_id
 * @property {string} correlationId - correlation_id
 * @property {boolean} is_resumable - is download resume available for this file
 * @property {GUID} _visitorId - visitor_id
 * @property {number} auto_resumed - manual_resumed
 * @property {string} fileFormat - file extension
 * @return {LogObject<boUploadCompletedParams>} LogObject<boUploadCompletedParams>
 */
export function boUploadCompleted(params) {
    return { evid: 53, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLibDeleteVideoPopupCancelBtnClicked' event (evid: 54)
 *
 * Event description: Clicking  cancel delete video in the popup
 *
 * @param {boLibDeleteVideoPopupCancelBtnClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLibDeleteVideoPopupCancelBtnClickedParams>} LogObject<boLibDeleteVideoPopupCancelBtnClickedParams>
 */
export function boLibDeleteVideoPopupCancelBtnClicked(params) {
    return { evid: 54, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLibDeleteVideoPopupDeleteBtnClicked' event (evid: 55)
 *
 * Event description: Clicking delete in the delete video popup
 *
 * @param {boLibDeleteVideoPopupDeleteBtnClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {number} numberVideos - number of videos chosen
 * @property {GUID} _appId - app_id
 * @property {string} videoID - json of video_id
 * @property {string} user_agent - user_agent
 * @property {string} button - batch/video page
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLibDeleteVideoPopupDeleteBtnClickedParams>} LogObject<boLibDeleteVideoPopupDeleteBtnClickedParams>
 */
export function boLibDeleteVideoPopupDeleteBtnClicked(params) {
    return { evid: 55, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLibAddToChannelBtnClicked' event (evid: 56)
 *
 * Event description: Clicking add to channel
 *
 * @param {boLibAddToChannelBtnClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {number} numberVideos - number of videos chosen
 * @property {GUID} _appId - app_id
 * @property {string} videoID - json of video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLibAddToChannelBtnClickedParams>} LogObject<boLibAddToChannelBtnClickedParams>
 */
export function boLibAddToChannelBtnClicked(params) {
    return { evid: 56, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLibAddToChannelSaveBtnClicked' event (evid: 57)
 *
 * Event description: Clicking save button to add videos to channel
 *
 * @param {boLibAddToChannelSaveBtnClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {number} numberChannels - number of channels the video added to
 * @property {number} numberVideos - number of videos added
 * @property {GUID} _appId - app_id
 * @property {string} videoID - json of video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {number} overQuotaVideosCount - how many of the videos are OverQ
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - json of channel_id
 * @return {LogObject<boLibAddToChannelSaveBtnClickedParams>} LogObject<boLibAddToChannelSaveBtnClickedParams>
 */
export function boLibAddToChannelSaveBtnClicked(params) {
    return { evid: 57, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLibAddToChannelCancelBtnClicked' event (evid: 58)
 *
 * Event description: Clicking cancel add to channel
 *
 * @param {boLibAddToChannelCancelBtnClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boLibAddToChannelCancelBtnClickedParams>} LogObject<boLibAddToChannelCancelBtnClickedParams>
 */
export function boLibAddToChannelCancelBtnClicked(params) {
    return { evid: 58, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidDeleteVidBtnClicked' event (evid: 59)
 *
 * Event description: Clicking delete video
 *
 * @param {boVidDeleteVidBtnClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidDeleteVidBtnClickedParams>} LogObject<boVidDeleteVidBtnClickedParams>
 */
export function boVidDeleteVidBtnClicked(params) {
    return { evid: 59, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetLayoutLayoutChanged' event (evid: 6)
 *
 * Event description: Choosing layout between classic or strip
 *
 * @param {appSetLayoutLayoutChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {string} selection - classic/strip
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - editor / ADI (null is editor)
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetLayoutLayoutChangedParams>} LogObject<appSetLayoutLayoutChangedParams>
 */
export function appSetLayoutLayoutChanged(params) {
    return { evid: 6, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidDeleteVidPopupBtnClicked' event (evid: 60)
 *
 * Event description: Clicking delete or cancel in the delete video popup
 *
 * @param {boVidDeleteVidPopupBtnClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {string} button - delete/cancel
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {boolean} overQuoted - is video id under OverQuota, true / false
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidDeleteVidPopupBtnClickedParams>} LogObject<boVidDeleteVidPopupBtnClickedParams>
 */
export function boVidDeleteVidPopupBtnClicked(params) {
    return { evid: 60, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appLearnMoreClick' event (evid: 601)
 *
 * Event description: User click on"Learn More" button
 *
 * @param {appLearnMoreClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {string} pageName - from where user click on learn more (start_page,video_list etc.)
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appLearnMoreClickParams>} LogObject<appLearnMoreClickParams>
 */
export function appLearnMoreClick(params) {
    return { evid: 601, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appChooseScheduledVideoClick' event (evid: 602)
 *
 * Event description: User click on "choose scheduled video" button
 *
 * @param {appChooseScheduledVideoClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} entryPoint - from which entry point user see live screen (bottom_bar/quick_actions/feed_card/more_apps)
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appChooseScheduledVideoClickParams>} LogObject<appChooseScheduledVideoClickParams>
 */
export function appChooseScheduledVideoClick(params) {
    return { evid: 602, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appEnableAccessClick' event (evid: 603)
 *
 * Event description: User click on "Enable Access" button for camera and mic
 *
 * @param {appEnableAccessClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appEnableAccessClickParams>} LogObject<appEnableAccessClickParams>
 */
export function appEnableAccessClick(params) {
    return { evid: 603, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appAccessPopUpButtonClick' event (evid: 604)
 *
 * Event description: User clicks on "Don't Allow" / "Ok" in access pop up
 *
 * @param {appAccessPopUpButtonClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} privilegeName - microphone/camera etc
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {string} buttonName - dont_allow/ok
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appAccessPopUpButtonClickParams>} LogObject<appAccessPopUpButtonClickParams>
 */
export function appAccessPopUpButtonClick(params) {
    return { evid: 604, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appNextClick' event (evid: 605)
 *
 * Event description: User click on "Next" button when starting  live
 *
 * @param {appNextClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {string} videoType - scheduled/new
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channel_id
 * @return {LogObject<appNextClickParams>} LogObject<appNextClickParams>
 */
export function appNextClick(params) {
    return { evid: 605, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appCameraButtonClick' event (evid: 606)
 *
 * Event description: User click on camera button  in go live screen
 *
 * @param {appCameraButtonClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - from where user click on the button (new_video/schedualed_video,live)
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channel_id
 * @return {LogObject<appCameraButtonClickParams>} LogObject<appCameraButtonClickParams>
 */
export function appCameraButtonClick(params) {
    return { evid: 606, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appFlashButtonClick' event (evid: 607)
 *
 * Event description: User click on flash button in go live screen
 *
 * @param {appFlashButtonClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - from where user click on the button (new_video/schedualed_video,live)
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channel_id
 * @return {LogObject<appFlashButtonClickParams>} LogObject<appFlashButtonClickParams>
 */
export function appFlashButtonClick(params) {
    return { evid: 607, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appPageCloseClick' event (evid: 608)
 *
 * Event description: user click on close in live app
 *
 * @param {appPageCloseClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {string} pageName - page name
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channel_id
 * @return {LogObject<appPageCloseClickParams>} LogObject<appPageCloseClickParams>
 */
export function appPageCloseClick(params) {
    return { evid: 608, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appOrientationChanged' event (evid: 609)
 *
 * Event description: User changed orientation
 *
 * @param {appOrientationChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {string} orientation - portrait/landscape
 * @property {boolean} isLive - If user change orientation before live or when live streaming
 * @property {string} videoType - scheduled/new
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channel_id
 * @return {LogObject<appOrientationChangedParams>} LogObject<appOrientationChangedParams>
 */
export function appOrientationChanged(params) {
    return { evid: 609, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidChangeVideoClick' event (evid: 61)
 *
 * Event description: Clicking change video
 *
 * @param {boVidChangeVideoClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} source - computer/vimeo/facebook/youtube
 * @property {GUID} _appId - app_id
 * @property {string} videoID - old_videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {boolean} overQuoted - is video id under OverQuota, true / false
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidChangeVideoClickParams>} LogObject<boVidChangeVideoClickParams>
 */
export function boVidChangeVideoClick(params) {
    return { evid: 61, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appStartClick' event (evid: 610)
 *
 * Event description: User click on "Get started" / "Start New Live" button
 *
 * @param {appStartClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} entryPoint - from which entry point user see live screen (bottom_bar/quick_actions/feed_card/more_apps)
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {string} button - get_started/start_new live
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appStartClickParams>} LogObject<appStartClickParams>
 */
export function appStartClick(params) {
    return { evid: 610, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appErrorPageButtonClick' event (evid: 611)
 *
 * Event description: When user in error page and click on button:
 * Refresh - General error screen
 * Got It / Save to device - No option to resume live
 * Resume / End live - User can resume live or when user re-open the app
 *
 * @param {appErrorPageButtonClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id (if we have)
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} errorType - storage/connection_lost etc.
 * @property {number} errorCode - error code
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {string} buttonName - refresh/got_it/save_to_device/resume/end_live
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channel_id (if we have)
 * @return {LogObject<appErrorPageButtonClickParams>} LogObject<appErrorPageButtonClickParams>
 */
export function appErrorPageButtonClick(params) {
    return { evid: 611, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appDeleteVideoPopUpButtonClick' event (evid: 612)
 *
 * Event description: After clicking on Delete Video button ,User click on cancel / Delete in  delete pop up
 *
 * @param {appDeleteVideoPopUpButtonClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - video_list/end_screen
 * @property {string} compId - player_id
 * @property {string} buttonName - cancel/delete
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channel_id
 * @return {LogObject<appDeleteVideoPopUpButtonClickParams>} LogObject<appDeleteVideoPopUpButtonClickParams>
 */
export function appDeleteVideoPopUpButtonClick(params) {
    return { evid: 612, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appLearnHowClick' event (evid: 613)
 *
 * Event description: User click on "Learn How" when there is no channels on the selected site
 *
 * @param {appLearnHowClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appLearnHowClickParams>} LogObject<appLearnHowClickParams>
 */
export function appLearnHowClick(params) {
    return { evid: 613, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidChangeVideoCompleted' event (evid: 62)
 *
 * Event description: Changing video completed
 *
 * @param {boVidChangeVideoCompletedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} source - computer/vimeo/facebook/youtube
 * @property {GUID} _appId - app_id
 * @property {boolean} isSuccess - user changed the video success
 * @property {string} videoID - new_videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} errorType - error message if change not success
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidChangeVideoCompletedParams>} LogObject<boVidChangeVideoCompletedParams>
 */
export function boVidChangeVideoCompleted(params) {
    return { evid: 62, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appGoLiveGoLiveClick' event (evid: 620)
 *
 * Event description: User click on Go Live button  in go live screen
 *
 * @param {appGoLiveGoLiveClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - from where user click on the button (new_video/schedualed_video)
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channel_id
 * @return {LogObject<appGoLiveGoLiveClickParams>} LogObject<appGoLiveGoLiveClickParams>
 */
export function appGoLiveGoLiveClick(params) {
    return { evid: 620, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidChangeCoverClicked' event (evid: 63)
 *
 * Event description: Changing on change cover
 *
 * @param {boVidChangeCoverClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - new_videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidChangeCoverClickedParams>} LogObject<boVidChangeCoverClickedParams>
 */
export function boVidChangeCoverClicked(params) {
    return { evid: 63, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appNewLiveChannelTitleClick' event (evid: 630)
 *
 * Event description: User click on channel title button when starting new live
 *
 * @param {appNewLiveChannelTitleClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appNewLiveChannelTitleClickParams>} LogObject<appNewLiveChannelTitleClickParams>
 */
export function appNewLiveChannelTitleClick(params) {
    return { evid: 630, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appNewLiveChannelChooseClick' event (evid: 631)
 *
 * Event description: User click on channel to choose where to start new live
 *
 * @param {appNewLiveChannelChooseClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channel_id
 * @return {LogObject<appNewLiveChannelChooseClickParams>} LogObject<appNewLiveChannelChooseClickParams>
 */
export function appNewLiveChannelChooseClick(params) {
    return { evid: 631, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appNewLiveAddTitleClick' event (evid: 632)
 *
 * Event description: User click on "tap to add a title.."
 *
 * @param {appNewLiveAddTitleClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channel_id
 * @return {LogObject<appNewLiveAddTitleClickParams>} LogObject<appNewLiveAddTitleClickParams>
 */
export function appNewLiveAddTitleClick(params) {
    return { evid: 632, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appNewLiveScheduledStartSoonYesClick' event (evid: 633)
 *
 * Event description: user click on "Yes" button when want to start new live in "Your scheduled video <video name> to start soon" page
 *
 * @param {appNewLiveScheduledStartSoonYesClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channel_id
 * @return {LogObject<appNewLiveScheduledStartSoonYesClickParams>} LogObject<appNewLiveScheduledStartSoonYesClickParams>
 */
export function appNewLiveScheduledStartSoonYesClick(params) {
    return { evid: 633, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appNewLiveScheduledStartSoonNotNowClick' event (evid: 634)
 *
 * Event description: user click on "not now" button when want to start new live in "Your scheduled video <video name> to start soon" page
 *
 * @param {appNewLiveScheduledStartSoonNotNowClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channel_id
 * @return {LogObject<appNewLiveScheduledStartSoonNotNowClickParams>} LogObject<appNewLiveScheduledStartSoonNotNowClickParams>
 */
export function appNewLiveScheduledStartSoonNotNowClick(params) {
    return { evid: 634, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidChangeCoverCompleted' event (evid: 64)
 *
 * Event description: changing cover completed
 *
 * @param {boVidChangeCoverCompletedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} coverOrigin - upload/exist
 * @property {GUID} _appId - app_id
 * @property {string} videoID - new_videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidChangeCoverCompletedParams>} LogObject<boVidChangeCoverCompletedParams>
 */
export function boVidChangeCoverCompleted(params) {
    return { evid: 64, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appVideoListChooseClick' event (evid: 640)
 *
 * Event description: user click on video to choose scheduled video
 *
 * @param {appVideoListChooseClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} videoId - video_id
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channel_id
 * @return {LogObject<appVideoListChooseClickParams>} LogObject<appVideoListChooseClickParams>
 */
export function appVideoListChooseClick(params) {
    return { evid: 640, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appVideoListDeleteClick' event (evid: 642)
 *
 * Event description: user click on delete button
 *
 * @param {appVideoListDeleteClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} videoId - video_id
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channel_id
 * @return {LogObject<appVideoListDeleteClickParams>} LogObject<appVideoListDeleteClickParams>
 */
export function appVideoListDeleteClick(params) {
    return { evid: 642, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appGoLiveOnboardingStartLiveClick' event (evid: 643)
 *
 * Event description: User click on start live button in go live screen (onboarding  screen) - first/second time for free users and first time for premium user
 *
 * @param {appGoLiveOnboardingStartLiveClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {string} type - user type free/premium
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channel_id
 * @return {LogObject<appGoLiveOnboardingStartLiveClickParams>} LogObject<appGoLiveOnboardingStartLiveClickParams>
 */
export function appGoLiveOnboardingStartLiveClick(params) {
    return { evid: 643, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appGoLiveOnboardingMoreInfoClick' event (evid: 644)
 *
 * Event description: User click on more info button in go live screen (onboarding  screen)
 *
 * @param {appGoLiveOnboardingMoreInfoClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channel_id
 * @return {LogObject<appGoLiveOnboardingMoreInfoClickParams>} LogObject<appGoLiveOnboardingMoreInfoClickParams>
 */
export function appGoLiveOnboardingMoreInfoClick(params) {
    return { evid: 644, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appGoLiveShareClick' event (evid: 645)
 *
 * Event description: User click on share button in "Go Live" screen
 *
 * @param {appGoLiveShareClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channel_id
 * @return {LogObject<appGoLiveShareClickParams>} LogObject<appGoLiveShareClickParams>
 */
export function appGoLiveShareClick(params) {
    return { evid: 645, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageTrailerUploadStart' event (evid: 65)
 *
 * Event description: Clicking upload trailer
 *
 * @param {boVidPageTrailerUploadStartParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {string} button - drag-n-drop/upload
 * @property {GUID} _instanceId - InstanceID
 * @property {string} trailerID - trailerID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageTrailerUploadStartParams>} LogObject<boVidPageTrailerUploadStartParams>
 */
export function boVidPageTrailerUploadStart(params) {
    return { evid: 65, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appLiveStart' event (evid: 650)
 *
 * Event description: When live video recording start
 *
 * @param {appLiveStartParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channel_id
 * @return {LogObject<appLiveStartParams>} LogObject<appLiveStartParams>
 */
export function appLiveStart(params) {
    return { evid: 650, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appLiveCancelClick' event (evid: 651)
 *
 * Event description: User click on cancel after start live when live is lading or countdown
 *
 * @param {appLiveCancelClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - Form where user click cancel (after_live/before_live etc.)
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channel_id
 * @return {LogObject<appLiveCancelClickParams>} LogObject<appLiveCancelClickParams>
 */
export function appLiveCancelClick(params) {
    return { evid: 651, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appLiveStopClick' event (evid: 652)
 *
 * Event description: User click on stop after start live
 *
 * @param {appLiveStopClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channel_id
 * @return {LogObject<appLiveStopClickParams>} LogObject<appLiveStopClickParams>
 */
export function appLiveStopClick(params) {
    return { evid: 652, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appLiveCountdownMessageAppear' event (evid: 653)
 *
 * Event description: Countdown message appears to user
 *
 * @param {appLiveCountdownMessageAppearParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channel_id
 * @return {LogObject<appLiveCountdownMessageAppearParams>} LogObject<appLiveCountdownMessageAppearParams>
 */
export function appLiveCountdownMessageAppear(params) {
    return { evid: 653, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appLiveConnectionIssueStart' event (evid: 655)
 *
 * Event description: When user have connection issues (connection/storage etc)
 *
 * @param {appLiveConnectionIssueStartParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} errorType - storage/connection_lost etc.
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channel_id
 * @return {LogObject<appLiveConnectionIssueStartParams>} LogObject<appLiveConnectionIssueStartParams>
 */
export function appLiveConnectionIssueStart(params) {
    return { evid: 655, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appLiveEndSaveToDeviceClick' event (evid: 656)
 *
 * Event description: After live end user click on save to device button / notification (When some of this video recorded offline)
 *
 * @param {appLiveEndSaveToDeviceClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - buttton/notification
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channel_id
 * @return {LogObject<appLiveEndSaveToDeviceClickParams>} LogObject<appLiveEndSaveToDeviceClickParams>
 */
export function appLiveEndSaveToDeviceClick(params) {
    return { evid: 656, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appLiveEndShareClick' event (evid: 657)
 *
 * Event description: After live ends user click on share  button
 *
 * @param {appLiveEndShareClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channel_id
 * @return {LogObject<appLiveEndShareClickParams>} LogObject<appLiveEndShareClickParams>
 */
export function appLiveEndShareClick(params) {
    return { evid: 657, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appLiveEndDeleteVideoClick' event (evid: 658)
 *
 * Event description: After live ends user click on delete video button
 *
 * @param {appLiveEndDeleteVideoClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channel_id
 * @return {LogObject<appLiveEndDeleteVideoClickParams>} LogObject<appLiveEndDeleteVideoClickParams>
 */
export function appLiveEndDeleteVideoClick(params) {
    return { evid: 658, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appLiveEndCameraRollAccessButtonClick' event (evid: 659)
 *
 * Event description: in camera roll access user click on don't allow or ok
 *
 * @param {appLiveEndCameraRollAccessButtonClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {string} buttonName - ok/not
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channel_id
 * @return {LogObject<appLiveEndCameraRollAccessButtonClickParams>} LogObject<appLiveEndCameraRollAccessButtonClickParams>
 */
export function appLiveEndCameraRollAccessButtonClick(params) {
    return { evid: 659, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageTrailerUploadCompleted' event (evid: 66)
 *
 * Event description: Upload trailer completed
 *
 * @param {boVidPageTrailerUploadCompletedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {boolean} isSuccess - did the upload succesed
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {string} button - drag-n-drop/upload
 * @property {GUID} _instanceId - InstanceID
 * @property {string} errorType - error message user get if not success
 * @property {string} trailerID - trailerID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageTrailerUploadCompletedParams>} LogObject<boVidPageTrailerUploadCompletedParams>
 */
export function boVidPageTrailerUploadCompleted(params) {
    return { evid: 66, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appLiveEndSaveStart' event (evid: 660)
 *
 * Event description: After live ends user  click on save to device, save start
 *
 * @param {appLiveEndSaveStartParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} path - path
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channel_id
 * @return {LogObject<appLiveEndSaveStartParams>} LogObject<appLiveEndSaveStartParams>
 */
export function appLiveEndSaveStart(params) {
    return { evid: 660, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appLiveEndSaveEnd' event (evid: 661)
 *
 * Event description: Video save end after live
 *
 * @param {appLiveEndSaveEndParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} errorMessage - error message if save fail
 * @property {GUID} _appId - app_id
 * @property {boolean} isSuccess - if save success
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channel_id
 * @return {LogObject<appLiveEndSaveEndParams>} LogObject<appLiveEndSaveEndParams>
 */
export function appLiveEndSaveEnd(params) {
    return { evid: 661, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appLiveEndDeleteVideoGotItClick' event (evid: 663)
 *
 * Event description: After user delete video that ended and clicking on Got It button
 *
 * @param {appLiveEndDeleteVideoGotItClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channel_id
 * @return {LogObject<appLiveEndDeleteVideoGotItClickParams>} LogObject<appLiveEndDeleteVideoGotItClickParams>
 */
export function appLiveEndDeleteVideoGotItClick(params) {
    return { evid: 663, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appLiveConnectionIssueEnd' event (evid: 666)
 *
 * Event description: When connection issue end
 *
 * @param {appLiveConnectionIssueEndParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - video_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} errorType - storage/connection_lost etc.
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channel_id
 * @return {LogObject<appLiveConnectionIssueEndParams>} LogObject<appLiveConnectionIssueEndParams>
 */
export function appLiveConnectionIssueEnd(params) {
    return { evid: 666, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appLiveStreamInfo' event (evid: 667)
 *
 * Event description: Event with stream info for live(user stream)
 *
 * @param {appLiveStreamInfoParams} params - The parameters for this event
 * @property {GUID} biToken - biToken
 * @property {GUID} videoInstanceID - videoInstanceID
 * @property {GUID} _msid - biToken
 * @property {number} avgBitrate - Bitrate
 * @property {string} path - path
 * @property {string} streamingModuleVer - streaming module version
 * @property {GUID} _appId - app_id
 * @property {string} videoID - ID of video in terms of Wix VOD
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - videoInstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {string} rtmpEndPoint - RTMP end point
 * @property {string} timeFrame - The time in the video we shoot this event (Not the time the user see the movie)
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - Channel ID
 * @return {LogObject<appLiveStreamInfoParams>} LogObject<appLiveStreamInfoParams>
 */
export function appLiveStreamInfo(params) {
    return { evid: 667, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageSaveClick' event (evid: 67)
 *
 * Event description: Save clicked at the video page
 *
 * @param {boVidPageSaveClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {boolean} videoChanged - user changed the video from video library
 * @property {boolean} coverUploaded - did cover uploaded
 * @property {boolean} genreChanged - did the genre changed
 * @property {boolean} embedVideoTitle - video title on/off in embed options
 * @property {boolean} descriptionExists - did description added
 * @property {boolean} trailerChanged - did the trailer changed
 * @property {boolean} embedShare - share button in embed options on/off
 * @property {string} source - computer/vimeo/facebook/youtube
 * @property {boolean} rentalPeriodChange - did the rental period changed
 * @property {number} numVideoEdit - number of videos user edit
 * @property {string} genre - genre
 * @property {boolean} embedShareChanged - share button in embed options changed
 * @property {boolean} showTrailer - show trailer toggle on/off
 * @property {boolean} publisherExists - did publisher added
 * @property {boolean} embedLogoChanged - embed custom logo changed
 * @property {number} purchasePricinig - doubled by 10000
 * @property {boolean} categoryExists - did categories added
 * @property {string} rentalPeriod - 24/48/72
 * @property {boolean} isDownload - if uou can download the video
 * @property {string} audience - (all/mature)
 * @property {boolean} titleChanged - user changed the video title
 * @property {boolean} videoTypeChanged - did the video type changed
 * @property {number} numOfCrewMembers - number of crew members
 * @property {boolean} purchasableChange - did the purchase option changed
 * @property {boolean} embedInfoChanged - info button in embed option changed
 * @property {boolean} embed - embed toggle on/off
 * @property {GUID} _appId - app_id
 * @property {string} videoID - new_videoID
 * @property {string} user_agent - user_agent
 * @property {boolean} embedLogoOptionChanged - custom logo options changed (show on control bar/ always)
 * @property {number} rentalPricinig - doubled by 10000
 * @property {boolean} downloadChanged - If user changed the download option
 * @property {number} numOfCastMembers - number of cast members
 * @property {GUID} _instanceId - InstanceID
 * @property {boolean} dateStartLiveChanged - go live on date or hour changed
 * @property {boolean} purchasePricinigChange - did the purchase price changed
 * @property {boolean} signUpToWatch - sign up to watch toggle on/off
 * @property {boolean} embedInfo - info button in embed option on/off
 * @property {string} _viewMode - view_mode
 * @property {number} numOfTags - number of tags
 * @property {boolean} rentalPricinigChange - did the rental price changed
 * @property {boolean} overQuoted - is video id under OverQuota, true / false
 * @property {boolean} showTrailerChanged - show trailer toggle changed
 * @property {string} trailer - preview/traliler/auto_generated/DontShow
 * @property {DateTime} dateStartLive - go live on date & hour
 * @property {boolean} embedLogo - embed custom logo checkbox on/off
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {boolean} signUpToWatchChanged - user changed sign up to watch toggle
 * @property {string} compId - player_id
 * @property {string} pricingSelection - free/paid
 * @property {boolean} isPurchasable - is the videos for purchase
 * @property {boolean} embedVideoTitleChanged - video title in embed options changed
 * @property {boolean} embedChanged - if the user change the embed toggle
 * @property {boolean} isRental - is the videos for rental
 * @property {boolean} rentalChange - did the rental option changed
 * @property {string} videoType - video type
 * @property {boolean} posterExists - did poster uploaded
 * @property {GUID} _visitorId - visitor_id
 * @property {boolean} audienceChanged - did the audience changed
 * @property {boolean} pricingSelectionChange - did the pricing selection changed
 * @property {string} embedLogoOption - custom logo in embed options value (control_bar/always)
 * @return {LogObject<boVidPageSaveClickParams>} LogObject<boVidPageSaveClickParams>
 */
export function boVidPageSaveClick(params) {
    return { evid: 67, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageSaveSaveCompleted' event (evid: 68)
 *
 * Event description: Save completed at the video page / live event page
 *
 * @param {boVidPageSaveSaveCompletedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {boolean} videoChanged - user changed the video from video library
 * @property {boolean} coverUploaded - did cover uploaded
 * @property {boolean} genreChanged - did the genre changed
 * @property {boolean} embedVideoTitle - video title on/off in embed options
 * @property {boolean} descriptionExists - did description added
 * @property {boolean} trailerChanged - did the trailer changed
 * @property {boolean} embedShare - share button in embed options on/off
 * @property {string} source - computer/vimeo/facebook/youtube
 * @property {boolean} rentalPeriodChange - did the rental period changed
 * @property {number} numVideoEdit - number of videos user edit
 * @property {string} genre - genre
 * @property {boolean} embedShareChanged - share button in embed options changed
 * @property {boolean} showTrailer - show trailer toggle on/off
 * @property {boolean} publisherExists - did publisher added
 * @property {boolean} embedLogoChanged - embed custom logo changed
 * @property {number} purchasePricinig - doubled by 10000
 * @property {boolean} categoryExists - did categories added
 * @property {string} rentalPeriod - 24/48/72
 * @property {boolean} isDownload - if uou can download the video
 * @property {string} audience - (all/mature)
 * @property {boolean} titleChanged - user changed the video title
 * @property {boolean} videoTypeChanged - did the video type changed
 * @property {number} numOfCrewMembers - number of crew members
 * @property {boolean} purchasableChange - did the purchase option changed
 * @property {boolean} embedInfoChanged - info button in embed option changed
 * @property {boolean} embed - embed toggle on/off
 * @property {GUID} _appId - app_id
 * @property {boolean} isSuccess - save complete ok
 * @property {string} videoID - new_videoID
 * @property {string} user_agent - user_agent
 * @property {boolean} embedLogoOptionChanged - custom logo options changed (show on control bar/ always)
 * @property {number} rentalPricinig - doubled by 10000
 * @property {boolean} downloadChanged - If user changed the download option
 * @property {number} numOfCastMembers - number of cast members
 * @property {GUID} _instanceId - InstanceID
 * @property {string} errorType - error message when user tried to save
 * @property {boolean} dateStartLiveChanged - go live on date or hour changed
 * @property {boolean} purchasePricinigChange - did the purchase price changed
 * @property {boolean} signUpToWatch - sign up to watch toggle on/off
 * @property {boolean} embedInfo - info button in embed option on/off
 * @property {string} _viewMode - view_mode
 * @property {number} numOfTags - number of tags
 * @property {boolean} rentalPricinigChange - did the rental price changed
 * @property {boolean} overQuoted - is video id under OverQuota, true / false
 * @property {boolean} showTrailerChanged - show trailer toggle changed
 * @property {string} trailer - preview/traliler/auto_generated/DontShow
 * @property {DateTime} dateStartLive - go live on date & hour
 * @property {boolean} embedLogo - embed custom logo checkbox on/off
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {boolean} signUpToWatchChanged - user changed sign up to watch toggle
 * @property {string} compId - player_id
 * @property {string} pricingSelection - free/paid
 * @property {boolean} isPurchasable - is the videos for purchase
 * @property {boolean} embedVideoTitleChanged - video title in embed options changed
 * @property {boolean} embedChanged - if the user change the embed toggle
 * @property {boolean} isRental - is the videos for rental
 * @property {boolean} rentalChange - did the rental option changed
 * @property {string} videoType - video type
 * @property {boolean} posterExists - did poster uploaded
 * @property {GUID} _visitorId - visitor_id
 * @property {boolean} audienceChanged - did the audience changed
 * @property {string} channelID - channel is for scheduled live
 * @property {boolean} pricingSelectionChange - did the pricing selection changed
 * @property {string} embedLogoOption - custom logo in embed options value (control_bar/always)
 * @return {LogObject<boVidPageSaveSaveCompletedParams>} LogObject<boVidPageSaveSaveCompletedParams>
 */
export function boVidPageSaveSaveCompleted(params) {
    return { evid: 68, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boChNewChannelClicked' event (evid: 69)
 *
 * Event description: Add new channel clicked
 *
 * @param {boChNewChannelClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} channelType - channel/youtube-feed
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {string} button - button/box
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boChNewChannelClickedParams>} LogObject<boChNewChannelClickedParams>
 */
export function boChNewChannelClicked(params) {
    return { evid: 69, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetLayoutLayoutWidthChanged' event (evid: 7)
 *
 * Event description: Choosing layout width between full or strip
 * (a strip layout event)
 *
 * @param {appSetLayoutLayoutWidthChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {string} selection - full_width/page_width
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetLayoutLayoutWidthChangedParams>} LogObject<appSetLayoutLayoutWidthChangedParams>
 */
export function appSetLayoutLayoutWidthChanged(params) {
    return { evid: 7, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boChSearchClicked' event (evid: 70)
 *
 * Event description: Search clicked
 *
 * @param {boChSearchClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boChSearchClickedParams>} LogObject<boChSearchClickedParams>
 */
export function boChSearchClicked(params) {
    return { evid: 70, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boChStatsBtnClicked' event (evid: 71)
 *
 * Event description: Stats button clicked
 *
 * @param {boChStatsBtnClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channelID
 * @return {LogObject<boChStatsBtnClickedParams>} LogObject<boChStatsBtnClickedParams>
 */
export function boChStatsBtnClicked(params) {
    return { evid: 71, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boChDefaultChTooltipSettingsHover' event (evid: 72)
 *
 * Event description: Tool tip settings hovered in the default channel
 *
 * @param {boChDefaultChTooltipSettingsHoverParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channelID
 * @return {LogObject<boChDefaultChTooltipSettingsHoverParams>} LogObject<boChDefaultChTooltipSettingsHoverParams>
 */
export function boChDefaultChTooltipSettingsHover(params) {
    return { evid: 72, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boChEditOpened' event (evid: 73)
 *
 * Event description: Open edit channel
 *
 * @param {boChEditOpenedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} channelType - channel/youtube-feed
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channelID
 * @return {LogObject<boChEditOpenedParams>} LogObject<boChEditOpenedParams>
 */
export function boChEditOpened(params) {
    return { evid: 73, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boChEditDeleteChClicked' event (evid: 74)
 *
 * Event description: Delete channel clicked
 *
 * @param {boChEditDeleteChClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channelID
 * @return {LogObject<boChEditDeleteChClickedParams>} LogObject<boChEditDeleteChClickedParams>
 */
export function boChEditDeleteChClicked(params) {
    return { evid: 74, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boChEditDeleteChPopUpBtnClicked' event (evid: 75)
 *
 * Event description: Delete or cancel clicked in the delete channel popup
 *
 * @param {boChEditDeleteChPopUpBtnClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {string} button - delete/cancel
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channelID
 * @return {LogObject<boChEditDeleteChPopUpBtnClickedParams>} LogObject<boChEditDeleteChPopUpBtnClickedParams>
 */
export function boChEditDeleteChPopUpBtnClicked(params) {
    return { evid: 75, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boChEditUpdateChangesClicked' event (evid: 76)
 *
 * Event description: Update Changes clicked or channel start to be created from library, clicking "add to new channel"
 *
 * @param {boChEditUpdateChangesClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {boolean} descriptionExists - description channel exists
 * @property {boolean} subscriptionOnly - "make paid videos on this channel subscription only" on/off
 * @property {number} numberVideos - number videos in the channel
 * @property {boolean} subscriptionEnabledChange - did you change the subscription option
 * @property {GUID} _appId - app_id
 * @property {number} subscriptionPricing - doubled by 10000
 * @property {string} videoID - JSON video_id
 * @property {string} user_agent - user_agent
 * @property {boolean} featuredSelected - featured video selected
 * @property {boolean} titleAdded - title added
 * @property {boolean} subscriptionOnlyChange - "make paid videos on this channel subscription only" changed
 * @property {boolean} subscriptionPricingChange - did the price of the subscription change
 * @property {string} button - popup/button/library
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {number} overQuotaVideosCount - how many of the videos are OverQ
 * @property {number} numOfTags - num of tags
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {boolean} coverAdded - cover added
 * @property {string} compId - player_id
 * @property {boolean} subscriptionEnabled - subscription enabled
 * @property {boolean} hasCustomCover - has channel custom cover
 * @property {boolean} scheduledExists - scheduled video exists
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channelID
 * @property {boolean} isYouTubeFeed - if channel is youtube feed
 * @return {LogObject<boChEditUpdateChangesClickedParams>} LogObject<boChEditUpdateChangesClickedParams>
 */
export function boChEditUpdateChangesClicked(params) {
    return { evid: 76, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boChEditUpdateChangesCompleted' event (evid: 77)
 *
 * Event description: Update Changes completed or channel created from library, clicking "add to new channel"
 *
 * @param {boChEditUpdateChangesCompletedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {boolean} descriptionExists - description channel exists
 * @property {boolean} subscriptionOnly - "make paid videos on this channel subscription only" on/off
 * @property {number} numberVideos - number videos in the channel
 * @property {string} errorMsg - the error message if save failed
 * @property {boolean} subscriptionEnabledChange - did you change the subscription option
 * @property {GUID} _appId - app_id
 * @property {boolean} isSuccess - save success or not
 * @property {number} subscriptionPricing - doubled by 10000
 * @property {string} videoID - JSON video_id
 * @property {string} user_agent - user_agent
 * @property {boolean} featuredSelected - featured video selected
 * @property {boolean} titleAdded - title added
 * @property {boolean} subscriptionOnlyChange - "make paid videos on this channel subscription only" changed
 * @property {boolean} subscriptionPricingChange - did the price of the subscription change
 * @property {string} button - popup/button/library
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {number} overQuotaVideosCount - how many of the videos are OverQ
 * @property {number} numOfTags - num of tags
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {boolean} coverAdded - cover added
 * @property {string} compId - player_id
 * @property {boolean} subscriptionEnabled - subscription enabled
 * @property {boolean} hasCustomCover - has channel custom cover
 * @property {boolean} scheduledExists - scheduled video exists
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channelID
 * @property {boolean} isYouTubeFeed - if channel is youtube feed
 * @return {LogObject<boChEditUpdateChangesCompletedParams>} LogObject<boChEditUpdateChangesCompletedParams>
 */
export function boChEditUpdateChangesCompleted(params) {
    return { evid: 77, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boChEditLaterBtnClicked' event (evid: 78)
 *
 * Event description: Later button clicked
 *
 * @param {boChEditLaterBtnClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channelID
 * @return {LogObject<boChEditLaterBtnClickedParams>} LogObject<boChEditLaterBtnClickedParams>
 */
export function boChEditLaterBtnClicked(params) {
    return { evid: 78, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boChEditScheduleClicked' event (evid: 79)
 *
 * Event description: Schedule button clicked
 *
 * @param {boChEditScheduleClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} source - computer/dropbox/drive/youtube/vimeo/facebook
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} action - set/change
 * @property {string} channelID - channelID
 * @return {LogObject<boChEditScheduleClickedParams>} LogObject<boChEditScheduleClickedParams>
 */
export function boChEditScheduleClicked(params) {
    return { evid: 79, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'siteBaseMigrationPopUpShown' event (evid: 796)
 *
 * Event description: Site Base Migration success pop up has been shown
 *
 * @param {siteBaseMigrationPopUpShownParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} uuid - uuid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<siteBaseMigrationPopUpShownParams>} LogObject<siteBaseMigrationPopUpShownParams>
 */
export function siteBaseMigrationPopUpShown(params) {
    return { evid: 796, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'siteBaseMigrationPopUpLearnMoreClick' event (evid: 797)
 *
 * Event description: Click on learn more on Site Base Migration success pop up
 *
 * @param {siteBaseMigrationPopUpLearnMoreClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} uuid - uuid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<siteBaseMigrationPopUpLearnMoreClickParams>} LogObject<siteBaseMigrationPopUpLearnMoreClickParams>
 */
export function siteBaseMigrationPopUpLearnMoreClick(params) {
    return { evid: 797, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'siteBaseMigrationStarted' event (evid: 798)
 *
 * Event description: Site Base Migration for reg users triggered by Video BO open started
 *
 * @param {siteBaseMigrationStartedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} uuid - uuid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<siteBaseMigrationStartedParams>} LogObject<siteBaseMigrationStartedParams>
 */
export function siteBaseMigrationStarted(params) {
    return { evid: 798, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'siteBaseMigrationFinished' event (evid: 799)
 *
 * Event description: Site Base Migration for reg users triggered by Video BO open finished
 *
 * @param {siteBaseMigrationFinishedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {number} videosCount - videos_count
 * @property {GUID} uuid - uuid
 * @property {number} sitesCount - sites_count
 * @property {GUID} _appId - app_id
 * @property {boolean} isSuccess - did the migration succeed
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} errorType - error
 * @property {number} uploadedVideosDuration - ms, uploaded_videos_duration to see overquota
 * @property {string} _viewMode - view_mode
 * @property {number} loadingTime - ms, migration process duration
 * @property {boolean} overQuoted - is overQuoted before migration (at least one video marked as OQ)
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<siteBaseMigrationFinishedParams>} LogObject<siteBaseMigrationFinishedParams>
 */
export function siteBaseMigrationFinished(params) {
    return { evid: 799, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetSettingsChannelOptionsShareChanged' event (evid: 8)
 *
 * Event description: Choosing to let the viewers share my channel or not
 *
 * @param {appSetSettingsChannelOptionsShareChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - compact / classic etc
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {boolean} isShare - let the viewers share my channel or not
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - editor / ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetSettingsChannelOptionsShareChangedParams>} LogObject<appSetSettingsChannelOptionsShareChangedParams>
 */
export function appSetSettingsChannelOptionsShareChanged(params) {
    return { evid: 8, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boChEditScheduleSaved' event (evid: 80)
 *
 * Event description: Schedule save
 *
 * @param {boChEditScheduleSavedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} source - computer/dropbox/drive/youtube/vimeo/facebook
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} action - create/change
 * @property {string} channelID - channelID
 * @return {LogObject<boChEditScheduleSavedParams>} LogObject<boChEditScheduleSavedParams>
 */
export function boChEditScheduleSaved(params) {
    return { evid: 80, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boChEditRemoveClicked' event (evid: 81)
 *
 * Event description: Remove video form channel clicked
 *
 * @param {boChEditRemoveClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channelID
 * @return {LogObject<boChEditRemoveClickedParams>} LogObject<boChEditRemoveClickedParams>
 */
export function boChEditRemoveClicked(params) {
    return { evid: 81, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boTrailerShowToast' event (evid: 816)
 *
 * Event description: 'your trailer for <yourVideo> is ready' toast appears after successful auto trailer generation
 *
 * @param {boTrailerShowToastParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - player_id
 * @property {string} message - toast message
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channelID
 * @return {LogObject<boTrailerShowToastParams>} LogObject<boTrailerShowToastParams>
 */
export function boTrailerShowToast(params) {
    return { evid: 816, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boTrailerClickOnToast' event (evid: 817)
 *
 * Event description: Fired when user has interaction with auto-generated trailer's toast
 *
 * @param {boTrailerClickOnToastParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {string} button - check_it_out / close
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boTrailerClickOnToastParams>} LogObject<boTrailerClickOnToastParams>
 */
export function boTrailerClickOnToast(params) {
    return { evid: 817, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boTrailerPreview' event (evid: 818)
 *
 * Event description: Fired when clicks on 'Preview' on an auto-generated trailer.
 *
 * @param {boTrailerPreviewParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - instance_id
 * @property {GUID} _msid - msid
 * @property {string} videoId - .
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - instance_id
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boTrailerPreviewParams>} LogObject<boTrailerPreviewParams>
 */
export function boTrailerPreview(params) {
    return { evid: 818, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boTrailerShowFailToast' event (evid: 819)
 *
 * Event description: 'your trailer for <yourVideo> couldn't be created' toast appears after unsuccessful auto trailer generation
 *
 * @param {boTrailerShowFailToastParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} errorType - indication of why auto-generation didn't succeed
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - player_id
 * @property {string} message - toast message
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channelID
 * @return {LogObject<boTrailerShowFailToastParams>} LogObject<boTrailerShowFailToastParams>
 */
export function boTrailerShowFailToast(params) {
    return { evid: 819, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boChEditRemovePopUpBtnClicked' event (evid: 82)
 *
 * Event description: Button delete or cancel in the remove video form channel popup
 *
 * @param {boChEditRemovePopUpBtnClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {string} button - delete/cancel
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {boolean} overQuoted - is video id under OverQuota, true / false
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channelID
 * @return {LogObject<boChEditRemovePopUpBtnClickedParams>} LogObject<boChEditRemovePopUpBtnClickedParams>
 */
export function boChEditRemovePopUpBtnClicked(params) {
    return { evid: 82, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boTrailerClickOnFailToast' event (evid: 820)
 *
 * Event description: Fired when user has interaction with auto-generated trailer's fail toast
 *
 * @param {boTrailerClickOnFailToastParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {string} button - go_to_video / x
 * @property {GUID} _instanceId - InstanceID
 * @property {string} errorType - indication of why auto-generation didn't succeed
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boTrailerClickOnFailToastParams>} LogObject<boTrailerClickOnFailToastParams>
 */
export function boTrailerClickOnFailToast(params) {
    return { evid: 820, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boTrailerFailMessageClick' event (evid: 821)
 *
 * Event description: User clicked on one of the buttons in the auto-generated trailer fail message
 *
 * @param {boTrailerFailMessageClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {string} button - contact_customer_care / try_again
 * @property {GUID} _instanceId - InstanceID
 * @property {string} errorType - error type
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channelID
 * @return {LogObject<boTrailerFailMessageClickParams>} LogObject<boTrailerFailMessageClickParams>
 */
export function boTrailerFailMessageClick(params) {
    return { evid: 821, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boTrailerToggleClick' event (evid: 822)
 *
 * Event description: Click on the toggle button to open or close the trailer section
 *
 * @param {boTrailerToggleClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} source - computer/dropbox/drive/youtube/vimeo/facebook
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} action - open / close
 * @property {string} channelID - channelID
 * @return {LogObject<boTrailerToggleClickParams>} LogObject<boTrailerToggleClickParams>
 */
export function boTrailerToggleClick(params) {
    return { evid: 822, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boSectionHover' event (evid: 823)
 *
 * Event description: Hover over section.
 * e.g. hover over the trailer section in video edit page at BO, only when trailer section is open (toggle is on).
 *
 * @param {boSectionHoverParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} section - trailer
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channelID
 * @return {LogObject<boSectionHoverParams>} LogObject<boSectionHoverParams>
 */
export function boSectionHover(params) {
    return { evid: 823, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetPlayerAblitiesChanged' event (evid: 824)
 *
 * Event description: User changed player ability: added or removed playback speed / quality / subtitles
 *
 * @param {appSetPlayerAblitiesChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - classic/strip/compact
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {string} target - playback_speed, quality, subtitles
 * @property {GUID} _visitorId - visitor_id
 * @property {string} action - enable, disable
 * @return {LogObject<appSetPlayerAblitiesChangedParams>} LogObject<appSetPlayerAblitiesChangedParams>
 */
export function appSetPlayerAblitiesChanged(params) {
    return { evid: 824, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'playerVideoSettingsMenuOpen' event (evid: 825)
 *
 * Event description: UoU clicked on settings button in a video
 *
 * @param {playerVideoSettingsMenuOpenParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - widget, embed
 * @property {string} compId - player_id
 * @property {string} correlationId - ID for one unique view connection
 * @property {string} videoType - live/upload/youtube/vimeo/facebook
 * @property {GUID} _visitorId - visitorID
 * @property {string} channelID - channelID
 * @return {LogObject<playerVideoSettingsMenuOpenParams>} LogObject<playerVideoSettingsMenuOpenParams>
 */
export function playerVideoSettingsMenuOpen(params) {
    return { evid: 825, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'playerVideoSettingsMenuClick' event (evid: 826)
 *
 * Event description: UoU clicked on a setting category
 *
 * @param {playerVideoSettingsMenuClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - widget, embed
 * @property {string} compId - player_id
 * @property {string} target - speed, subtitles, quality
 * @property {string} correlationId - ID for one unique view connection
 * @property {string} videoType - live/upload/youtube/vimeo/facebook
 * @property {GUID} _visitorId - visitorID
 * @property {string} channelID - channelID
 * @return {LogObject<playerVideoSettingsMenuClickParams>} LogObject<playerVideoSettingsMenuClickParams>
 */
export function playerVideoSettingsMenuClick(params) {
    return { evid: 826, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'playerVideoSettingsChange' event (evid: 827)
 *
 * Event description: UoU changed the settings of the video they watch.
 *
 * @param {playerVideoSettingsChangeParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} visitorID - visitorID
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - widget, embed
 * @property {string} compId - player_id
 * @property {string} target - speed, subtitles, quality
 * @property {string} correlationId - ID for one unique view connection
 * @property {string} videoType - live/upload/youtube/vimeo/facebook
 * @property {GUID} _visitorId - visitorID
 * @property {string} value - percentage of speed or quality value
 * @property {string} channelID - channelID
 * @return {LogObject<playerVideoSettingsChangeParams>} LogObject<playerVideoSettingsChangeParams>
 */
export function playerVideoSettingsChange(params) {
    return { evid: 827, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetDesignSubSectionOpen' event (evid: 828)
 *
 * Event description: In setting -> design tab, user opened a sub section: Text / Buttons / Player
 *
 * @param {appSetDesignSubSectionOpenParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} layoutType - layout type
 * @property {string} section - Text, Buttons, Player
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetDesignSubSectionOpenParams>} LogObject<appSetDesignSubSectionOpenParams>
 */
export function appSetDesignSubSectionOpen(params) {
    return { evid: 828, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetVideosSearchChannels' event (evid: 829)
 *
 * Event description: User searched channel in Videos tab in Setting.
 *
 * @param {appSetVideosSearchChannelsParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {string} target - search term
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetVideosSearchChannelsParams>} LogObject<appSetVideosSearchChannelsParams>
 */
export function appSetVideosSearchChannels(params) {
    return { evid: 829, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boChEditAddVidsClick' event (evid: 83)
 *
 * Event description: Add video button click
 *
 * @param {boChEditAddVidsClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channelID
 * @return {LogObject<boChEditAddVidsClickParams>} LogObject<boChEditAddVidsClickParams>
 */
export function boChEditAddVidsClick(params) {
    return { evid: 83, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'widgetMigrateIdsToSettingsParams' event (evid: 830)
 *
 * Event description: Migrate channelId and videoId strings from styleParams to settingsParams. Starts when a user opens the editor
 *
 * @param {widgetMigrateIdsToSettingsParamsParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - instance_id
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - instance_id
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<widgetMigrateIdsToSettingsParamsParams>} LogObject<widgetMigrateIdsToSettingsParamsParams>
 */
export function widgetMigrateIdsToSettingsParams(params) {
    return { evid: 830, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boStorageToastAppear' event (evid: 831)
 *
 * Event description: Toast appear when user exceed / about to exceed storage limit
 *
 * @param {boStorageToastAppearParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - instance_id
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {string} storage_status - about_to_exceed, exceed
 * @property {GUID} _instanceId - instance_id
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - comp id
 * @property {GUID} _visitorId - visitor_id
 * @property {boolean} upgrade_available - true / false
 * @return {LogObject<boStorageToastAppearParams>} LogObject<boStorageToastAppearParams>
 */
export function boStorageToastAppear(params) {
    return { evid: 831, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boStorageExceedingPopUpAppear' event (evid: 832)
 *
 * Event description: ‘Your storage is full’ pop up is shown
 *
 * @param {boStorageExceedingPopUpAppearParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - instance_id
 * @property {GUID} _msid - msid
 * @property {string} source - source
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - instance_id
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - comp id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boStorageExceedingPopUpAppearParams>} LogObject<boStorageExceedingPopUpAppearParams>
 */
export function boStorageExceedingPopUpAppear(params) {
    return { evid: 832, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boStorageLimitationsAheadPopUpAppear' event (evid: 833)
 *
 * Event description: Warning of the enforcement of video hours
 *
 * @param {boStorageLimitationsAheadPopUpAppearParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - instance_id
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {string} storage_status - not_exceeding, about_to_exceed, exceed
 * @property {GUID} _instanceId - instance_id
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - comp id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boStorageLimitationsAheadPopUpAppearParams>} LogObject<boStorageLimitationsAheadPopUpAppearParams>
 */
export function boStorageLimitationsAheadPopUpAppear(params) {
    return { evid: 833, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boStorageUpgradeButtonClick' event (evid: 834)
 *
 * Event description: User clicks on the upgrade button via the storage referrals
 *
 * @param {boStorageUpgradeButtonClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - instance_id
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {string} storage_status - not_exceeding, about_to_exceed, exceed
 * @property {GUID} _instanceId - instance_id
 * @property {string} upgrade_origin - toast,  storage_is_full_popup, limitations_ahead_popup
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - comp id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boStorageUpgradeButtonClickParams>} LogObject<boStorageUpgradeButtonClickParams>
 */
export function boStorageUpgradeButtonClick(params) {
    return { evid: 834, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boStorageLearnMoreClick' event (evid: 835)
 *
 * Event description: User clicks on ‘Learn More’ button or link which leads to KBs with more info
 *
 * @param {boStorageLearnMoreClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - instance_id
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {string} storage_status - not_exceeding, about_to_exceed, exceed
 * @property {GUID} _instanceId - instance_id
 * @property {string} upgrade_origin - upgrade_origin
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - comp id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boStorageLearnMoreClickParams>} LogObject<boStorageLearnMoreClickParams>
 */
export function boStorageLearnMoreClick(params) {
    return { evid: 835, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boTranscodeFinish' event (evid: 836)
 *
 * Event description: Shoots when transcoding is finished with indication for success.
 *
 * @param {boTranscodeFinishParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} source - upload/drive/dropbox
 * @property {string} path - url path of a http call that caused the error
 * @property {string} errorKey - wmp error key
 * @property {GUID} _appId - app_id
 * @property {boolean} isSuccess - did the upload succesed
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} errorType - OK/networkError/serverError/unknownError/userClosedDashboard/quotaExceeded/invalidFile/notSupported/exceedsMaxSize
 * @property {string} _viewMode - view_mode
 * @property {number} loadingTime - loadingTime
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {string} correlationId - correlation_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boTranscodeFinishParams>} LogObject<boTranscodeFinishParams>
 */
export function boTranscodeFinish(params) {
    return { evid: 836, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boChEditAddVidsCompleted' event (evid: 84)
 *
 * Event description: Choose video to add
 *
 * @param {boChEditAddVidsCompletedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} source - computer/dropbox/drive/youtube/vimeo/facebook
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {boolean} overQuoted - is video id under OverQuota, true / false
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channelID
 * @return {LogObject<boChEditAddVidsCompletedParams>} LogObject<boChEditAddVidsCompletedParams>
 */
export function boChEditAddVidsCompleted(params) {
    return { evid: 84, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boChEditChCoverUpload' event (evid: 85)
 *
 * Event description: Upload cover
 *
 * @param {boChEditChCoverUploadParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} mediaType - picture/video
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {string} button - drag-n-drop/upload/change
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - player_id
 * @property {string} coverID - coverID
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channelID
 * @return {LogObject<boChEditChCoverUploadParams>} LogObject<boChEditChCoverUploadParams>
 */
export function boChEditChCoverUpload(params) {
    return { evid: 85, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boChEditChCoverCompleted' event (evid: 86)
 *
 * Event description: Upload cover completed
 *
 * @param {boChEditChCoverCompletedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} mediaType - picture/video
 * @property {string} errorMsg - error message if fail
 * @property {GUID} _appId - app_id
 * @property {boolean} isSuccess - is_success
 * @property {string} user_agent - user_agent
 * @property {string} button - drag-n-drop/upload/change
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - player_id
 * @property {string} coverID - coverID
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channelID
 * @return {LogObject<boChEditChCoverCompletedParams>} LogObject<boChEditChCoverCompletedParams>
 */
export function boChEditChCoverCompleted(params) {
    return { evid: 86, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boChEditVidReordered' event (evid: 87)
 *
 * Event description: Video reordered
 *
 * @param {boChEditVidReorderedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channelID
 * @return {LogObject<boChEditVidReorderedParams>} LogObject<boChEditVidReorderedParams>
 */
export function boChEditVidReordered(params) {
    return { evid: 87, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boChEditFindVidClicked' event (evid: 88)
 *
 * Event description: Find video clicked
 *
 * @param {boChEditFindVidClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - origin
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} channelID - channelID
 * @return {LogObject<boChEditFindVidClickedParams>} LogObject<boChEditFindVidClickedParams>
 */
export function boChEditFindVidClicked(params) {
    return { evid: 88, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boSettingsPayPalDisconnectCompleted' event (evid: 89)
 *
 * Event description: Disconnection from paypal has been completed
 *
 * @param {boSettingsPayPalDisconnectCompletedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} uuid - uuid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boSettingsPayPalDisconnectCompletedParams>} LogObject<boSettingsPayPalDisconnectCompletedParams>
 */
export function boSettingsPayPalDisconnectCompleted(params) {
    return { evid: 89, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetSettingsChannelOptionsShowVideoListChanged' event (evid: 9)
 *
 * Event description: Choosing to show video list or not
 * (a strip layout event)
 *
 * @param {appSetSettingsChannelOptionsShowVideoListChangedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - mandatory
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {boolean} isShowVideoList - Choosing to show video list or not
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetSettingsChannelOptionsShowVideoListChangedParams>} LogObject<appSetSettingsChannelOptionsShowVideoListChangedParams>
 */
export function appSetSettingsChannelOptionsShowVideoListChanged(params) {
    return { evid: 9, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLibUploadError' event (evid: 90)
 *
 * Event description: Uploading  error  display
 *
 * @param {boLibUploadErrorParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {number} manual_resumed - count how many times upload was resumed manually
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {string} fileType - image / video / audio / doc / folder
 * @property {GUID} _instanceId - InstanceID
 * @property {string} errorType - Unsupported format/Invalid video file/File exceeds max size/Unsupported code/Network connection issue/Unknown error resume_error / technical_issue / connectivity_issue
 * @property {string} _viewMode - view_mode
 * @property {number} fileSize - file size in KB
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - ADI / editor / МА
 * @property {string} compId - player_id
 * @property {string} correlationId - id to find one upload process (same as 71:52)
 * @property {boolean} is_resumable - is download resume available for this file
 * @property {GUID} _visitorId - visitor_id
 * @property {number} auto_resumed - count how many times (in current correlation_id) upload was resumed automatically
 * @property {string} fileFormat - file extension
 * @return {LogObject<boLibUploadErrorParams>} LogObject<boLibUploadErrorParams>
 */
export function boLibUploadError(params) {
    return { evid: 90, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLibUploadErrorBtnClick' event (evid: 91)
 *
 * Event description: Clicking a button (Replace file/Clear/Try again) after uploading  error  displayed
 *
 * @param {boLibUploadErrorBtnClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {string} fileType - image / video / audio / doc / folder
 * @property {string} button - Replace file/Clear/Try again
 * @property {GUID} _instanceId - InstanceID
 * @property {string} errorType - Unsupported format/Invalid video file/File exceeds max size/Unsupported codec/Network connection issue/Unknown error
 * @property {string} _viewMode - view_mode
 * @property {number} fileSize - file size in KB
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - ADI / editor / МА
 * @property {string} compId - player_id
 * @property {string} target - resume / clear / replace file / retry
 * @property {string} correlationId - id to find one upload process (same as 71:52)
 * @property {GUID} _visitorId - visitor_id
 * @property {string} fileFormat - file extension
 * @return {LogObject<boLibUploadErrorBtnClickParams>} LogObject<boLibUploadErrorBtnClickParams>
 */
export function boLibUploadErrorBtnClick(params) {
    return { evid: 91, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLibUpgradeState' event (evid: 92)
 *
 * Event description: Exceeding free or payed package limitations
 *
 * @param {boLibUpgradeStateParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} upgradeState - free_more_than_10/free_more_30_min_package/exceeds_package_limit
 * @return {LogObject<boLibUpgradeStateParams>} LogObject<boLibUpgradeStateParams>
 */
export function boLibUpgradeState(params) {
    return { evid: 92, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boLibUpgradeStateButtonClick' event (evid: 93)
 *
 * Event description: Clicking a button (Upgrade Now /Clear) in upgrade state
 *
 * @param {boLibUpgradeStateButtonClickParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} buttonType - state/tool_tip
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {string} button - Upgrade_Now /Clear
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {boolean} overQuoted - is video id under OverQuota, true / false
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @property {string} upgradeState - free_more_than_10/free_more_30_min_package/exceeds_package_limit
 * @return {LogObject<boLibUpgradeStateButtonClickParams>} LogObject<boLibUpgradeStateButtonClickParams>
 */
export function boLibUpgradeStateButtonClick(params) {
    return { evid: 93, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boGeneralUpgradeBtnClicked' event (evid: 94)
 *
 * Event description: Clicking a button Upgrade Now in BO menu
 *
 * @param {boGeneralUpgradeBtnClickedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} location - From where in the bo the user clicked on upgrade button (menu/upgradeCounter)
 * @property {string} fromTab - email-marketing", "navigation", "settings-counter", "video-library", "video-page", "video-page-embed", "settings-embed
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {string} ctaId - upgrade/contactUs
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boGeneralUpgradeBtnClickedParams>} LogObject<boGeneralUpgradeBtnClickedParams>
 */
export function boGeneralUpgradeBtnClicked(params) {
    return { evid: 94, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boStatsNosStatsDisplay' event (evid: 95)
 *
 * Event description: No stats state display
 *
 * @param {boStatsNosStatsDisplayParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - ADI / editor / МА
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boStatsNosStatsDisplayParams>} LogObject<boStatsNosStatsDisplayParams>
 */
export function boStatsNosStatsDisplay(params) {
    return { evid: 95, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPageError' event (evid: 96)
 *
 * Event description: Showing error state display in video page
 *
 * @param {boVidPageErrorParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {string} source - computer/vimeo/facebook/youtube
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} errorType - No title/Missing trailer
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - ADI / editor / МА
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPageErrorParams>} LogObject<boVidPageErrorParams>
 */
export function boVidPageError(params) {
    return { evid: 96, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boVidPagePriceError' event (evid: 97)
 *
 * Event description: Showing price error state display in video page, default price page and channel info page
 *
 * @param {boVidPagePriceErrorParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} videoID - videoID
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} errorType - Price too high/Price too low
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - ADI / editor / МА
 * @property {string} buyType - subscription/video
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boVidPagePriceErrorParams>} LogObject<boVidPagePriceErrorParams>
 */
export function boVidPagePriceError(params) {
    return { evid: 97, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'boGeneralErrorNotCompleteAction' event (evid: 98)
 *
 * Event description: Error state action not complete
 *
 * @param {boGeneralErrorNotCompleteActionParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - ADI / editor / МА
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<boGeneralErrorNotCompleteActionParams>} LogObject<boGeneralErrorNotCompleteActionParams>
 */
export function boGeneralErrorNotCompleteAction(params) {
    return { evid: 98, src: 71, endpoint: 'video', params: params };
}
/**
 * A function to create a log object for the 'appSetLoaded' event (evid: 99)
 *
 * Event description: The existing appSet.opened (evid=100) event sends when the app starts (aka js inits), this one would send right from the html load
 *
 * @param {appSetLoadedParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {GUID} videoInstanceID - InstanceID
 * @property {GUID} _msid - msid
 * @property {GUID} _appId - app_id
 * @property {string} editorMode - editorMode
 * @property {string} user_agent - user_agent
 * @property {GUID} _instanceId - InstanceID
 * @property {string} _viewMode - view_mode
 * @property {GUID} _siteMemberId - site_member_id
 * @property {string} origin - my_account/editor/ADI
 * @property {string} compId - player_id
 * @property {GUID} _visitorId - visitor_id
 * @return {LogObject<appSetLoadedParams>} LogObject<appSetLoadedParams>
 */
export function appSetLoaded(params) {
    return { evid: 99, src: 71, endpoint: 'video', params: params };
}
//# sourceMappingURL=index.js.map